import { useState, useEffect, useRef, useCallback, useMemo } from "react";
import { httpService } from "../../../../../src/services/httpService";
import AddNewClientAppointment from "./AddNewClientAppointment";
import { RiCloseCircleFill } from "react-icons/ri";
import PetServiceCategoryDrawer from "../../../Orders/PetServiceCategoryDrawer";
import AddNewPet from "../../../Orders/AddNewPet";
import { toast } from "react-toastify";
import {
  FiPhone,
  FiUser,
  FiMail,
  FiMapPin,
  FiEdit3,
  FiCalendar,
  FiSearch,
  FiUserPlus,
  FiPlusCircle,
  FiArrowRightCircle,
  FiTag,
  FiX,
  FiArrowLeft,
  FiCheck,
  FiTrash2,
  FiMinus,
  FiPlus,
  FiAlertCircle,
  FiFileText,
  FiHome,
} from "react-icons/fi";
import {
  MdPets,
  MdLocalHotel,
  MdContentCut,
  MdShoppingCart,
  MdHistory,
  MdSpa,
  MdPayment,
} from "react-icons/md";
import Swal from "sweetalert2";
import {
  FaDirections,
  // FaRuler,
  FaPaw,
  // FaSortNumericUp,
  FaDog,
  // FaClock,
  FaUserTie,
  FaCalendar,
  FaInfoCircle,
  FaCat,
  FaPlus,
} from "react-icons/fa";
import CombinedHistoryDrawer from "../bookingcalendar/CombinedHistoryDrawer";
import EnquiryListDrawer from "../../EnquiryListDrawer";
import EditEnquiry from "../../EditEnquiry";
import SelectAddOnsDrawer from "../../../Orders/SelectAddOnsDrawer";
import TotalsSummary from "../../../common/TotalsSummary";
import ProductCatalog from "../../../../components/common/ProductCatalog";
import OtherChargesDrawer from "../../../../components/common/OtherChargesDrawer";
import OrderPaymentDrawer from "../../../../components/Order/OrderPaymentDrawer";
import { useOrderBoarding } from "../../../../context/OrderBoardingContext";
import LoaderSpiner from "../../../../components/LoaderSpiner/LoaderSpiner";
import { useProfile } from "../../../../context/ProfileContext";
import { markSetupStepCompleteById } from "../../../../utils/vendorSetupSteps";
import { createPortal } from "react-dom";
import { HiArrowSmLeft } from "react-icons/hi";
import AdjustmentAmountCard from "../../../../components/common/AdjustmentAmountCard";
import BookingOrderPopup from "../../../../components/common/BookingOrderTooltip";
import OrderCheckinDrawer from "../../../../components/Order/OrderCheckinDrawer";
import GroomingStartedDrawer from "../../../services/GroomingStartedDrawer";
import VetClinicStartedDrawer from "../../../services/VetClinicStartedDrawer";
import BoardingStartedDrawer from "../../../services/BoardingStartedDrawer";
import OrderCheckoutDrawer from "../../../../components/Order/OrderCheckoutDrawer";

const normalizeBookingData = (data = {}) => ({
  order_id: data.order_id || "",
  booking_id: data.ref_id || data._id || "",
  orderNumber: data.order_number || "",
  status: data.status,
  order_notes: data?.order_notes || "",
  customer: {
    customerId: data.vendor_client_id || "",
    name: `${data.client_first_name || ""} ${data.client_last_name || ""}`.trim(),
    phone: data.phone || "",
    email: data.email || "",
    address: data.address || {},
  },
  pet: {
    pet_id: data.pet_id || "",
    vendor_pet_id: data.vendor_pet_id || "",
    type: data.pet_type || "",
    breed: data.pet_breed || "",
    size: data.pet_size || "",
    age: data.pet_age || "",
    gender: data.pet_gender || "",
    tags: data.pet_tags || [],
    name: data.pet_name || "",
  },
  service: {
    service_id: data.service_id || "",
    service_name: data.service_name || "",
    service_code: data.service_code || "",
    service_category_id: data.service_category_id || "",
    service_category_name: data.service_category_name || "",
    service_type_id: data.service_type_id || "",
    service_type_name: data.service_type_name || "",
    duration: data.duration || "",
    addons: data.addons || [],
    start_date: data.start_date || "",
    start_time: data.start_time || "",
    datetime: data.datetime || "",
    unit_price_with_tax: data.unit_price_with_tax || 0,
    staffId: data.technician_id || "",
    staffName: data.employee_name || "",
    notes: data?.notes || "",
  },
  vendor: {
    vendorId: data.ref_id || "",
    name: data.vendor_name || "",
    companyName: data.vendor_company_name || "",
    brandName: data.vendor_brand_name || "",
    type: data.vendor_type || "",
    address: data.vendor_address || {},
  },
  pricing: {
    price:
      data?.grand_total ||
      (data?.additional_amount || 0) + (data.total_price || 0),
    paidAmount: data.paid_amount || 0,
    waivedAmount: data.waived_amount || 0,
    paymentStatus: data.payment_status || "unpaid",
    total:
      data?.grand_total ||
      (data?.additional_amount || 0) + (data.total_price || 0),
  },
  consent: {
    file: data.consentFile || null,
    uploadedAt: data.consentUploadedAt || null,
    required: true,
  },
  media: {
    before: data.beforeMedia || [],
    after: data.afterMedia || [],
  },
  notes: {
    notes: data.notes || "",
    files: [],
  },
  system: {
    createdAt: data.createdAt || null,
    updatedAt: data.updatedAt || null,
  },
});

const ProductInfoTooltip = ({ product, mrpPrice, effectivePrice }) => {
  const iconRef = useRef(null);
  const [pos, setPos] = useState(null);

  const TOOLTIP_WIDTH = 320;
  const MARGIN = 8;
  const ESTIMATED_HEIGHT = 150;

  const show = () => {
    if (!iconRef.current) return;
    const r = iconRef.current.getBoundingClientRect();
    const iconCenter = r.left + r.width / 2;

    const width = Math.min(TOOLTIP_WIDTH, window.innerWidth - MARGIN * 2);
    let left = iconCenter - width / 2;
    left = Math.max(MARGIN, Math.min(left, window.innerWidth - width - MARGIN));

    const below = r.top < ESTIMATED_HEIGHT + MARGIN * 2;

    setPos({
      left,
      width,
      top: below ? r.bottom + MARGIN : r.top - MARGIN,
      below,
      arrowLeft: iconCenter - left,
    });
  };

  const hide = () => setPos(null);

  return (
    <>
      <span
        ref={iconRef}
        className="inline-flex cursor-help text-gray-500 hover:text-gray-700"
        onMouseEnter={show}
        onMouseLeave={hide}
        onFocus={show}
        onBlur={hide}
        tabIndex={0}
      >
        <FaInfoCircle className="text-sm" />
      </span>

      {pos &&
        createPortal(
          <div
            role="tooltip"
            className="fixed z-[9999] rounded bg-gray-800 px-3 py-2 text-sm text-white shadow-lg pointer-events-none"
            style={{
              left: pos.left,
              top: pos.top,
              width: pos.width,
              transform: pos.below ? "none" : "translateY(-100%)",
            }}
          >
            <div className="whitespace-normal break-words">
              <strong className="block mb-1">Product Details</strong>
              {product.description && <div>{product.description}</div>}
              <div>MRP: ₹{mrpPrice.toFixed(2)}</div>
              <div>Price: ₹{effectivePrice.toFixed(2)}</div>
              <div>GST: {product.gst_slab}%</div>
              {product?.batches?.length > 0 && (
                <div>Batch: {product.batches[0]?.batch_number}</div>
              )}
            </div>
            <div
              className={`absolute border-4 border-transparent ${
                pos.below
                  ? "bottom-full border-b-gray-800"
                  : "top-full border-t-gray-800"
              }`}
              style={{ left: pos.arrowLeft, transform: "translateX(-50%)" }}
            />
          </div>,
          document.body,
        )}
    </>
  );
};

const AddAppointment = ({
  isOpen,
  onClose,
  selectedSlotInfo,
  clearSlotSelection = () => {},
  editMode,
  editingAppointment,
  onSave,
  appointmentStatusRef,
  clientDetails = null,
  saleType = null,
  isPetDetails = false,
  enquiryDetails = null,
  openBookingDetailsDrawer = () => {},
}) => {
  const [showAddClientDrawer, setShowAddClientDrawer] = useState(false);
  const [isEditClientOpen, setIsEditClientOpen] = useState(false);
  const [searchPhone, setSearchPhone] = useState("");
  const [clientData, setClientData] = useState(null);
  const [shouldOpenPetForm, setShouldOpenPetForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [serviceId, setServiceId] = useState(null);
  const [showPetServiceDrawer, setShowPetServiceDrawer] = useState(false);
  const [showAddNewPet, setShowAddNewPet] = useState(false);
  const [itemData, setItemData] = useState([]);
  const [orderItems, setOrderItems] = useState([]);
  const [orderId, setOrderId] = useState(null);
  const [drawerEditMode, setDrawerEditMode] = useState(editMode || false);
  const [clientOrders, setClientOrders] = useState([]);
  const [loadingOrders, setLoadingOrders] = useState(false);
  const [appointmentList, setAppointmentList] = useState([]);
  const [boardingList, setBoardingList] = useState([]);
  const [vetClinicList, setVetClinicList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [preSelectedPetId, setPreSelectedPetId] = useState(null);
  const [totalSummary, setTotalSummary] = useState({
    subtotal: 0,
    // originalSubtotal: 0,
    gst: 0,
    discount: 0,
    total: 0,
    discountAmount: 0,
    discountedGST: 0,
    totalItemDiscount: 0,
    mrpTotal: 0,
    netAmount: 0,
  });
  const [paymentOrderId, setPaymentOrderId] = useState(null);

  const [paymentDetails, setPaymentDetails] = useState({
    paymentType: "", // 'full', 'partial'
    amount: "",
    method: "", // 'cash', 'upi', 'credit', 'cheque', 'bank'
    reference: "",
    notes: "",
  });
  // const [showPaymentSection, setShowPaymentSection] = useState(false);
  const [isPaymentLoading, setIsPaymentLoading] = useState(false);
  const [isBookingLoading, setIsBookingLoading] = useState(false);

  // Coupon and Payment System States
  const [isServiceEditMode, setIsServiceEditMode] = useState(false);
  const [saveDisabled, setSaveDisabled] = useState(false);

  // Booking Details Drawer for the schedule button
  // const [showBookingDetails, setShowBookingDetails] = useState(false);
  // const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [editEnquiryData, setEditEnquiryData] = useState([]);
  const [showEditEnquiryDrawer, setShowEditEnquiryDrawer] = useState(false);

  const [savedEnquiryId, setSavedEnquiryId] = useState(null);
  const [enquiryHardSave, setEnquiryHardSave] = useState(false);

  //Addons States
  const [isAddonsDrawerOpen, setIsAddonsDrawerOpen] = useState(false);
  const [addonsServiceCategoryId, setAddonsServiceCategoryId] = useState(null);
  const [addonsPetType, setAddonsPetType] = useState("Both");
  const [addonsPetTypeId, setAddonsPetTypeId] = useState(null);
  const [selectedAddons, setSelectedAddons] = useState([]);
  const [selectedItemIndex, setSelectedItemIndex] = useState(null);
  const [selectedListType, setSelectedListType] = useState(null); // e.g. "appointmentList", "vetClinicList"
  const [serviceTypeName, setServiceTypeName] = useState("");
  const [enquiryDataLoading, setEnquiryDataLoading] = useState(true);
  const totalSummaryRef = useRef({});

  const [isFromEnquiryList, setIsFromEnquiryList] = useState(false);
  const [isEnquiryLoading, setIsEnquiryLoading] = useState(false);

  // Products Drawer State
  const [isProductsDrawerOpen, setIsProductsDrawerOpen] = useState(false);
  const [productsServiceCategoryId, setProductsServiceCategoryId] =
    useState(null);
  const [selectedProductsItemIndex, setSelectedProductsItemIndex] =
    useState(null);
  const [selectedProductsListType, setSelectedProductsListType] =
    useState(null);

  // Other Charges Drawer State
  const [isOtherChargesDrawerOpen, setIsOtherChargesDrawerOpen] =
    useState(false);
  const [otherCharges, setOtherCharges] = useState([]);
  const [otherChargesSelectedIndex, setOtherChargesSelectedIndex] =
    useState(null);
  const [otherChargesListType, setOtherChargesListType] = useState(null);

  // new
  const [searchResults, setSearchResults] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);
  const [adjustmentAmount, setAdjustmentAmount] = useState(0);
  const [adjustmentReason, setAdjustmentReason] = useState("");
  const [savingAdjustment, setSavingAdjustment] = useState(false);

  // Flow States: Proceed Popup -> Check-in Drawer -> Started Drawer -> Checkout Drawer
  const [proceedPopupData, setProceedPopupData] = useState({
    isOpen: false,
    orderId: null,
    highlightRefId: null,
    isQueue: null,
  });
  const [checkinDrawerOpen, setCheckinDrawerOpen] = useState(false);
  const [selectedCheckinPayload, setSelectedCheckinPayload] = useState(null);
  const isAdvancingFlowRef = useRef(false);
  const isAdvancingToCheckoutRef = useRef(false);

  const [groomingStartedDrawerOpen, setGroomingStartedDrawerOpen] = useState(false);
  const [vetStartedDrawerOpen, setVetStartedDrawerOpen] = useState(false);
  const [boardingStartedDrawerOpen, setBoardingStartedDrawerOpen] = useState(false);
  const [selectedStartedBooking, setSelectedStartedBooking] = useState(null);
  const [selectedStartedRow, setSelectedStartedRow] = useState(null);

  const [checkoutDrawerOpen, setCheckoutDrawerOpen] = useState(false);
  const [checkoutOrderId, setCheckoutOrderId] = useState(null);
  const savedBookingOrderRef = useRef(null);
  const drawerWidth = "lg:w-3/4";

  const finalizeFlowAndClose = () => {
    setProceedPopupData({
      isOpen: false,
      orderId: null,
      highlightRefId: null,
      isQueue: null,
    });
    setCheckinDrawerOpen(false);
    setSelectedCheckinPayload(null);
    setGroomingStartedDrawerOpen(false);
    setVetStartedDrawerOpen(false);
    setBoardingStartedDrawerOpen(false);
    setSelectedStartedBooking(null);
    setSelectedStartedRow(null);
    setCheckoutDrawerOpen(false);
    setCheckoutOrderId(null);
    isAdvancingFlowRef.current = false;
    isAdvancingToCheckoutRef.current = false;

    if (onSave) {
      onSave(savedBookingOrderRef.current);
    }
    if (window.refreshOrderData) window.refreshOrderData();
    if (window.refreshOrdersList) window.refreshOrdersList();
    if (window.refreshAppointmentData) window.refreshAppointmentData();
    if (window.refreshBookingData) window.refreshBookingData();
    if (window.refreshBoardingData) window.refreshBoardingData();
    clearSlotSelection();
    handleClose();
  };

  const handleProceedPopupClose = (reason) => {
    if (reason === "checkin") {
      setProceedPopupData({
        isOpen: false,
        orderId: null,
        highlightRefId: null,
        isQueue: null,
      });
      return;
    }
    finalizeFlowAndClose();
  };

  const handleProceedCheckIn = (checkInPayload) => {
    isAdvancingFlowRef.current = true;
    setProceedPopupData({
      isOpen: false,
      orderId: null,
      highlightRefId: null,
      isQueue: null,
    });
    setSelectedCheckinPayload(checkInPayload);
    setCheckinDrawerOpen(true);
  };

  const handleCheckinDrawerClose = () => {
    setCheckinDrawerOpen(false);
    setSelectedCheckinPayload(null);
    if (isAdvancingFlowRef.current) {
      return;
    }
    finalizeFlowAndClose();
  };

  const handlePostCheckin = async (service_ref_id, type, order_id, row) => {
    isAdvancingFlowRef.current = true;
    setCheckinDrawerOpen(false);

    const activeOrderId =
      order_id ||
      selectedCheckinPayload?.order_id ||
      savedBookingOrderRef.current?._id;

    try {
      const itemType = String(
        type ||
          row?.item_type ||
          row?.type ||
          selectedCheckinPayload?.service_type_name ||
          selectedCheckinPayload?.item_type ||
          "",
      ).toLowerCase();
      const isBoarding =
        itemType.includes("boarding") || itemType.includes("day_care");

      let fetched = row;
      if (!fetched && service_ref_id) {
        try {
          const response = await httpService.get(
            isBoarding
              ? `/vendorbooking/getVendorBooking/${service_ref_id}`
              : `/vendorappointment/getVendorAppointment/${service_ref_id}`,
          );
          fetched = response?.data ?? response;
        } catch (fetchErr) {
          console.error("Error fetching service details by ref_id:", fetchErr);
        }
      }

      // Fallback: If fetched is missing or lacks vendor_pet_id, fetch from order items
      if ((!fetched || !fetched.vendor_pet_id) && activeOrderId) {
        try {
          const orderRes = await httpService.get(
            `/vendororder/getvendororder/${activeOrderId}`
          );
          const orderData = orderRes?.data ?? orderRes;
          const items = Array.isArray(orderData?.order_items)
            ? orderData.order_items
            : [];
          const matched =
            items.find((i) => String(i?.ref_id) === String(service_ref_id)) ||
            items[0];
          if (matched) {
            fetched = {
              ...(fetched || {}),
              ...matched,
              order_id: activeOrderId,
              client_first_name:
                orderData?.client?.client_first_name ||
                fetched?.client_first_name ||
                "",
              client_last_name:
                orderData?.client?.client_last_name ||
                fetched?.client_last_name ||
                "",
              phone: orderData?.client?.phone || fetched?.phone || "",
              email: orderData?.client?.email || fetched?.email || "",
              vendor_client_id:
                orderData?.client?.client_id ||
                fetched?.vendor_client_id ||
                "",
            };
          }
        } catch (err) {
          console.error("Error fetching fallback order item:", err);
        }
      }

      const targetRefId =
        service_ref_id ||
        fetched?.ref_id ||
        fetched?._id ||
        selectedCheckinPayload?.ref_id;

      const updatedBooking = {
        ...(fetched || {}),
        ref_id: targetRefId,
        service_ref_id: targetRefId,
        booking_id: targetRefId,
        order_id:
          fetched?.order_id ||
          fetched?.orderId ||
          activeOrderId ||
          "",
        vendor_pet_id:
          fetched?.vendor_pet_id ||
          fetched?.pet_id ||
          selectedCheckinPayload?.vendor_pet_id ||
          "",
      };

      setGroomingStartedDrawerOpen(false);
      setVetStartedDrawerOpen(false);
      setBoardingStartedDrawerOpen(false);

      const normalizedBooking = normalizeBookingData(updatedBooking);

      if (isBoarding) {
        setSelectedStartedBooking({
          ...normalizedBooking,
          booking_id: targetRefId,
          order_id: updatedBooking.order_id,
          status: updatedBooking?.status || "started",
        });
        setSelectedStartedRow(updatedBooking);
        setBoardingStartedDrawerOpen(true);
        return;
      }

      setSelectedStartedBooking(normalizedBooking);
      setSelectedStartedRow(updatedBooking);

      if (itemType.includes("vet")) {
        setVetStartedDrawerOpen(true);
      } else {
        setGroomingStartedDrawerOpen(true);
      }
    } catch (error) {
      console.error("Error opening started drawer after check-in:", error);
      setCheckoutOrderId(activeOrderId);
      setCheckoutDrawerOpen(true);
    }
  };

  const handleCloseStartedDrawer = () => {
    setGroomingStartedDrawerOpen(false);
    setVetStartedDrawerOpen(false);
    setBoardingStartedDrawerOpen(false);
    setSelectedStartedBooking(null);
    setSelectedStartedRow(null);

    setTimeout(() => {
      if (!isAdvancingToCheckoutRef.current) {
        finalizeFlowAndClose();
      }
    }, 250);
  };

  const handleOpenCheckoutDrawer = (orderId) => {
    isAdvancingToCheckoutRef.current = true;
    setGroomingStartedDrawerOpen(false);
    setVetStartedDrawerOpen(false);
    setBoardingStartedDrawerOpen(false);
    setSelectedStartedBooking(null);
    setSelectedStartedRow(null);

    const targetOrderId =
      orderId ||
      savedBookingOrderRef.current?._id ||
      selectedCheckinPayload?.order_id ||
      checkoutOrderId;

    setCheckoutOrderId(targetOrderId);
    setCheckoutDrawerOpen(true);
  };

  const handleCheckoutDrawerClose = () => {
    isAdvancingToCheckoutRef.current = false;
    setCheckoutDrawerOpen(false);
    setCheckoutOrderId(null);
    finalizeFlowAndClose();
  };

  const [saveEnquiryClicked, setSaveEnquiryClicked] = useState(null);
  const [saleTypeValue, setSaleTypeValue] = useState(saleType);
  useEffect(() => {
    setSaleTypeValue(saleType);
  }, [saleType]);

  const normalizeText = (value = "") =>
    String(value).toLowerCase().replace(/\s+/g, "").trim();

  const getPetVaccinationSource = (petId) => {
    const normalizedPetId = String(petId || "");
    const fromClientPets = Array.isArray(clientData?.pets)
      ? clientData.pets.find(
          (pet) =>
            String(
              pet?._id || pet?.id || pet?.vendor_pet_id || pet?.pet_id || "",
            ) === normalizedPetId,
        )
      : null;
    const fromClientDetails = Array.isArray(clientDetails?.pet_details)
      ? clientDetails.pet_details.find(
          (pet) =>
            String(
              pet?._id || pet?.id || pet?.vendor_pet_id || pet?.pet_id || "",
            ) === normalizedPetId,
        )
      : null;
    return fromClientPets || fromClientDetails || null;
  };

  const hasVaccinationForPet = (petId) => {
    const pet = getPetVaccinationSource(petId);
    const vaccinations = Array.isArray(pet?.vaccinations)
      ? pet.vaccinations
      : Array.isArray(pet?.vaccinated_for)
      ? pet.vaccinated_for
      : [];
    const records = Array.isArray(pet?.vaccination_records)
      ? pet.vaccination_records
      : [];
    const statusText = (
      pet?.vaccination_status ||
      pet?.vaccinationStatus ||
      ""
    ).toLowerCase();
    const rabiesRegex = /rabies/i;

    // Check if any vaccination entry (string or object) contains "rabies"
    const hasRabiesInVaccinations = vaccinations.some((item) => {
      const name =
        item?.name || item?.vaccine || item?.vaccination || item || "";
      return rabiesRegex.test(typeof name === "string" ? name : JSON.stringify(name));
    });

    // Check if any record's vaccine name contains "rabies" (date is irrelevant)
    const hasRabiesInRecords = records.some((rec) => {
      const name =
        rec?.vaccine ||
        rec?.vaccination ||
        rec?.name ||
        rec?.vaccine_name ||
        "";
      return rabiesRegex.test(typeof name === "string" ? name : JSON.stringify(name));
    });

    return (
      hasRabiesInVaccinations ||
      hasRabiesInRecords ||
      rabiesRegex.test(statusText)
    );
  };

  const getVaccinationSetting = () =>
    profileData?.systemSettings?.vaccination_requirement ||
    profileData?.vaccination_requirement ||
    null;

  const normalizeServiceName = (value) =>
    String(value || "").trim().toLowerCase();

  const serviceMatches = (settingName, currentServiceName) => {
    const setting = normalizeServiceName(settingName);
    const current = normalizeServiceName(currentServiceName);
    if (!setting || !current) return false;
    return (
      setting === current ||
      setting.includes(current) ||
      current.includes(setting)
    );
  };

  const isVaccinationRequiredForService = (item, defaultType = "") => {
    const vaccineSetting = getVaccinationSetting();
    if (!vaccineSetting || vaccineSetting.enabled !== true) return false;
    if (
      !Array.isArray(vaccineSetting.services) ||
      vaccineSetting.services.length === 0
    ) {
      return true;
    }
    const candidates = [
      item?.service_type_name,
      item?.service_category_name,
      item?.category_name,
      item?.service_name,
      item?.item_type,
      defaultType,
    ].filter(Boolean);

    return candidates.some((candidate) =>
      vaccineSetting.services.some((s) => {
        const name = s?.name || s?.type || s;
        return serviceMatches(name, candidate);
      })
    );
  };

  const renderFormAttachment = (item) => {
    const formNames =
      (Array.isArray(item?.form_names) && item.form_names.join(", ")) ||
      item?.form_name ||
      "";

    if (!formNames) return null;

    const className = `text-sm mt-1 ${
      item?.form_has_mandatory ? "text-red-500" : "text-teal-700"
    }`;

    return <p className={className}>Forms: {formNames}</p>;
  };

  const dropdownRef = useRef(null);

  const { syncBoardingItems } = useOrderBoarding();
  const { vendorId, profileData } = useProfile();

  const handlePaymentSuccess = (responseData) => {
    toast.success("Payment recorded successfully!");
    if (onSave) onSave(responseData);

    handleClose();
  };
  const triggerConfirmedNotifications = async (orderId) => {
    if (!orderId) return;
    try {
      const res = await httpService.post(
        `/vendororder/send-confirmed-notifications/${orderId}`,
      );
      if (res?.status) {
        // Optional: silent success, or toast if you want visibility
        // toast.success(res?.message || "Notification sent.");
        console.log("Confirmed notification dispatched:", res?.data);
      }
    } catch (err) {
      // Don't block the user flow — just log
      console.error("Failed to trigger confirmed notifications:", err);
    }
  };

  const handleOpenProductsDrawer = (item, index, listType) => {
    setProductsServiceCategoryId(
      item.service_category_type_id || item.service_type_id,
    );
    setSelectedProductsItemIndex(index);
    setSelectedProductsListType(listType);
    setIsProductsDrawerOpen(true);
    setServiceTypeName(item.service_type_name);
  };

  const handleCloseProductsDrawer = () => {
    setIsProductsDrawerOpen(false);
    setSelectedProductsItemIndex(null);
    setSelectedProductsListType(null);
  };

  const handleSaveProducts = (updatedProducts) => {
    setIsProductsDrawerOpen(false);
    if (selectedProductsItemIndex === null || !selectedProductsListType) return;

    const formattedProducts = updatedProducts.map((product) => {
      // Get values from product (using the correct field names from ProductCatalog)
      const effectivePrice = Number(product.sale_price_after_discount || product.effective_sale_price || product.price || 0);
      const mrpPrice = Number(product.mrp || product.mrp_price || product.sale_price || 0);
      const gstSlab = Number(product.gst_slab || product.tax_percentage || 0);
      const quantity = Number(product.quantity || 1);
      
      // ✅ CRITICAL: Calculate price without tax
      let priceWithoutTax = effectivePrice;
      let gstAmount = 0;
      
      if (gstSlab > 0 && effectivePrice > 0) {
        // priceWithoutTax = effectivePrice / (1 + gstSlab/100)
        priceWithoutTax = effectivePrice / (1 + gstSlab / 100);
        gstAmount = effectivePrice - priceWithoutTax;
      }
      
      return {
        // Preserve all original product data first
        ...product,

        // Core identifiers — these must come AFTER the spread to win
        product_id: product.id || product._id,
        product_name: product.name,

        // Quantity
        quantity: quantity,

        // ✅ CRITICAL: These fields MUST be correct
        unit_price: roundToTwo(effectivePrice),
        price: roundToTwo(priceWithoutTax),
        mrp_price: roundToTwo(mrpPrice),
        sale_price: roundToTwo(mrpPrice),
        total_price: roundToTwo(effectivePrice * quantity),
        
        // GST fields
        gst: roundToTwo(gstAmount),
        gstAmount: roundToTwo(gstAmount),
        gstAmountAfterDiscount: roundToTwo(gstAmount),
        tax_percentage: gstSlab,
        tax_amount: roundToTwo(gstAmount),
        
        // Amount breakdowns
        amount_without_tax: roundToTwo(priceWithoutTax),
        amount_with_tax: roundToTwo(effectivePrice),
        amount_before_discount: roundToTwo(mrpPrice),
        amount_after_discount: roundToTwo(effectivePrice),
        
        // Additional fields
        description: product.description || "",
        sku_number: product.sku_number || "",
        gst_slab: gstSlab,
      };
    });

    const mergeProducts = (existing = [], newProducts) => {
      const merged = [...existing];
      newProducts.forEach((newItem) => {
        const idx = merged.findIndex(
          (item) => item.product_id === newItem.product_id,
        );
        if (idx !== -1) {
          merged[idx] = {
            ...merged[idx],
            quantity: (merged[idx].quantity || 0) + (newItem.quantity || 1),
            total_price:
              (newItem.unit_price || 0) *
              (merged[idx].quantity + newItem.quantity),
          };
        } else {
          merged.push(newItem);
        }
      });
      return merged;
    };

    switch (selectedProductsListType) {
      case "appointmentList":
        setAppointmentList((prev) => {
          const updated = [...prev];
          updated[selectedProductsItemIndex].products = mergeProducts(
            updated[selectedProductsItemIndex].products,
            formattedProducts,
          );
          return updated;
        });
        break;
      case "boardingList":
        setBoardingList((prev) => {
          const updated = [...prev];
          updated[selectedProductsItemIndex].products = mergeProducts(
            updated[selectedProductsItemIndex].products,
            formattedProducts,
          );
          return updated;
        });
        break;
      case "vetClinicList":
        setVetClinicList((prev) => {
          const updated = [...prev];
          updated[selectedProductsItemIndex].products = mergeProducts(
            updated[selectedProductsItemIndex].products,
            formattedProducts,
          );
          return updated;
        });
        break;
      default:
        break;
    }
  };
  const handleOpenOtherChargesDrawer = (item, index, listType) => {
    setOtherChargesSelectedIndex(index);
    setOtherChargesListType(listType);
    setOtherCharges(item.otherCharges || []);
    setIsOtherChargesDrawerOpen(true);
  };

  const handleCloseOtherChargesDrawer = () => {
    setIsOtherChargesDrawerOpen(false);
    setOtherChargesSelectedIndex(null);
    setOtherChargesListType(null);
    setOtherCharges([]);
  };

  const handleSaveOtherCharges = (updatedCharges) => {
    setIsOtherChargesDrawerOpen(false);
    if (otherChargesSelectedIndex === null || !otherChargesListType) return;

    switch (otherChargesListType) {
      case "appointmentList":
        setAppointmentList((prev) => {
          const updated = [...prev];
          updated[otherChargesSelectedIndex].otherCharges = updatedCharges;
          return updated;
        });
        break;
      case "boardingList":
        setBoardingList((prev) => {
          const updated = [...prev];
          updated[otherChargesSelectedIndex].otherCharges = updatedCharges;
          return updated;
        });
        break;
      case "vetClinicList":
        setVetClinicList((prev) => {
          const updated = [...prev];
          updated[otherChargesSelectedIndex].otherCharges = updatedCharges;
          return updated;
        });
        break;
      default:
        break;
    }
  };
  // Delete an addon
  const handleDeleteAddon = (listType, listIndex, addonIndex) => {
    const updater = (prev) => {
      const updated = [...prev];
      updated[listIndex].addons = updated[listIndex].addons.filter(
        (_, i) => i !== addonIndex,
      );
      return updated;
    };
    switch (listType) {
      case "appointmentList":
        setAppointmentList(updater);
        break;
      case "boardingList":
        setBoardingList(updater);
        break;
      case "vetClinicList":
        setVetClinicList(updater);
        break;
    }
  };

  // Delete a product
  const handleDeleteProduct = (listType, listIndex, productIndex) => {
    const updater = (prev) => {
      const updated = [...prev];
      updated[listIndex].products.splice(productIndex, 1);
      return updated;
    };
    switch (listType) {
      case "appointmentList":
        setAppointmentList(updater);
        break;
      case "boardingList":
        setBoardingList(updater);
        break;
      case "vetClinicList":
        setVetClinicList(updater);
        break;
    }
  };

  // Decrement product quantity
  const handleDecrementProduct = (listType, listIndex, productIndex) => {
    const updater = (prev) => {
      const updated = [...prev];
      const product = updated[listIndex].products[productIndex];
      if (product.quantity > 1) {
        updated[listIndex].products[productIndex] = {
          ...product,
          quantity: product.quantity - 1,
        };
      } else {
        updated[listIndex].products.splice(productIndex, 1);
      }
      return updated;
    };
    switch (listType) {
      case "appointmentList":
        setAppointmentList(updater);
        break;
      case "boardingList":
        setBoardingList(updater);
        break;
      case "vetClinicList":
        setVetClinicList(updater);
        break;
    }
  };
  // Increment product quantity
  const handleIncrementProduct = (listType, listIndex, productIndex) => {
    const updater = (prev) => {
      const updated = [...prev];
      const product = updated[listIndex].products[productIndex];

      updated[listIndex].products[productIndex] = {
        ...product,
        quantity: product.quantity + 1,
      };

      return updated;
    };

    switch (listType) {
      case "appointmentList":
        setAppointmentList(updater);
        break;
      case "boardingList":
        setBoardingList(updater);
        break;
      case "vetClinicList":
        setVetClinicList(updater);
        break;
    }
  };

  // Delete an other charge
  const handleDeleteOtherCharge = (listType, listIndex, chargeIndex) => {
    const updater = (prev) => {
      const updated = [...prev];
      updated[listIndex].otherCharges.splice(chargeIndex, 1);
      return updated;
    };
    switch (listType) {
      case "appointmentList":
        setAppointmentList(updater);
        break;
      case "boardingList":
        setBoardingList(updater);
        break;
      case "vetClinicList":
        setVetClinicList(updater);
        break;
    }
  };

  /**
   * Check if an employee is double-booked at the same time within the same order
   * @param {Array} appointments - List of appointments in current order
   * @param {Object} newAppointment - The appointment being added/edited
   * @param {number} editIndex - Index of appointment being edited (-1 for new)
   * @returns {Object} { isValid: boolean, conflictMessage: string }
   */
  const checkEmployeeDoubleBooking = (
    appointments,
    newAppointment,
    editIndex = -1,
  ) => {
    // Skip validation for boarding/daycare
    if (
      newAppointment.item_type?.toLowerCase() === "boarding" ||
      newAppointment.item_type?.toLowerCase() === "day_care"
    ) {
      return { isValid: true, conflictMessage: "" };
    }

    // Skip if no employee selected
    if (!newAppointment.technician_id) {
      return { isValid: true, conflictMessage: "" };
    }

    // Skip if no date/time selected
    if (!newAppointment.start_date || !newAppointment.start_time) {
      return { isValid: true, conflictMessage: "" };
    }

    // Check for conflicts
    for (let i = 0; i < appointments.length; i++) {
      const existing = appointments[i];

      if (editIndex === i) continue;

      if (
        existing.item_type?.toLowerCase() === "boarding" ||
        existing.item_type?.toLowerCase() === "day_care"
      ) {
        continue;
      }

      if (!existing.technician_id) continue;

      if (
        existing.technician_id === newAppointment.technician_id &&
        existing.start_date === newAppointment.start_date &&
        existing.start_time === newAppointment.start_time
      ) {
        return {
          isValid: false,
          conflictMessage: `${existing.employee_name || "Employee"} is already booked at ${existing.start_time} on ${existing.start_date} for ${existing.pet_name}`,
        };
      }
    }

    return { isValid: true, conflictMessage: "" };
  };

  const handleOpenAddonsDrawer = (item, index, listType) => {
    setAddonsServiceCategoryId(
      item.service_category_type_id || item.service_type_id,
    );
    setAddonsPetType(item.pet_type);
    setAddonsPetTypeId(item.pet_type_id);
    setSelectedAddons(item.addons || []);
    setSelectedItemIndex(index);
    setSelectedListType(listType);
    setIsAddonsDrawerOpen(true);
    setServiceTypeName(item.service_type_name);
  };

  const handleCloseAddons = () => {
    setIsAddonsDrawerOpen(false);
  };
  const handleSaveAddons = (updatedAddons) => {
    setIsAddonsDrawerOpen(false);
    if (!updatedAddons || selectedItemIndex === null || !selectedListType)
      return;

    switch (selectedListType) {
      case "appointmentList":
        setAppointmentList((prev) => {
          const updated = [...prev];
          updated[selectedItemIndex].addons = updatedAddons;
          return updated;
        });
        break;

      case "vetClinicList":
        setVetClinicList((prev) => {
          const updated = [...prev];
          updated[selectedItemIndex].addons = updatedAddons;
          return updated;
        });
        break;

      case "boardingList":
        setBoardingList((prev) => {
          const updated = [...prev];
          updated[selectedItemIndex].addons = updatedAddons;
          return updated;
        });
        break;

      default:
        break;
    }
  };

  // schedule drawer open close drawer functions
  // const handleOpenScheduleDetails = (orderId) => {
  //   setSelectedOrderId(orderId);
  //   setShowBookingDetails(true);
  // };

  // const handleCloseScheduleDetails = () => {
  //   setShowBookingDetails(false);
  //   setSelectedOrderId(null);
  // };

  useEffect(() => {
    if (enquiryDetails && clientData !== null) {
      setSavedEnquiryId(enquiryDetails?._id);
      fetchDiscountData([
        ...enquiryDetails?.appointmentList,
        ...enquiryDetails?.boardingList,
        ...enquiryDetails?.vetClinicList,
      ]);
    }
  }, [enquiryDetails, isOpen, clientData]);
  useEffect(() => {
    if (selectedSlotInfo !== null && clientData !== null) {
      if (clientData?.isActive === false) {
        toast.error("Cannot book for a disabled client.");
        return;
      }
      // For vet calendar, ensure itemData has correct service type before opening
      if (saleType === "vet") {
        setItemData((prev) => ({
          ...prev,
          item_type: "vet_clinic",
          service_type_name: "Pet Vet Clinic",
        }));
      }
      setShowPetServiceDrawer(true);
    }
  }, [clientData, selectedSlotInfo, saleType]);

  // Sync drawerEditMode with editMode prop
  useEffect(() => {
    setDrawerEditMode(editMode || false);
  }, [editMode]);
  const [showHistoryDrawer, setShowHistoryDrawer] = useState(false);
  const [showEnquiryDrawer, setShowEnquiryDrawer] = useState(false);
  const [showEnquiryDraweronCancel, setShowEnquiryDraweronCancel] =
    useState(false);
  const [enquiryData, setEnquiryData] = useState([]);

  const currentEditingEnquiryId =
    savedEnquiryId || enquiryDetails?._id || enquiryDetails?.id;

  const displayedEnquiries = useMemo(() => {
    if (!enquiryData || !Array.isArray(enquiryData)) return [];
    if (!currentEditingEnquiryId) return enquiryData;
    return enquiryData.filter(
      (enquiry) =>
        String(enquiry?._id) !== String(currentEditingEnquiryId) &&
        String(enquiry?.id) !== String(currentEditingEnquiryId)
    );
  }, [enquiryData, currentEditingEnquiryId]);
  const [loadingEnquiries, setLoadingEnquiries] = useState(false);
  const [expandedEnquiry, setExpandedEnquiry] = useState(null);
  const [showEnquiryPaymentSection, setShowEnquiryPaymentSection] =
    useState(false);
  const [selectedEnquiryForPayment, setSelectedEnquiryForPayment] =
    useState(null);
  const [existingPaidAmount, setExistingPaidAmount] = useState(0);
  const [notes, setNotes] = useState("");

  const [liveCalculation, setLiveCalculation] = useState(null);
  const [preDiscountGross, setPreDiscountGross] = useState(0);
  const [postDiscountSubtotal, setPostDiscountSubtotal] = useState(0);
  const [postDiscountGst, setPostDiscountGst] = useState(0);

  // const [discount, setDiscount] = useState({
  //   type: "percentage", // percentage | fixed
  //   value: 0,
  //   amount: 0,
  // });

  // useEffect(() => {
    // let calcValue = discount.value;

    // Calculate discount amount
    // const calcAmount = (totalSummary.subtotal * calcValue) / 100;

    // setDiscount((prev) => ({ ...prev, amount: calcAmount }));
  // }, [totalSummary.subtotal]);

  //directly set client if client details are passed
  useEffect(() => {
    if (clientDetails && clientDetails?.phone) {
      setSearchPhone(clientDetails.phone);
    }
  }, [clientDetails]);
  useEffect(() => {
    if (isOpen) {
      // setDiscount({
      //   type: "percentage", // percentage | fixed
      //   value: 0,
      //   amount: 0,
      // });
      setNotes("");
      setEnquiryHardSave(false);
      setSavedEnquiryId(null);
      setPaymentOrderId(null);
      setAdjustmentAmount(0);
      setAdjustmentReason("");
    }
  }, [isOpen]);
  
  const saveAdjustmentToOrder = async (orderId, amount) => {
    if (!orderId) return;
    // Skip if zero / empty
    const numericAmount = parseFloat(amount) || 0;
    if (numericAmount <= 0) return;

    try {
      setSavingAdjustment(true);
      const res = await httpService.post("/orderpayment/saveOrderAdjustment", {
        order_id: orderId,
        adjustment_amount: numericAmount,
        adjustment_reason: adjustmentReason,
      });
      if (!res?.status) {
        throw new Error(res?.message || "Adjustment API failed");
      }
      toast.success("Adjustment amount saved!", { position: "top-center" });
    } catch (err) {
      console.error("Failed to save adjustment amount:", err);
      toast.error("Booking saved, but adjustment amount could not be saved.", {
        position: "top-center",
      });
    } finally {
      setSavingAdjustment(false);
    }
  };

  // new Useeffect
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Initialize data when in edit mode
  useEffect(() => {
    if (editMode && editingAppointment && isOpen) {
      // Pre-populate client data if available
      if (editingAppointment?.client || editingAppointment?.phone) {
        setSearchPhone(editingAppointment?.phone || "");

        // If we have client data, set it up
        if (editingAppointment?.client) {
          setClientData({
            firstname: editingAppointment?.client.split(" ")[0] || "",
            lastname: editingAppointment?.client.split(" ")[1] || "",
            phone: editingAppointment?.phone || "",
            email: editingAppointment?.email || "",
            address: {
              address1: editingAppointment?.address || "",
              address2: "",
              city: "",
              state: "",
              zip: "",
            },
          });
        }
      }

      // Set serviceId if available in appointment data
      if (editingAppointment?.service_id) {
        setServiceId(editingAppointment?.service_id);
      }

      // Pre-populate existing order items if available
      if (editingAppointment?.items) {
        setOrderItems(editingAppointment?.items);
        setAppointmentList(editingAppointment?.items);
        setAppointmentList(
          editingAppointment?.items?.map((item) => ({
            ...item,
            order_id: editingAppointment._id, // or a default value like item.id or item.order_id if it exists
          })),
        );
      }

      // Pass entire appointment data to itemData for service drawer prefilling
      // Include order_id if available
      setItemData({
        ...editingAppointment,
        order_id: editingAppointment?.order_id || editingAppointment?.orderId,
      });

      // Set orderId state if available
      if (editingAppointment?.order_id || editingAppointment?.orderId) {
        setOrderId(editingAppointment?.order_id || editingAppointment?.orderId);
      }

      // Auto-open the Pet & Service drawer when editing existing appointment
      setShowPetServiceDrawer(true);
    }
  }, [editMode, editingAppointment, isOpen]);

  useEffect(() => {
    if (clientDetails && clientDetails?.phone) {
      fetchClientByPhone(clientDetails.phone);

      // If we have pre-selected pet details, set them up immediately
      if (clientDetails.pet_details && clientDetails.pet_details.length > 0) {
        const selectedPet = clientDetails.pet_details.find(
          (pet) => pet._selected,
        );
        if (selectedPet) {
          // You might want to set some state here to indicate which pet is pre-selected
          setPreSelectedPetId(selectedPet._id);
        }
      }
    }
  }, [clientDetails]);

  // Initialize data when opened from BoardingHistoryDrawer (reorder functionality)
  useEffect(() => {
    if (!editMode && editingAppointment && isOpen && editingAppointment.type) {
      // Set client data from the booking history
      if (editingAppointment.vendor_client || editingAppointment.client) {
        setClientData(
          editingAppointment.vendor_client || editingAppointment.client,
        );
      }

      // Pass the booking data to itemData for service drawer prefilling
      setItemData({
        ...editingAppointment,
        _fromHistoryReorder: true,
      });
      // Don't auto-open the Pet & Service drawer - let user manually click to add services
    }
  }, [editMode, editingAppointment, isOpen]);

  // Handle selectedSlotInfo for new appointments from calendar drag
  useEffect(() => {
    if (
      isOpen &&
      !editMode &&
      selectedSlotInfo &&
      (selectedSlotInfo.startDate || selectedSlotInfo.endDate)
    ) {
      setItemData((prev) => ({
        ...prev,
        start_date: selectedSlotInfo.startDate,
        end_date: selectedSlotInfo.endDate,
        roomtype_id: selectedSlotInfo.roomTypeId, // ✅ Will now have value
        room_id: selectedSlotInfo.bedId,
        roomId: selectedSlotInfo.bedId,
        bedId: selectedSlotInfo.bedId,
        roomTypeName: selectedSlotInfo.roomTypeName || prev?.roomTypeName,
        roomNumber: selectedSlotInfo.roomNumber || prev?.roomNumber,
        fromDrag: selectedSlotInfo.fromDrag || false,
        item_type:
          saleType === "vet" ? "vet_clinic" : prev?.item_type || "grooming",
        service_type_name:
          saleType === "vet" ? "Pet Vet Clinic" : prev?.service_type_name,
      }));
    }
  }, [isOpen, editMode, selectedSlotInfo, saleType]);

  useEffect(() => {
    if (serviceId) {
      handleServiceData(serviceId);
      setServiceId(serviceId);
    }
  }, [serviceId]);

  const isUpdatingFromApiRef = useRef(false);

  // Helper function to round to 2 decimal places
  const roundToTwo = (num) => {
    if (num === null || num === undefined || isNaN(num)) return 0;
    return Math.round((parseFloat(num) + Number.EPSILON) * 100) / 100;
  };

  // const fetchLiveCalculation = useCallback(async (cartItems, dType, dValue) => {
  //   if (!cartItems || cartItems.length === 0) {
  //     setLiveCalculation(null);
  //     setPostDiscountSubtotal(0);
  //     setPostDiscountGst(0);
  //     setPreDiscountGross(0);
  //     return;
  //   }

  //   if (isUpdatingFromApiRef.current) {
  //     return;
  //   }

  //   try {
  //     const payload = {
  //       items: cartItems.map((item) => ({
  //         unit_price: Number(item.unit_price || 0),
  //         qty: Number(item.quantity || 1),
  //         gst_slab: Number(item.tax_percentage || 0),
  //       })),
  //       discount_type: dType,
  //       discount_value: Number(dValue || 0),
  //     };

  //     const res = await httpService.post(
  //       "/vendororder/calculatePOSTotals",
  //       payload,
  //     );

  //     if (res?.status) {
  //       setLiveCalculation(res.data);
  //       setPreDiscountGross(res.data.gross_total);
  //       setPostDiscountSubtotal(res.data.amount_without_tax);
  //       setPostDiscountGst(res.data.total_gst);

  //       isUpdatingFromApiRef.current = true;

  //       setProductList((prev) =>
  //         prev.map((product, idx) => {
  //           const calculatedItem = res.data.items[idx];
  //           if (calculatedItem) {
  //             return {
  //               ...product,
  //               amount_without_tax: calculatedItem.amount_without_tax,
  //               gstAmount: calculatedItem.gst_amount,
  //               gst: calculatedItem.gst_amount,
  //               tax_amount: calculatedItem.gst_amount,
  //               total_price: calculatedItem.discounted_total,
  //             };
  //           }
  //           return product;
  //         }),
  //       );
  //       const summary = {
  //         subtotal: res.data.amount_without_tax.toFixed(2),
  //         originalSubtotal: res.data.gross_total.toFixed(2),
  //         gst: res.data.total_gst.toFixed(2),
  //         discount: res.data.discount_amount.toFixed(2),
  //         total: res.data.final_total.toFixed(2),
  //         discountAmount: res.data.discount_amount,
  //         discountedGST: res.data.total_gst,
  //         totalItemDiscount: 0,
  //       };

  //       setTotalSummary(summary);
  //       totalSummaryRef.current = summary;

  //       setTimeout(() => {
  //         isUpdatingFromApiRef.current = false;
  //       }, 100);
  //     }
  //   } catch (err) {
  //     console.error("Error fetching live calculation:", err);
  //   }
  // }, []);

  useEffect(() => {
    // const isProductOnlyOrder =
    //   appointmentList?.length === 0 &&
    //   boardingList?.length === 0 &&
    //   vetClinicList?.length === 0 &&
    //   productList?.length > 0;

    // if (isProductOnlyOrder) {
    //   if (isUpdatingFromApiRef.current) {
    //     return;
    //   }

    //   const timer = setTimeout(() => {
    //     fetchLiveCalculation(productList, discount.type, discount.value);
    //   }, 500);

    //   return () => clearTimeout(timer);
    // } else {
      calculateTotals();
    // }
  // }, [productList, discount.type, discount.value, fetchLiveCalculation]);
  // }, [productList, discount.type, discount.value]);
  }, [productList]);

  // Fetch enquiry data whenever the selected client changes so the inline enquiry card can render immediately.
  useEffect(() => {
    if (clientData?._id) {
      fetchEnquiryData();
    }
  }, [clientData?._id]);

  useEffect(() => {
    if (
      appointmentList?.length > 0 ||
      boardingList?.length > 0 ||
      vetClinicList?.length > 0 ||
      productList?.length > 0
    ) {
      calculateTotals();
    }
  }, [
    appointmentList,
    boardingList,
    vetClinicList,
    productList,
    // discount.value,
    // discount.type,
  ]);
  useEffect(() => {
    // Check if there are any items to auto‑save
    if (
      appointmentList?.length > 0 ||
      boardingList?.length > 0 ||
      vetClinicList?.length > 0 ||
      productList?.length > 0
    ) {
      setSaleTypeValue(null);
      const timer = setTimeout(() => {
        handleBookingAPI(1);
        if(saveEnquiryClicked) {
          setSaveEnquiryClicked(false);
          handleClose();
        }
      }, 600); // 👈 Debounce to avoid rapid calls
      return () => clearTimeout(timer);
    }
  }, [appointmentList, boardingList, vetClinicList, productList, saveEnquiryClicked]);
  useEffect(() => {
    // Convert boardingList items to have a unique _localIndex (use array index)
    const itemsWithIndex = boardingList?.map((item, idx) => ({
      ...item,
      _localIndex: item._localIndex ?? idx, // preserve existing or use index
    }));
    syncBoardingItems(itemsWithIndex);
  }, [boardingList]);

  // Fetch client by phone
  const fetchClientByPhone = async (phone) => {
    if (phone.length !== 10) return;

    setLoading(true);
    setError(null);
    try {
      const response = await httpService.get(`/vendorclient/search/${phone}`);
      const client = response.data || null;
      setClientData(client);

      // Fetch client orders if client found
      if (client?._id) {
        await fetchClientOrders(client._id);
      }
    } catch (err) {
      setError("Client not found or error fetching data.");
      setClientData(null);
      setClientOrders([]);
    } finally {
      setLoading(false);
    }
  };

  /// new api
  const searchClientsByPhone = async (phone) => {
    if (phone.length < 3) {
      setSearchResults([]);
      setShowDropdown(false);
      return;
    }
    setSearchLoading(true);
    try {
      const response = await httpService.get(
        `/vendorclient/searchclients/${phone}`,
      );
      const results = response.data || [];
      setSearchResults(results);
      setShowDropdown(results.length > 0);
    } catch (err) {
      setSearchResults([]);
      setShowDropdown(false);
    } finally {
      setSearchLoading(false);
    }
  };

  const handleSelectClient = (client) => {
    setClientData(client);
    setSearchPhone(client.phone);
    setShowDropdown(false);
    setSearchResults([]);
    setError(null);
    if (client._id) fetchClientOrders(client._id);
  };

  // Fetch client orders
  const fetchClientOrders = async (clientId) => {
    setLoadingOrders(true);
    try {
      const response = await httpService.get(
        `/vendororder/getVendorClientOrders/${clientId}`,
      );
      setClientOrders(response.data || []);
    } catch (err) {
      console.error("Error fetching client orders:", err);
      setClientOrders([]);
    } finally {
      setLoadingOrders(false);
    }
  };

  function handleClose() {
    if (showEnquiryDraweronCancel) {
      setShowEnquiryDrawer(true);
      setShowEnquiryDraweronCancel(false);
      clearSlotSelection();
      setOrderItems([]);
      setOrderId(null);
      syncBoardingItems([]);
      totalSummaryRef.current = {};
      setSavedEnquiryId(null);
      setIsFromEnquiryList(false);
      return;
    }
    resetForm();
    clearSlotSelection();
    onClose();
    setOrderItems([]);
    setOrderId(null);
    syncBoardingItems([]);
    totalSummaryRef.current = {};
    setProceedPopupData({
      isOpen: false,
      orderId: null,
      highlightRefId: null,
      isQueue: null,
    });
    setCheckinDrawerOpen(false);
    setSelectedCheckinPayload(null);
    setGroomingStartedDrawerOpen(false);
    setVetStartedDrawerOpen(false);
    setBoardingStartedDrawerOpen(false);
    setSelectedStartedBooking(null);
    setSelectedStartedRow(null);
    setCheckoutDrawerOpen(false);
    setCheckoutOrderId(null);
    isAdvancingFlowRef.current = false;
    isAdvancingToCheckoutRef.current = false;

    // Refresh boarding calendar and queue data when drawer closes
    if (window.refreshBoardingData || window.refreshBookingData) {
      if (window.refreshBoardingData) {
        window.refreshBoardingData();
      } else {
        window.refreshBookingData();
      }
    }
  }

  const resetForm = () => {
    setShowAddClientDrawer(false);
    setSearchPhone("");
    setClientData(null);
    setShouldOpenPetForm(false);
    setLoading(false);
    setError(null);
    setServiceId(null);
    setShowPetServiceDrawer(false);
    setShowAddNewPet(false);
    setClientOrders([]);
    setLoadingOrders(false);
    setAppointmentList([]);
    setBoardingList([]);
    setProductList([]);
    setVetClinicList([]);
    setAdjustmentAmount(0);
    setAdjustmentReason("");
    setSavedEnquiryId(null);
    setIsFromEnquiryList(false);
  };

  // Function to handle back navigation without losing appointment state
  const handleBackFromServiceDrawer = () => {
    setShowPetServiceDrawer(false);
    setItemData([]); // Clear item data but keep appointment list intact
    setDrawerEditMode(false); // Reset edit mode
    // Don't reset appointmentList here to maintain state
  };

  // Handler for going back to enquiry view from service drawer
  const handleBackToEnquiryView = () => {
    setShowPetServiceDrawer(false);
    setShowEnquiryDrawer(true);
    setItemData([]);
    setDrawerEditMode(false);
  };

  const handleProductQuantityChange = (index, delta) => {
    setProductList((prev) => {
      const next = [...prev];
      const newQuantity = next[index].quantity + delta;
      const availableQuantity = next[index].quantity_available;
      next[index] = { ...next[index], quantity: next[index].quantity + delta };

      // If quantity drops to zero or below, remove the item entirely
      if (newQuantity <= 0) {
        next.splice(index, 1);
      } else if (newQuantity > availableQuantity) {
        toast.warn(`Only ${availableQuantity} items available`);
        next[index].quantity = availableQuantity;
        // Recompute total_price
        next[index].total_price = availableQuantity * next[index].unit_price;
        next[index].gstAmount =
          (next[index].unit_price - next[index].before_gst) *
          next[index].quantity;
      } else {
        next[index].total_price = next[index].quantity * next[index].unit_price;
        next[index].gstAmount =
          (next[index].unit_price - next[index].before_gst) *
          next[index].quantity;
      }
      // Safely handle gstAmount - only update if it exists
      if (next[index] && typeof next[index].gstAmount !== "undefined") {
        next[index].gstAmount = next[index].gstAmount * next[index].quantity;
      }
      return next;
    });
  };
  const handleProductQuantityInput = (idx, value, product) => {
    let qty = parseInt(value, 10);
    if (isNaN(qty) || qty < 1) {
      qty = 1;
    }

    if (qty > product.quantity_available) {
      toast.warn(`Only ${product.quantity_available} items available`);
      qty = product.quantity_available;
    }

    setProductList((prev) => {
      const updated = [...prev];
      updated[idx] = {
        ...product,
        quantity: qty,
        total_price: qty * product.unit_price,
        // Safely handle gstAmount - only include if it exists in the original product
        ...(product.gstAmount !== undefined && {
          gstAmount: product.gstAmount * qty,
        }),
      };
      return updated;
    });
  };

  const handleSavedAppointment = (data) => {
    // Check if this is appointment data from NewServiceDrawer (not API response)
    if (data.pet_name && data.service_name && !data._id) {
      // ✅ VALIDATION: Check for double-booking
      const isEdit = data._editIndex !== undefined;
      const validationResult = checkEmployeeDoubleBooking(
        appointmentList,
        data,
        isEdit ? data._editIndex : -1,
      );

      if (!validationResult.isValid) {
        toast.error(validationResult.conflictMessage, {
          position: "top-center",
          autoClose: 5000,
        });
        return; // Don't add/update
      }
      let petTags = [];
      if (clientData?.pets && data.vendor_pet_id) {
        const foundPet = clientData.pets.find(
          (pet) => pet._id === data.vendor_pet_id,
        );
        if (foundPet) {
          if (foundPet.tags && foundPet.tags.length > 0) {
            // Handle different tag formats
            petTags = foundPet.tags.map((tag) => {
              if (typeof tag === "object" && tag.name) {
                return tag.name; // Extract name from object
              }
              return tag; // Keep as is if string
            });
          }
        }
      }

      // Check if this is an edit operation (has _editIndex)
      if (data._editIndex !== undefined) {
        // This is an update to an existing appointment in the list
        const editIndex = data._editIndex;
        setAppointmentList((prev) => {
          const updatedList = [...prev];
          // Update the appointment at the specific index
          const updatedData = { ...data, pet_tags: petTags }; // ✅ Include pet_tags
          delete updatedData._editIndex;
          delete updatedData._originalAppointment;
          updatedList[editIndex] = updatedData; // Replace at the same position
          fetchDiscountData([
            ...updatedList,
            ...boardingList,
            ...vetClinicList,
          ]);
          return updatedList;
        });
        toast.success("Appointment updated successfully!", {
          position: "top-center",
        });
      } else {
        // This is a new appointment being added
        // When adding new appointment
        setAppointmentList((prev) => {
          const updatedList = [...prev, { ...data, pet_tags: petTags }]; // ✅ Include pet_tags
          fetchDiscountData([
            ...updatedList,
            ...boardingList,
            ...vetClinicList,
          ]);
          return updatedList;
        });
        toast.success("Appointment added successfully!", {
          position: "top-center",
        });
      }
      setShowPetServiceDrawer(false); // Close the service drawer
      // Don't close the main appointment drawer - stay to show the data
      return;
    } else if (data.item_type === "product" && !data._id) {
      setProductList((prev = []) => {
        const map = new Map();

        // First, keep all previous values in a map (keyed by service_id)
        prev.forEach((p) => {
          map.set(p.service_id, p);
        });

        // Then, overwrite with new values (same service_id will be replaced)
        data.products.forEach((p) => {
          const updatedProduct = {
            ...p,
            // ✅ ENSURE ALL REQUIRED PRICE FIELDS ARE INCLUDED
            item_type: "product",
            unit_price: p.unit_price || 0,
            price: p.unit_price || 0, // Price before tax
            total_price: (p.unit_price || 0) * (p.quantity || 1),
            gst: p.gst || 0,
            tax_percentage: p.gst || 0,
            tax_amount: p.gstAmount || 0,
            amount_without_tax: p.unit_price - p.gstAmount || 0,
            amount_with_tax: (p.unit_price || 0) + (p.gst || 0),
            amount_after_discount: (p.unit_price || 0) + (p.gst || 0),
            amount_before_discount: p.unit_price || 0,
            discount_amount: p.discount_amount || 0,
            discount_type: p.discount_type || "",
            discount_value: p.discount_value || 0,
            gstAmount: p.gstAmount * p.quantity, // calculate gstAmount*quantity
          };
          map.set(p.service_id, updatedProduct);
        });

        // Return merged list
        return Array.from(map.values());
      });
    }
  };

  const handleSavedBoarding = (data) => {
    // Check if this is boarding data from BoardingDrawer (not API response)
    if (
      data.pet_name &&
      (data.item_type === "boarding" ||
        data.item_type === "daycare" ||
        data.item_type === "day_care") &&
      !data._id
    ) {
      // Determine which list to update based on item_type
      const isBoarding = data.item_type === "boarding";
      const isDaycare =
        data.item_type === "day_care" || data.item_type === "daycare";

      // Check if this is an edit operation (has _editIndex)
      if (data._editIndex !== undefined) {
        // This is an update to an existing item in the list
        const editIndex = data._editIndex;

        if (isBoarding) {
          setBoardingList((prev) => {
            const updatedList = [...prev];
            // Update the boarding at the specific index with all necessary fields
            const updatedData = {
              ...data,
              // Ensure all required fields are preserved, including updated pet name
              pet_name: data.pet_name,
              service_type_name: data.service_type_name,
              service_type_id: data.service_type_id,
              pet_breed: data.pet_breed,
              pet_type: data.pet_type,
              pet_size: data.pet_size,
              room_type_name: data.room_type_name,
              room_number: data.room_number,
              unit_price: data.unit_price,
              total_price: data.total_price,
              discount: data.discount || 0,
              gst: data.gst || 0,
              tax_percentage: data.tax_percentage || 0,
              notes: data.notes,
              vendor_pet_id: data.vendor_pet_id,
              pet_id: data.pet_id,
              discounted_tax: data.discounted_tax || 0,
            };
            delete updatedData._editIndex; // Remove the index marker
            delete updatedData._originalBoarding; // Remove the backup data
            updatedList[editIndex] = updatedData; // Replace at the same position
            fetchDiscountData([
              ...appointmentList,
              ...updatedList,
              ...vetClinicList,
            ]);
            return updatedList;
            // return updatedList;
          });
        } else if (isDaycare) {
          setAppointmentList((prev) => {
            const updatedList = [...prev];
            // Update the daycare at the specific index
            const updatedData = {
              ...data,
              // Ensure all required fields are preserved
              pet_name: data.pet_name,
              service_type_name: data.service_type_name || "Day Care",
              service_type_id: data.service_type_id,
              service_id: data.service_id, // Explicitly preserve service_id
              pet_breed: data.pet_breed,
              pet_type: data.pet_type,
              pet_size: data.pet_size,
              unit_price: data.unit_price,
              total_price: data.total_price,
              discount: data.discount || 0,
              gst: data.gst || 0,
              notes: data.notes,
              vendor_pet_id: data.vendor_pet_id,
              pet_id: data.pet_id,
            };
            delete updatedData._editIndex; // Remove the index marker
            delete updatedData._originalDaycare; // Remove the backup data
            updatedList[editIndex] = updatedData; // Replace at the same position
            fetchDiscountData([
              ...updatedList,
              ...boardingList,
              ...vetClinicList,
            ]);
            return updatedList;
          });
        }
      } else {
        // This is a new item being added
        const newItemData = {
          ...data,
          // Ensure all required fields are included
          pet_name: data.pet_name,
          service_type_name:
            data.service_type_name || (isDaycare ? "Day Care" : "Boarding"),
          service_type_id: data.service_type_id,
          pet_breed: data.pet_breed,
          pet_type: data.pet_type,
          pet_size: data.pet_size,
          unit_price: data.unit_price,
          total_price: data.total_price,
          discount: data.discount || 0,
          gst: data.gst || 0,
          tax_percentage: data.tax_percentage || 0,
          discounted_tax: data.discounted_tax || 0,
        };

        if (isBoarding) {
          newItemData.room_type_name = data.room_type_name;
          newItemData.room_number = data.room_number;
          setBoardingList((prev) => {
            const updatedList = [...prev, newItemData];
            fetchDiscountData([
              ...appointmentList,
              ...updatedList,
              ...vetClinicList,
            ]);
            return updatedList; // call your function here
          });

          // setBoardingList((prev) => [...prev, newItemData]);
        } else if (isDaycare) {
          // Ensure service_id is explicitly preserved for new daycare items
          const daycareItemData = {
            ...newItemData,
            service_id: data.service_id, // Explicitly preserve service_id
          };
          setAppointmentList((prev) => {
            const newList = [...prev, daycareItemData];
            fetchDiscountData([...newList, ...boardingList, ...vetClinicList]);
            return newList;
          });
        }
      }
      setShowPetServiceDrawer(false); // Close the service drawer

      // Refresh boarding calendar and queue data after successful operation
      if (window.refreshBoardingData) {
        window.refreshBoardingData();
      } else if (window.refreshBookingData) {
        window.refreshBookingData();
      }

      // Don't close the main appointment drawer - stay to show the data
      return;
    } else if (data.item_type === "product" && !data._id) {
      setProductList((prev = []) => {
        const map = new Map();

        // First, keep all previous values in a map (keyed by service_id)
        prev.forEach((p) => {
          map.set(p.service_id, p);
        });

        // Then, overwrite with new values (same service_id will be replaced)
        data.products.forEach((p) => {
          const updatedProduct = {
            ...p,
            gstAmount: (p.gstAmount || 0) * (p.quantity || 1), // calculate gstAmount*quantity
          };
          map.set(p.service_id, updatedProduct);
        });

        // Return merged list
        return Array.from(map.values());
      });
    }
  };

  const handleSavedDogWalking = (data) => {
    // Check if this is dog walking data from DogWalkingDrawer (not API response)
    if (data.pet_name && data.item_type === "dog_walking" && !data._id) {
      // ✅ VALIDATION: Check for double-booking
      const isEdit = data._editIndex !== undefined;
      const validationResult = checkEmployeeDoubleBooking(
        appointmentList,
        data,
        isEdit ? data._editIndex : -1,
      );

      if (!validationResult.isValid) {
        toast.error(validationResult.conflictMessage, {
          position: "top-center",
          autoClose: 5000,
        });
        return; // Don't add/update
      }

      // Check if this is an edit operation (has _editIndex)
      if (data._editIndex !== undefined) {
        // This is an update to an existing dog walking in the list
        const editIndex = data._editIndex;
        setAppointmentList((prev) => {
          const updatedList = [...prev];
          // Update the dog walking at the specific index with all necessary fields
          const updatedData = {
            ...data,
            // Ensure all required fields are preserved
            pet_name: data.pet_name,
            service_type_name: data.service_type_name || "Dog Walking",
            service_type_id: data.service_type_id,
            pet_breed: data.pet_breed,
            pet_type: data.pet_type,
            pet_size: data.pet_size,
            employee_name: data.employee_name,
            employee_id: data.technician_id,
            appointment_date: data.appointment_date || data.start_date,
            appointment_time: data.start_time,
            frequency: data.frequency,
            numberOfTimes: data.numberOfTimes,
            unit_price: data.unit_price,
            total_price: data.total_price,
            discount: data.discount || 0,
            gst: data.gst || 0,
            duration: data.duration,
            notes: data.notes,
          };
          delete updatedData._editIndex; // Remove the index marker
          delete updatedData._originalDogWalking; // Remove the backup data
          updatedList[editIndex] = updatedData; // Replace at the same position
          fetchDiscountData([
            ...updatedList,
            ...boardingList,
            ...vetClinicList,
          ]);
          return updatedList;
        });
        toast.success("Dog walking appointment updated successfully!", {
          position: "top-center",
        });
      } else {
        // This is a new dog walking being added
        const newItemData = {
          ...data,
          // Ensure all required fields are included
          pet_name: data.pet_name,
          service_type_name: data.service_type_name || "Dog Walking",
          service_type_id: data.service_type_id,
          pet_breed: data.pet_breed,
          pet_type: data.pet_type,
          pet_size: data.pet_size,
          employee_name: data.employee_name,
          employee_id: data.technician_id,
          appointment_date: data.appointment_date || data.start_date,
          appointment_time: data.start_time,
          frequency: data.frequency,
          numberOfTimes: data.numberOfTimes,
          unit_price: data.unit_price,
          total_price: data.total_price,
          discount: data.discount || 0,
          gst: data.gst || 0,
          duration: data.duration,
          notes: data.notes,
        };
        setAppointmentList((prev) => {
          const updatedList = [...prev, newItemData];
          fetchDiscountData([
            ...updatedList,
            ...boardingList,
            ...vetClinicList,
          ]);
          return updatedList;
        });
        toast.success("Dog walking appointment added successfully!", {
          position: "top-center",
        });
      }
      setShowPetServiceDrawer(false); // Close the service drawer
      // Don't close the main appointment drawer - stay to show the data
      return;
    }
  };

  const handleSavedVetClinic = (data) => {
    // ✅ IMPORTANT: Store original_price (MRP) for strikethrough display
    const processedData = {
      ...data,
      original_unit_price: data.mrp_price || data.unit_price,
      unit_price: data.mrp_price,
      price: data.unit_price,
      amount_without_tax: data.unit_price,
      amount_after_discount: data.unit_price,
      gst: data.gst,
      tax_percentage: data.tax_percentage,
      discount_amount: data.discount,
      discount_percentage: data.discount_percentage,
      // ✅ Preserve veterinarian information
      veterinarian_name: data.employee_name,
      veterinarian_id: data.technician_id,
      employee_name: data.employee_name,
      technician_id: data.technician_id,
      appointment_to: data.technician_id,
    };

    // Check if this is an edit operation
    if (data._editIndex !== undefined) {
      const editIndex = data._editIndex;
      setVetClinicList((prev) => {
        const updatedList = [...prev];
        const updatedData = { ...processedData };
        delete updatedData._editIndex;
        delete updatedData._originalVetClinic;
        updatedList[editIndex] = updatedData;
        // ✅ FIX: refresh discount data for vet items (same as grooming/boarding)
        fetchDiscountData([
          ...appointmentList,
          ...boardingList,
          ...updatedList,
        ]);
        return updatedList;
      });
      toast.success("Vet clinic appointment updated successfully!");
    } else {
      setVetClinicList((prev) => {
        const newList = [...prev, processedData];
        // ✅ FIX: refresh discount data for vet items (same as grooming/boarding)
        fetchDiscountData([
          ...appointmentList,
          ...boardingList,
          ...newList,
        ]);
        return newList;
      });
      toast.success("Vet clinic appointment added successfully!");
    }
    setShowPetServiceDrawer(false);
  };

  const handleSavedServicesData = (data) => {
    setIsServiceEditMode(false);

    // Route to appropriate handler based on service type
    if (
      data.item_type?.toLowerCase() === "boarding" ||
      data.item_type === "day_care"
    ) {
      handleSavedBoarding(data);
    } else if (data?.item_type === "dog_walking") {
      handleSavedDogWalking(data);
    } else if (data?.item_type === "vet_clinic") {
      handleSavedVetClinic(data);
    } else {
      handleSavedAppointment(data);
    }

    // Original API response handling for actual saving
    if (data._id) {
      const message = editMode
        ? "Order updated successfully!"
        : "Order created successfully!";
      toast.success(message);
      setOrderId(data._id);
      setOrderItems(data.order_items);
      if (onSave) onSave(data);
      clearSlotSelection();
      handleClose();
    }
  };
  const appendDiscountObjects = (arrayWithDiscount, arrayWithNumber) => {
    return arrayWithNumber.map((item, index) => {
      const source = arrayWithDiscount[index];
      // ✅ Ensure source.discount is always an array
      let discountArray = source?.discount || [];
      if (!Array.isArray(discountArray)) {
        discountArray = [];
      }

      const activeDiscount = discountArray.find(
        (d) => Number(d.is_active) === 1,
      );
      const totalDiscountAmount = activeDiscount?.discount_amount || 0;

      // For boarding, we need to handle per-day vs total calculations
      const isBoarding = source.item_type === "boarding";
      const duration = source.duration || 1;

      let amountAfterDiscount;

      if (isBoarding) {
        const totalPrice = source.unit_price * duration;
        const totalAfterDiscount = totalPrice - totalDiscountAmount;
        amountAfterDiscount = totalAfterDiscount / duration;
      } else {
        amountAfterDiscount = source.unit_price - totalDiscountAmount;
      }
      const taxAmount = (amountAfterDiscount * source.tax_percentage) / 100;
      const amountWithTax =
        (isBoarding ? amountAfterDiscount * duration : amountAfterDiscount) +
        taxAmount;

      // Remove any non-array discount property from item
      delete item.discount;

      return {
        ...item,
        amount_after_discount: amountAfterDiscount,
        tax_amount: taxAmount,
        gst: taxAmount,
        amount_with_tax: amountWithTax,
        amount_without_tax: amountAfterDiscount,
        discount_type: activeDiscount?.type || "",
        price_per_day: source.price_per_day || source.unit_price,
        discount_amount: totalDiscountAmount,
        discount_value: activeDiscount?.value || 0,
        discount_name: activeDiscount?.name || "",
        discounts: discountArray, // ✅ Always an array now
        // Preserve original unit price for display
        original_unit_price: source.unit_price,
        original_total_price: isBoarding
          ? source.unit_price * duration
          : source.unit_price,
      };
    });
  };

  const fetchDiscountData = async (items) => {
    try {
      if (isFromEnquiryList) setIsEnquiryLoading(true);
      const payload = {
        client_id: clientData?._id,
        items: items.map((item) => {
          if (item.item_type === "boarding") {
            const duration = item.duration || item.quantity || 1;

            return {
              ...item,
              quantity: duration,
              unit_price: (item.price_per_day || 0) * duration, // ✅ Use price_per_day
              total_price: item.total_price || 0,
            };
          }

          return item;
        }),
      };

      const response = await httpService.post(
        "/vendorbooking/getDiscountCalculation",
        payload,
      );

      const itemsWithDiscount = appendDiscountObjects(
        response.data.items,
        items,
      );
      const preservedItems = itemsWithDiscount.map((discountItem, index) => {
        const originalItem = items[index];
        return {
          ...discountItem,
          pet_tags: originalItem?.pet_tags || discountItem?.pet_tags,
          addons: originalItem?.addons || discountItem?.addons,
          products: originalItem?.products || discountItem?.products,
          otherCharges:
            originalItem?.otherCharges || discountItem?.otherCharges,
        };
      });

      setBoardingList(
        preservedItems.filter((item) => item.item_type === "boarding"),
      );
      setAppointmentList(
        preservedItems.filter(
          (item) =>
            item.item_type === "grooming" ||
            item.item_type === "day_care" ||
            item.item_type === "dog_walking",
        ),
      );
      setVetClinicList(
        itemsWithDiscount.filter((item) => item.item_type === "vet_clinic"),
      );
      if (enquiryDetails) setEnquiryDataLoading(false);
    } catch (error) {
      console.error("Error fetching discount data:", error);
    } finally {
      setIsEnquiryLoading(false);
    }
  };

  const handleServiceData = (serviceId) => {
    setItemData((prev) => ({
      ...prev,
      service_id: serviceId,
    }));
  };
  const handleclientSaved = (data) => {
    setClientData(data);
    setError(null);
  };

  const handleSaveAndAddPet = (data) => {
    setClientData(data);
    setError(null);
    setShowAddClientDrawer(false);
    // Open the Add New Pet component
    setShowAddNewPet(true);
  };

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "completed":
        return "bg-green-100 text-green-700 border-green-200";
      case "cancelled":
        return "bg-red-100 text-red-700 border-red-200";
      case "no_show":
        return "bg-yellow-100 text-yellow-700 border-yellow-200";
      case "draft":
        return "bg-gray-100 text-gray-700 border-gray-200";
      default:
        return "bg-blue-100 text-blue-700 border-blue-200";
    }
  };

  const getStatusText = (status) => {
    switch (status?.toLowerCase()) {
      case "completed":
        return "Completed";
      case "cancelled":
        return "Cancelled";
      case "no_show":
        return "No Show";
      case "draft":
        return "Draft";
      default:
        return status?.charAt(0).toUpperCase() + status?.slice(1);
    }
  };

  // Helper function to safely format dates
  const safeFormatDate = (dateString) => {
    if (!dateString) return null;
    const date = new Date(dateString);
    return isNaN(date.getTime()) ? null : date;
  };

  // Helper function to get boarding display text
  const getBoardingDisplayText = (boarding) => {
    const roomTypeName = boarding.room_type_name || "Room Type";
    const roomNumber = boarding.room_number || "Not Selected";
    const serviceName = boarding.service_name || "Boarding";

    if (roomTypeName === "Room Type" && roomNumber === "Not Selected") {
      return (
        <>
          {serviceName} -
          <span className="italic text-sm text-red-500">
            Room details not added
          </span>
        </>
      );
    } else if (roomTypeName === "Room Type") {
      return `${serviceName} - ${roomTypeName} - Room ${roomNumber}`;
    } else if (roomNumber === "Not Selected") {
      return (
        <>
          {serviceName} - {roomTypeName} -{" "}
          <span className="italic text-sm text-red-500">Room not selected</span>
        </>
      );
    } else {
      return `${serviceName} - ${roomTypeName} - Room ${roomNumber}`;
    }
  };

  // Function to handle pet save from AddNewPet component
  const handlePetSaved = (petData) => {
    if (clientData?.phone) {
      fetchClientByPhone(clientData.phone);
    }
    setShowAddNewPet(false);
  };

  // Function to handle AddNewPet back button
  const handleAddNewPetBack = () => {
    setShowAddNewPet(false);
  };

  // Function to refresh appointment data
  const handleRefreshAppointmentData = (newData) => {
    if (onSave) {
      onSave(newData);
    }
  };

  // Handler for Add Pets & Services
  const handleAddPetsAndServices = () => {
     if (clientData?.isActive === false) {
       toast.error("This client is disabled. Cannot add pets or services.");
       return;
     }
    setDrawerEditMode(false);
    setShowPetServiceDrawer(false);
    setTimeout(() => setShowPetServiceDrawer(true), 0);
  };

  // Handler for editing appointment from list
  const handleEditAppointmentFromList = (appointment, index) => {
     if (clientData?.isActive === false) {
       toast.error("This client is disabled. Cannot edit services.");
       return;
     }
    // Prepare the appointment data for editing with all necessary fields
    const editData = {
      ...appointment,
      // Ensure ids are present for downstream drawers
      service_id: appointment.service_id,
      pet_id: appointment.pet_id,
      vendor_pet_id: appointment.vendor_pet_id,
      vendor_client_id: clientData?._id,
      service_category_type_id: appointment.service_category_type_id,
      service_type_name:
        appointment.service_type_name || appointment.service_name || "Grooming",
      item_type:
        appointment.item_type ||
        (appointment.service_type_name === "Day Care"
          ? "day_care"
          : "grooming"), // Explicitly set item_type
      employee_id: appointment.technician_id,
      employee_name: appointment.employee_name,
      // Ensure date and time are properly formatted for editing
      start_date: appointment.start_date,
      start_time: appointment.start_time,
      appointment_date: appointment.appointment_date || appointment.start_date,
      appointment_time: appointment.appointment_time || appointment.start_time,
      // Preserve frequency and numberOfTimes for dog walking
      frequency: appointment.frequency,
      numberOfTimes: appointment.numberOfTimes,
      // Store the original index and appointment data for restoration
      _editIndex: index,
      _originalAppointment: { ...appointment },
    };

    setItemData(editData);
    setDrawerEditMode(true);
    setShowPetServiceDrawer(true);
    // DON'T remove from list - keep it visible and handle updates properly
  };

  // Handler for deleting appointment from list
  const handleDeleteAppointmentFromList = (index) => {
    setAppointmentList((prev) => {
      const updatedList = prev.filter((_, i) => i !== index);
      fetchDiscountData([...updatedList, ...boardingList, ...vetClinicList]);
      return updatedList;
    });
    toast.success("Appointment removed from list!", {
      position: "top-center",
    });
  };

  // Handler for editing boarding from list
  const handleEditBoardingFromList = (boarding, index) => {
    if (clientData?.isActive === false) {
      toast.error("This client is disabled. Cannot edit boarding.");
      return;
    }
    // Prepare the boarding data for editing with all necessary fields
    const editData = {
      ...boarding,
      // Ensure ids are present for downstream drawers
      service_id: boarding.service_id,
      pet_id: boarding.pet_id,
      vendor_pet_id: boarding.vendor_pet_id,
      vendor_client_id: clientData?._id,
      service_category_type_id: boarding.service_category_type_id,
      service_type_name: boarding.service_type_name || "Boarding", // Force to 'Boarding' for proper category matching
      service_type_id: boarding.service_type_id,
      item_type: "boarding", // Explicitly set item_type for better matching
      // Ensure dates are properly formatted for editing
      start_date: boarding.start_date,
      end_date: boarding.end_date,
      checkin_date: boarding.start_date,
      checkout_date: boarding.end_date,
      // Room and pricing details
      room_type_id: boarding.room_type_id,
      room_type_name: boarding.room_type_name,
      room_id: boarding.room_id,
      room_number: boarding.room_number,
      price: boarding.unit_price,
      discount: boarding.discount || 0,
      gst: boarding.gst || 0,
      total_price: boarding.total_price,
      // Pet details
      pet_name: boarding.pet_name,
      pet_type: boarding.pet_type,
      pet_size: boarding.pet_size,
      pet_breed: boarding.pet_breed,
      // Store the original index and boarding data for restoration
      _editIndex: index,
      _originalBoarding: { ...boarding },
    };

    setItemData(editData);
    setDrawerEditMode(true);
    setShowPetServiceDrawer(true);
    // DON'T remove from list - keep it visible and handle updates properly
  };

  // Handler for deleting boarding from list
  const handleDeleteBoardingFromList = (index) => {
    setBoardingList((prev) => {
      const updatedList = prev.filter((_, i) => i !== index);
      if (appointmentList && updatedList) {
        fetchDiscountData([
          ...appointmentList,
          ...updatedList,
          ...vetClinicList,
        ]);
      }
      return updatedList; // call your function here
    });
    // setBoardingList((prev) => prev.filter((_, i) => i !== index));
    toast.success("Boarding removed from list!", {
      position: "top-center",
    });
  };

  // Handler for editing vet clinic from list
  const handleEditVetClinicFromList = (vetClinic, index) => {
      if (clientData?.isActive === false) {
        toast.error("This client is disabled. Cannot edit vet clinic.");
        return;
      }
    // Prepare the vet clinic data for editing with all necessary fields
    const editData = {
      ...vetClinic,
      // Ensure ids are present for downstream drawers
      service_id: vetClinic.service_id,
      pet_id: vetClinic.pet_id,
      vendor_pet_id: vetClinic.vendor_pet_id,
      vendor_client_id: clientData?._id,
      service_category_type_id: vetClinic.service_category_type_id,
      service_type_name: "Vet Clinic", // Force service type name for category matching
      service_type_id: vetClinic.service_type_id,
      // Ensure dates are properly formatted for editing
      start_date: vetClinic.appointment_date || vetClinic.start_date,
      start_time: vetClinic.appointment_time || vetClinic.start_time,
      appointment_date: vetClinic.appointment_date || vetClinic.start_date,
      appointment_time: vetClinic.appointment_time || vetClinic.start_time,
      // Veterinarian details
      veterinarian_id: vetClinic.veterinarian_id || vetClinic.technician_id,
      veterinarian_name: vetClinic.veterinarian_name || vetClinic.employee_name,
      technician_id: vetClinic.veterinarian_id || vetClinic.technician_id,
      employee_name: vetClinic.veterinarian_name || vetClinic.employee_name,
      // Pricing details
      price: vetClinic.unit_price,
      discount: vetClinic.discount || 0,
      gst: vetClinic.gst || 0,
      total_price: vetClinic.total_price,
      // Pet details
      pet_name: vetClinic.pet_name,
      pet_type: vetClinic.pet_type,
      pet_size: vetClinic.pet_size,
      pet_breed: vetClinic.pet_breed,
      // Store the original index and vet clinic data for restoration
      _editIndex: index,
      _originalVetClinic: { ...vetClinic },
    };

    setItemData(editData);
    setDrawerEditMode(true);
    setShowPetServiceDrawer(true);
    // DON'T remove from list - keep it visible and handle updates properly
  };

  // Handler for deleting vet clinic from list
  const handleDeleteVetClinicFromList = (index) => {
    setVetClinicList((prev) => prev.filter((_, i) => i !== index));
    toast.success("Vet clinic appointment removed from list!", {
      position: "top-center",
    });
  };

  // Fetch enquiry data
  const fetchEnquiryData = async () => {
    if (!clientData?._id) return;

    setLoadingEnquiries(true);
    try {
      const response = await httpService.get("/vendororder/getOrderEnquiries");
      const allEnquiries = response.data || [];
      const clientId = clientData?._id;

      // Some enquiry records use vendor_client_id while others keep it nested under vendor_client._id.
      const filtered = allEnquiries.filter((enq) => {
        const enquiryClientId = enq.vendor_client_id || enq.vendor_client?._id;
        return enquiryClientId === clientId;
      });

      const sortedEnquiries = [...filtered].sort(
        (a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0),
      );

      // Add original_quantity_available to each item to preserve the original limit
      const processedEnquiries = sortedEnquiries.map((enquiry) => ({
        ...enquiry,
        items:
          enquiry.items?.map((item) => ({
            ...item,
            original_quantity_available:
              item.quantity_available ||
              item.product_details?.quantity_available ||
              item.quantity ||
              999,
          })) || [],
      }));

      setEnquiryData(processedEnquiries);
      setExpandedEnquiry(processedEnquiries[0]?._id || null);
    } catch (error) {
      console.error("Error fetching enquiry data:", error);
      toast.error("Failed to load enquiry data");
      setEnquiryData([]);
    } finally {
      setLoadingEnquiries(false);
    }
  };

  const handleDeleteEnquiry = async (enquiry) => {
    const result = await Swal.fire({
      title: "Delete Enquiry?",
      text: "Are you sure you want to delete this enquiry?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        // Call delete API if available
        // await httpService.delete(`/vendororder/deleteEnquiry/${enquiry._id}`);

        // Remove from local state
        setEnquiryData((prev) => prev.filter((e) => e._id !== enquiry._id));

        toast.success("Enquiry deleted successfully!", {
          position: "top-center",
        });
      } catch (error) {
        console.error("Error deleting enquiry:", error);
        toast.error("Failed to delete enquiry", {
          position: "top-center",
        });
      }
    }
  };

  const handleEnquiryPaymentComplete = async (paymentData) => {
    // Prevent multiple calls
    if (isPaymentLoading) {
      return;
    }

    setIsPaymentLoading(true);

    try {
      const enquiry = selectedEnquiryForPayment;
      if (!enquiry) {
        console.error("❌ No enquiry selected for payment");
        toast.error("No enquiry selected for payment", {
          position: "top-center",
        });
        return;
      }

      // Prepare enquiry items for conversion
      const enquiryItems = enquiry.items.map((item) => {
        return {
          item_type: item.item_type || "grooming",
          vendor_pet_id: item.vendor_pet_id,
          service_id: item.service_id,
          technician_id: item.technician_id,
          start_date: item.start_date || item.appointment_date,
          start_time: item.time_slot || item.appointment_time,
          duration: item.duration,
          frequency: item.frequency,
          number_of_times: item.numberOfTimes,
          pet_size: item.pet_size, // Add this
          pet_breed: item.pet_breed, // Add this if available
          addons: item.addons || [],
          notes: item.notes || "",
        };
      });

      const payload = {
        booking_type: 3, // "booking & payment"
        vendor_client_id: clientData?._id,
        order_items: enquiryItems,
        payment_mode: paymentData.method,
        reference_number:
          paymentData.method === "cash" ? "" : paymentData.reference || "",
        // Add calculated total amount to ensure consistency
        notes,
      };

      await httpService.post("/vendorappointment/addBooking", payload);
      if (vendorId) {
        await markSetupStepCompleteById(vendorId, "booking");
      }

      // NEW: Delete enquiry since it has been converted to booking & payment
      try {
        await httpService.delete(
          `/vendororderenquiry/deleteOrderEnquiry/${enquiry._id}`,
        );
      } catch (deleteErr) {
        console.error(
          "Failed to delete enquiry after booking+payment conversion",
          deleteErr,
        );
      }

      toast.success("Enquiry converted to booking with payment successfully!", {
        position: "top-center",
      });

      // Close payment section and reset state
      setShowEnquiryPaymentSection(false);
      setSelectedEnquiryForPayment(null);
      setExistingPaidAmount(0);

      // Close the drawer
      handleClose();
    } catch (error) {
      console.error("❌ Error processing payment:", error);
      toast.error("Failed to process payment", {
        position: "top-center",
      });
    } finally {
      setIsPaymentLoading(false);
    }
  };

  const handleBackFromEnquiryPayment = () => {
    setShowEnquiryPaymentSection(false);
    setSelectedEnquiryForPayment(null);
    setExistingPaidAmount(0);
  };

  // Calculate remaining amount for enquiry payments
  const calculateRemainingAmount = () => {
    const enquiry = selectedEnquiryForPayment;
    if (!enquiry) return 0;

    // Calculate total amount dynamically from components
    const subtotal = parseFloat(enquiry.amount_before_discount || 0);
    const addonAmount = parseFloat(calculateTotalAddonAmount(enquiry));
    const gstAmount = parseFloat(enquiry.total_gst);
    const discount = parseFloat(enquiry.discount_amount || 0);

    const totalAmount = subtotal + addonAmount + gstAmount - discount;
    const remainingAmount = totalAmount - existingPaidAmount;
    return Math.max(0, remainingAmount);
  };

  // Calculate total addon base amount for enquiry (for totals section)
  const calculateTotalAddonAmount = (enquiry) => {
    if (!enquiry || !enquiry.items) return 0;

    let totalAddonAmount = 0;
    enquiry.items.forEach((item) => {
      if (item.addons && item.addons.length > 0) {
        item.addons.forEach((addon) => {
          totalAddonAmount += parseFloat(addon.addon_price || 0); // Only base price, no GST
        });
      }
    });

    return totalAddonAmount;
  };

  // Calculate totals
  const calculateTotals = () => {
    let subtotal = 0; // Taxable amount (excl. GST)
    let totalGst = 0;
    let totalItemDiscount = 0;
    let grossAmount = 0; // MRP including GST (for products)

    setSaveDisabled(
      appointmentList?.some((a) => !a.start_date || !a.start_time) ||
        boardingList?.some(
          (b) => !b.start_date || !b.end_date || !b.room_type_id,
        ) ||
        vetClinicList?.some((v) => !v.start_date || !v.start_time),
    );

    // Process all lists
    const allItems = [
      ...appointmentList,
      ...boardingList,
      ...vetClinicList,
      ...productList,
    ];
    let finalTotal = 0;
    // let finalNetAmount = 0;

    allItems.forEach((item) => {
      if (!item) return;
      let mrpTotal = 0;

      const isBoarding = item.item_type === "boarding";
      const duration = item.duration || 1;
      let itemSubtotal = 0;
      let itemGst = 0;
      let itemGrossAmount = 0;

      // Calculate base price based on item type
      if (isBoarding) {
        // Boarding: unit_price is per day
        itemSubtotal = Number(item?.unit_price * duration || 0);
        itemGst = Number(item?.gst || 0);
        itemGrossAmount = Number(item?.unit_price * duration || 0);
        mrpTotal += Number(item.unit_price) * Number(duration);
      } else {
        // For appointments and vet clinic
        itemSubtotal = Number(item.unit_price || item.price || 0);
        itemGst = Number(item.gst || 0);
        itemGrossAmount = Number(item?.unit_price * duration || 0);
        mrpTotal += Number(item.unit_price);
      }

      // Calculate addons total
      const addonTotal =
        item.addons?.reduce(
          (sum, addon) => sum + parseFloat(addon.addon_price || 0),
          0,
        ) || 0;

      let finalProductsTax = 0;
      let productDiscountForItem = 0;
      const productTotalValue = item.products?.reduce((sum, product) => {
        return (sum + (product.effective_sale_price || product.amount_after_discount) * parseFloat(product.quantity || 1));
      },0) || 0;
      const productTotalMrp = item.products?.reduce((sum, product) => {
        return (sum + product.mrp_price * parseFloat(product.quantity || 1));
      },0) || 0;
      const productTotal =
        item.products?.reduce((sum, product) => {
          finalProductsTax += product.gstAmountAfterDiscount * product.quantity;
          
          // ✅ per-product discount: prefer explicit field, fall back to MRP − sale
          const perUnitDiscount = product.discount_amount != null
            ? parseFloat(product.discount_amount || 0)
            : parseFloat(product.amount_before_discount || 0) -
              parseFloat(product.amount_after_discount || 0);

          productDiscountForItem += Math.max(0, perUnitDiscount) * parseFloat(product.quantity || 1);
          return (
            sum +
            parseFloat(product.price || 0) * parseFloat(product.quantity || 1)
          );
        }, 0) || 0;

      const otherChargesTotal =
        item.otherCharges?.reduce((sum, charge) => {
          return sum + parseFloat(charge.amount || 0);
        }, 0) || 0;

      // Total before discount
      const totalBeforeDiscount = itemSubtotal;

      // Calculate item-level discounts (from backend/API)
      const activeDiscount = item?.discounts?.find(
        (d) => Number(d.is_active) === 1,
      );
      let itemDiscount = 0;

      if (activeDiscount) {
        if (activeDiscount.type === "percentage") {
          itemDiscount = (totalBeforeDiscount * activeDiscount.value) / 100;
        } else {
          itemDiscount = Math.min(
            activeDiscount.value || 0,
            totalBeforeDiscount,
          );
        }
      }

      // Calculate amount after item discount
      const amountAfterItemDiscount = Math.max(
        0,
        totalBeforeDiscount - itemDiscount,
      );
      // For non-products, GST is based on discounted amount
      const taxPercentage = parseFloat(item.tax_percentage || 0);
      if (taxPercentage > 0) {
        itemGst = (amountAfterItemDiscount * taxPercentage) / (100 + taxPercentage);
      }
      itemSubtotal = amountAfterItemDiscount;

      // Accumulate totals
      subtotal += mrpTotal + productTotalMrp + otherChargesTotal + addonTotal;
      finalTotal += itemSubtotal + productTotalValue + otherChargesTotal + addonTotal;

      // finalNetAmount += finalTotal - (itemGst + finalProductsTax);
      totalGst += itemGst + finalProductsTax;
      totalItemDiscount += itemDiscount + productDiscountForItem;
      grossAmount += totalBeforeDiscount;

      // Update the item with calculated values for display
      if (item.item_type === "boarding") {
        item.amount_without_tax = amountAfterItemDiscount;
        item.amount_after_discount =
          duration > 0
            ? amountAfterItemDiscount / duration
            : amountAfterItemDiscount;
      } else if (item.item_type === "product") {
        item.amount_without_tax = itemSubtotal;
        item.amount_after_discount = itemSubtotal;
      } else {
        item.amount_without_tax = itemSubtotal;
        item.amount_after_discount = itemSubtotal;
      }
    });

    const totalDiscount = totalItemDiscount //+ manualDiscountAmount;

    // Update total summary state
    const summary = {
      subtotal: subtotal,
      gst: totalGst.toFixed(2),
      discount: totalDiscount.toFixed(2),
      total: finalTotal.toFixed(2),
      discountAmount: totalDiscount,
      discountedGST: totalGst,
      totalItemDiscount: totalItemDiscount,
      netAmount: finalTotal - totalGst,
    };

    setTotalSummary(summary);
    totalSummaryRef.current = summary;

    // return {
    //   subtotal: finalSubtotal.toFixed(2),
    //   gst: finalGst.toFixed(2),
    //   discount: totalDiscount.toFixed(2),
    //   total: finalTotal.toFixed(2),
    // };
  };

  // API call for booking
  const handleBookingAPI = async (
    bookingType,
    paymentData = null,
    shouldShowPaymentDrawer = false,
  ) => {
    // Prevent multiple calls
    if (isBookingLoading) {
      return;
    }

    const totalItems =
      appointmentList?.length +
      boardingList?.length +
      vetClinicList?.length +
      productList?.length;

    if (totalItems === 0) {
      toast.warn("No items to save!", {
        position: "top-center",
      });
      return;
    }

    setIsBookingLoading(true);

    try {
      // Prepare appointment items (including daycare)
      const appointmentItems = appointmentList?.map((appointment) => {
        const activeDiscount = appointment?.discounts?.find(
          (d) => d.is_active === 1,
        );
        let updatedTotalPrice = appointment.price - (activeDiscount || 0);
        const originalUnitPrice = appointment.price;
        // let updatedGstAmount = appointment.gst;
        const updatedGstAmount =
          updatedTotalPrice * (appointment.tax_percentage / 100);
        // if (
        //   updatedTotalPrice <
        //   appointment.total_price - (appointment.gst || 0)
        // ) {
        //   updatedGstAmount =
        //     updatedTotalPrice * (appointment.tax_percentage / 100);
        // }
        // Calculate item totals
        const unitPrice = parseFloat(appointment.unit_price || 0);
        const gstAmount = parseFloat(appointment.gst || 0);
        const discountAmount = parseFloat(appointment.discount_amount || 0);
        const amountWithoutTax = parseFloat(
          appointment.amount_without_tax || 0,
        );
        const totalPrice = parseFloat(appointment.total_price || 0);

        // Calculate addons total if any
        const addonTotal =
          appointment.addons?.reduce((sum, addon) => {
            return sum + (parseFloat(addon.addon_price) || 0);
          }, 0) || 0;

        const item = {
          original_unit_price: originalUnitPrice,
          item_type: appointment.item_type || "grooming", // This preserves 'day_care' for daycare items
          service_category_type_id: appointment.service_category_type_id,
          vendor_pet_id: appointment.pet_id || appointment.vendor_pet_id,
          service_id: appointment.service_id, // This should include the service_id from vendordaycareservice
          technician_id: appointment.technician_id,
          start_date: appointment.start_date,
          start_time: appointment.start_time,
          duration: appointment.duration,
          frequency: appointment.frequency,
          number_of_times: appointment.numberOfTimes,
          price_surcharge: appointment?.price_surcharge || [],
          quantity: 1,
          unit_price: unitPrice,
          discount: discountAmount,
          gst: gstAmount,
          total_price: totalPrice,
          amount_without_tax: amountWithoutTax,
          amount_with_tax: totalPrice,
          amount_after_discount: amountWithoutTax,
          tax_percentage: appointment.tax_percentage || 0,
          tax_amount: gstAmount,
          discounts: appointment?.discounts || [],
          addons: appointment.addons || [],
          otherCharges: appointment.otherCharges || [],
          products: appointment.products || [],
          notes: appointment.notes || "",
          form_ids: appointment.form_ids || [],
        };

        return item;
      });

      // Prepare boarding items
      const boardingItems = boardingList?.map((boarding) => {
        let updatedTotalPrice =
          boarding.price -
          (boarding?.discounts?.find((d) => d.is_active === 1)
            ?.discount_amount || 0);
        // let updatedGstAmount = boarding.gst;
        const updatedGstAmount =
          updatedTotalPrice * (boarding.tax_percentage / 100);
        // if (updatedTotalPrice < boarding.total_price - (boarding.gst || 0)) {
        //   updatedGstAmount =
        //     updatedTotalPrice * (boarding.tax_percentage / 100);
        // }

        const activeDiscount = boarding?.discounts?.find(
          (d) => d.is_active === 1,
        );
        const duration = boarding.duration || 1;
        const unitPrice = parseFloat(
          Number(boarding.unit_price) -
            Number(activeDiscount?.discount_amount || 0) / Number(duration),
        ).toFixed(2);
        const originalUnitPrice = parseFloat(
          Number(boarding.unit_price),
        ).toFixed(2);

        const gstAmount = parseFloat(updatedGstAmount || 0);
        const discountAmount = parseFloat(activeDiscount?.discount_amount || 0);
        const amountWithoutTax = parseFloat(boarding.amount_without_tax || 0);
        const totalPrice = parseFloat(
          Number(boarding.amount_without_tax) + Number(updatedGstAmount) || 0,
        );

        // Calculate addons total if any
        const addonTotal =
          boarding.addons?.reduce((sum, addon) => {
            return sum + (parseFloat(addon.addon_price) || 0);
          }, 0) || 0;

        const item = {
          original_unit_price: originalUnitPrice,
          item_type: boarding.item_type || "boarding",
          service_category_type_id: boarding.service_category_type_id,
          vendor_pet_id: boarding.pet_id || boarding.vendor_pet_id,
          service_id: boarding.service_id,
          room_type_id: boarding.room_type_id,
          room_id: boarding.room_id,
          room_number: boarding.room_number,
          start_date: boarding.start_date,
          end_date: boarding.end_date,
          duration: boarding.duration,
          quantity: boarding.duration,
          unit_price: unitPrice,
          discount: discountAmount,
          discount_name: boarding?.discount_name,
          gst: gstAmount,
          total_price: totalPrice,
          amount_without_tax: amountWithoutTax,
          amount_with_tax: totalPrice,
          amount_after_discount: amountWithoutTax,
          tax_percentage: boarding.tax_percentage || 0,
          tax_amount: gstAmount,
          discounts: boarding?.discounts || [],
          price_surcharge: boarding?.price_surcharge || [],
          addons: boarding.addons || [],
          otherCharges: boarding.otherCharges || [],
          products: boarding.products || [],
          notes: boarding.notes || "",
          form_ids: boarding.form_ids || [],
        };
        return item;
      });

      // Prepare vet clinic items
      const vetClinicItems = vetClinicList?.map((vetClinic) => {
        const unitPrice = parseFloat(vetClinic.unit_price || 0);
        const gstAmount = parseFloat(vetClinic.gst || 0);
        const discountAmount = parseFloat(vetClinic.discount_amount || 0);
        const amountWithoutTax = parseFloat(vetClinic.amount_without_tax || 0);
        const totalPrice = parseFloat(vetClinic.total_price || 0);

        // Calculate addons total if any
        const addonTotal =
          vetClinic.addons?.reduce((sum, addon) => {
            return sum + (parseFloat(addon.addon_price) || 0);
          }, 0) || 0;

        return {
          original_unit_price: unitPrice,
          item_type: "vet_clinic",
          vendor_pet_id: vetClinic.pet_id || vetClinic.vendor_pet_id,
          service_id: vetClinic.service_id,
          technician_id:
            vetClinic.veterinarian_id ||
            vetClinic.technician_id ||
            vetClinic.appointment_to,
          start_date: vetClinic.appointment_date || vetClinic.start_date,
          start_time:
            vetClinic.appointment_start_time ||
            vetClinic.appointment_time ||
            vetClinic.start_time,
          duration: vetClinic.duration,
          quantity: 1,
          unit_price: unitPrice,
          discount: discountAmount,
          discounts: vetClinic.discounts,
          gst: gstAmount,
          total_price: totalPrice,
          amount_without_tax: amountWithoutTax,
          amount_with_tax: totalPrice,
          amount_after_discount: amountWithoutTax,
          tax_percentage: vetClinic.tax_percentage || 0,
          tax_amount: gstAmount,
          addons: vetClinic.addons || [],
          otherCharges: vetClinic.otherCharges || [],
          products: vetClinic.products || [],
          notes: vetClinic.symptoms || vetClinic.notes || "",
          vet_details: {
            symptoms: vetClinic.symptoms || "",
          },
          form_ids: vetClinic.form_ids || vetClinic.form_id || [],
        };
      });

      // Prepare products
      const productItems = productList
        ?.map((product) => {
          if (!product) return null;

          const quantity = parseFloat(product.quantity || 0);
          const unitPrice = parseFloat(product.unit_price || 0);
          const taxPercentage = parseFloat(product.tax_percentage || 0);

          // Calculate GST amount correctly (inclusive tax)
          const totalMrp = unitPrice * quantity;
          let gstAmount = 0;
          let amountWithoutTax = totalMrp;

          if (taxPercentage > 0) {
            amountWithoutTax = roundToTwo(totalMrp / (1 + taxPercentage / 100));
            gstAmount = roundToTwo(totalMrp - amountWithoutTax);
          }

          const totalPrice = totalMrp;

          return {
            item_type: "product",
            vendor_pet_id: product.vendor_pet_id || product.pet_id || "",
            service_id: product.service_id || product.product_id || product._id,
            description: product.description || "",
            sku_number: (product.sku_number || product.sku || "")
              .toString()
              .trim(),
            quantity: quantity,
            unit_price: roundToTwo(unitPrice),
            price: roundToTwo(amountWithoutTax),
            discount: parseFloat(product.discount_amount || 0),
            gst: roundToTwo(gstAmount),
            tax_percentage: taxPercentage,
            tax_amount: roundToTwo(gstAmount),
            total_price: roundToTwo(totalPrice),
            amount_without_tax: roundToTwo(amountWithoutTax),
            amount_with_tax: roundToTwo(totalPrice),
            amount_after_discount: roundToTwo(totalPrice),
            discount_amount: parseFloat(product.discount_amount || 0),
            discount_type: product.discount_type || "",
            discount_value: product.discount_value || 0,
          };
        })
        .filter(Boolean);

      // Combine all items
      const orderItems = [
        ...appointmentItems,
        ...boardingItems,
        ...vetClinicItems,
        ...productItems,
      ];

      // Calculate totals from all items
      let totalAmountFromItems = 0;
      let totalDiscountFromItems = 0;
      let totalGSTFromItems = 0;
      let amountBeforeDiscount = 0;
      let totalAmountWithoutTax = 0;

      orderItems.forEach((item) => {
        const itemTotalPrice = parseFloat(item.total_price) || 0;
        const itemDiscount = parseFloat(item.discount) || 0;
        const itemGST = parseFloat(item.gst) || 0;
        const itemAmountWithoutTax = parseFloat(item.amount_without_tax) || 0;

        totalAmountFromItems += itemTotalPrice;
        totalDiscountFromItems += itemDiscount;
        totalGSTFromItems += itemGST;
        totalAmountWithoutTax += itemAmountWithoutTax;

        // Calculate original price before discount
        const originalPrice = itemTotalPrice + itemDiscount;
        amountBeforeDiscount += originalPrice;
      });

      // Calculate order-level discount (from the Additional Discount section)
      // let manualDiscountAmount = 0;
      // if (discount.type === "percentage" && discount.value > 0) {
      //   manualDiscountAmount = (totalAmountWithoutTax * discount.value) / 100;
      // } else if (discount.type === "fixed" && discount.value > 0) {
      //   manualDiscountAmount = Math.min(discount.value, totalAmountWithoutTax);
      // }

      // Apply order-level discount
      const amountAfterOrderDiscount = Math.max(
        0,
        totalAmountWithoutTax //- manualDiscountAmount,
      );
      const finalTotalAmount = amountAfterOrderDiscount + totalGSTFromItems;

      // Base payload
      const payload = {
        booking_type: bookingType, // 1 - "enquiry", 2 - "booking", 3 - "booking & payment"
        vendor_client_id: clientData._id,
        order_items: orderItems,
        // Note: If backend is still calculating differently, this field should override backend calculation
        // discount_type: discount.type,
        // discount_value: discount.value,
        // discount_amount: parseFloat(discount.amount) || 0,
        notes,
        // ✅ Include calculated totals
        total_amount: finalTotalAmount,
        total_discount: totalDiscountFromItems,// + manualDiscountAmount,
        total_gst: totalGSTFromItems,
        amount_before_discount: amountBeforeDiscount,
        amount_after_discount: amountAfterOrderDiscount,
        gst_after_discount: totalGSTFromItems,
        amount_without_tax: amountAfterOrderDiscount,
      };

      // Add payment details if booking with payment
      if (bookingType === 3 && paymentData) {
        // Single payment method
        const paymentAmount = parseFloat(paymentData.amount);
        payload.paid_amount = paymentAmount;
        payload.payment_mode = paymentData.method;
        payload.reference_number = paymentData.reference || "";
        payload.amount_paid = paymentData.amountPaid;
        payload.balance_refunded = paymentData.balanceRefunded;
      }

      let response;
      if (bookingType === 1 && savedEnquiryId) {
        payload.rawEnquiryData = {
          appointmentList: appointmentList,
          boardingList: boardingList,
          vetClinicList: vetClinicList,
          productList: productList,
          totalSummary: totalSummaryRef.current,
        };
        response = await httpService.put(
          `/vendorenquiry/updateOrderEnquiry/${savedEnquiryId}`,
          payload,
        );
      } else {
        if (bookingType === 1) {
          payload.rawEnquiryData = {
            appointmentList: appointmentList,
            boardingList: boardingList,
            vetClinicList: vetClinicList,
            productList: productList,
            totalSummary: totalSummaryRef.current,
          };
        }
        if(bookingType === 2 && shouldShowPaymentDrawer) {
          payload.isPaying = true;
        }
        response = await httpService.post(
          "/vendorappointment/addBooking",
          payload,
        );
      }

      if (response.status) {
        let message = "";
        switch (bookingType) {
          case 1:
            message = "Enquiry saved successfully!";
            break;
          case 2:
            message = "Booking saved successfully!";
            break;
          case 3:
            message = "Booking saved and payment processed successfully!";
            break;
          default:
            message = "Request processed successfully!";
        }

        toast.success(message, {
          position: "top-center",
        });
         if ((bookingType === 2 || bookingType === 3) && vendorId) {
           await markSetupStepCompleteById(vendorId, "booking");
         }

        if (savedEnquiryId && (bookingType === 2 || bookingType === 3)) {
          await httpService.delete(
            `/vendororderenquiry/deleteOrderEnquiry/${savedEnquiryId}`,
          );
        }
        // ✅ Save adjustment after booking is created/updated
        if (
          (bookingType === 2 || bookingType === 3) &&
          parseFloat(adjustmentAmount) > 0
        ) {
          await saveAdjustmentToOrder(response.data._id, adjustmentAmount);
        }
        if (shouldShowPaymentDrawer) {
          setPaymentOrderId(response.data._id);
          return;
        }
        if ((!savedEnquiryId || !enquiryHardSave) && bookingType === 1) {
          const responseData = response.data;
          if (!savedEnquiryId) setSavedEnquiryId(responseData._id);
        } else if (bookingType === 2 || bookingType === 3) {
          savedBookingOrderRef.current = response.data;

          if (window.refreshOrderData) {
            window.refreshOrderData();
          } else if (window.refreshOrdersList) {
            window.refreshOrdersList();
          }
          if (window.refreshAppointmentData) window.refreshAppointmentData();
          if (window.refreshBookingData) window.refreshBookingData();
          if (window.refreshBoardingData) window.refreshBoardingData();

          const order = response.data;
          const items = order?.order_items || order?.items || [];
          const firstItem = items[0];
          setProceedPopupData({
            isOpen: true,
            orderId: order?._id || order?.order_id,
            highlightRefId:
              firstItem?.ref_id || firstItem?._id || firstItem?.id || null,
            isQueue: firstItem?.is_queue,
          });
        } else {
          if (onSave) {
            onSave(response.data);
          }

          // Refresh orders list after successful booking
          if (window.refreshOrderData) {
            window.refreshOrderData();
          } else if (window.refreshOrdersList) {
            window.refreshOrdersList();
          }

          // Only close drawer for non-payment bookings
          clearSlotSelection();
          handleClose();
        }
      }
    } catch (error) {
      console.error("Error processing booking:", error);

      // ✅ Show specific backend validation messages (e.g., past date)
      const backendMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        null;
      const isPastDateError =
        error?.response?.data?.code === "PAST_DATE_VALIDATION_ERROR" ||
        (backendMessage &&
          backendMessage.toLowerCase().includes("past date"));

      if (isPastDateError) {
        toast.error(
          backendMessage ||
            "Cannot schedule service for a past date. Please update the date.",
          {
            position: "top-center",
            autoClose: 7000,
          }
        );
      } else if (backendMessage) {
        toast.error(backendMessage, {
          position: "top-center",
          autoClose: 5000,
        });
      } else {
        toast.error("Failed to process request. Please try again", {
          position: "top-center",
        });
      }
    } finally {
      setIsBookingLoading(false);
    }
  };

  // Handler for Save as Enquiry
  const handleSaveAsEnquiry = () => {
    if (isBookingLoading) return;
    setEnquiryHardSave(true);
    handleBookingAPI(1);
  };

  // Handler for Save Booking
  const handleSaveBooking = () => {
    if (isBookingLoading) return;
    handleBookingAPI(2);
  };

  // Handler for Pay Now
  const handleSaveAndAddPayment = () => {
    if (isBookingLoading) return;
    if (
      appointmentList?.length === 0 &&
      boardingList?.length === 0 &&
      vetClinicList?.length === 0 &&
      productList?.length === 0
    ) {
      toast.warn("No items to save!", {
        position: "top-center",
      });
      return;
    }
    handleBookingAPI(2, null, true);
    // setShowPaymentSection(true);
  };

  const handleOrderSaveAndPay = async (paymentData) => {
    setIsPaymentLoading(true);
    try {
      // Single payment method validation
      if (!paymentData.method || !paymentData.amount) {
        toast.error("Please fill all payment details", {
          position: "top-center",
        });
        return;
      }

      if (paymentData.method !== "cash" && !paymentData.reference) {
        toast.error("Reference number is required for non-cash payments", {
          position: "top-center",
        });
        return;
      }

      // Combine all items from different lists
      const allItems = [
        ...appointmentList?.map((item) => ({
          ...item,
          type: "appointment",
          quantity: 1,
        })),
        ...boardingList?.map((item) => ({
          ...item,
          type: "boarding",
          quantity: item.duration || 1,
        })),
        ...vetClinicList?.map((item) => ({
          ...item,
          type: "vet_clinic",
          quantity: 1,
        })),
        ...productList?.map((item) => ({
          ...item,
          type: "product",
          quantity: item.quantity || 1,
        })),
      ];

      // Add items to payment data for invoice generation
      const paymentDataWithItems = {
        ...paymentData,
        items: allItems,
        client: clientData,
        totalAmount: parseFloat(totalSummary.total),
        subtotal: parseFloat(totalSummary.subtotal),
        gst: parseFloat(totalSummary.gst),
        discount: parseFloat(totalSummary.discount),
      };

      // Pass the enhanced payment data
      await handleBookingAPI(3, paymentDataWithItems);

      // Show success and close
      toast.success("Payment processed successfully!", {
        position: "top-center",
      });

      // Close payment drawer
      // setShowPaymentSection(false);
    } catch (error) {
      console.error("Error processing payment:", error);
      toast.error("Failed to process payment. Please try again", {
        position: "top-center",
      });
    } finally {
      setIsPaymentLoading(false);
    }
  };

  // Handle product quantity change in enquiry (exact same logic as BookingDetailsDrawer)
  const handleProductQuantityChanges = (item, delta, enquiry) => {
    // Use quantity_available if available, otherwise use original_quantity_available as fallback
    // original_quantity_available preserves the original limit from API response
    const availableQuantity =
      item.quantity_available ||
      item.product_details?.quantity_available ||
      item.original_quantity_available ||
      999;
    const currentQuantity = item.quantity || 1;
    const newQuantity = currentQuantity + delta;

    // If quantity drops to zero or below, don't allow
    if (newQuantity <= 0) {
      toast.warn("Quantity cannot be less than 1", {
        position: "top-center",
      });
      return;
    }

    // Update the enquiry data (same pattern as BookingDetailsDrawer)
    setEnquiryData((prev) =>
      prev.map((e) => {
        if (e._id === enquiry._id) {
          return {
            ...e,
            items: e.items.map((i) => {
              if (i._id === item._id) {
                let finalQuantity = newQuantity;
                let finalTotalPrice =
                  parseFloat(i.price || i.unit_price || 0) * newQuantity;

                // If quantity exceeds available, set to available quantity (same as BookingDetailsDrawer)
                if (newQuantity > availableQuantity) {
                  toast.warn(`Only ${availableQuantity} items available`);
                  finalQuantity = availableQuantity;
                  finalTotalPrice =
                    parseFloat(i.price || i.unit_price || 0) *
                    availableQuantity;
                }

                return {
                  ...i,
                  quantity: finalQuantity,
                  total_price: finalTotalPrice,
                };
              }
              return i;
            }),
          };
        }
        return e;
      }),
    );
  };

  // Handle product quantity input in enquiry (like in BookingDetailsDrawer)
  const handleProductQuantityInputs = (item, value, enquiry) => {
    let qty = parseInt(value, 10);
    if (isNaN(qty) || qty < 1) {
      qty = 1;
    }

    // Use quantity_available if available, otherwise use original_quantity_available as fallback
    // original_quantity_available preserves the original limit from API response
    const maxQuantity =
      item.quantity_available ||
      item.product_details?.quantity_available ||
      item.original_quantity_available ||
      999;
    if (qty > maxQuantity) {
      toast.warn(`Only ${maxQuantity} items available`, {
        position: "top-center",
      });
      qty = maxQuantity;
    }

    // Update the enquiry data with new quantity
    setEnquiryData((prev) =>
      prev.map((e) => {
        if (e._id === enquiry._id) {
          return {
            ...e,
            items: e.items.map((i) => {
              if (i._id === item._id) {
                const updatedItem = {
                  ...i,
                  quantity: qty,
                  total_price: parseFloat(i.price || i.unit_price || 0) * qty,
                };
                return updatedItem;
              }
              return i;
            }),
          };
        }
        return e;
      }),
    );
  };
  const handleEditEnquiryDrawer = (enquiry) => {
    setShowEnquiryDrawer(false);
    setShowEnquiryDraweronCancel(true);
    setSavedEnquiryId(enquiry?._id);
    setIsFromEnquiryList(true);
    fetchDiscountData([
      ...enquiry?.enquiryDetails?.appointmentList,
      ...enquiry?.enquiryDetails?.boardingList,
      ...enquiry?.enquiryDetails?.vetClinicList,
    ]);
  };

  const formatName = (name = "") =>
    name.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

  if (isEnquiryLoading) {
    return <LoaderSpiner message="Loading enquiry details..." />;
  }

  return (
    <>
      {isAddonsDrawerOpen ? (
        <SelectAddOnsDrawer
          isOpen={isAddonsDrawerOpen}
          onClose={handleCloseAddons}
          onSave={handleSaveAddons} // if your drawer supports saving
          serviceCategoryId={addonsServiceCategoryId}
          petType={addonsPetType}
          petTypeId={addonsPetTypeId}
          selectedAddons={selectedAddons}
          serviceTypeName={serviceTypeName}
          drawerWidth={drawerWidth}
        />
      ) : showAddNewPet ? (
        <AddNewPet
          isOpen={showAddNewPet}
          onClose={() => setShowAddNewPet(false)}
          onSave={handlePetSaved}
          onBack={handleAddNewPetBack}
          clientId={clientData?._id}
          shouldHideSaveAndAdd={true}
        />
      ) : showHistoryDrawer ? (
        <CombinedHistoryDrawer
          isOpen={showHistoryDrawer}
          onClose={() => setShowHistoryDrawer(false)}
          clientId={clientData?._id}
          clientData={clientData}
          onReorder={(item) => {
            // Keep your exact reorder behaviour (same as before)
            const editData = {
              ...item,
              service_id: item.service_id,
              vendor_pet_id: item.vendor_pet_id || item.pet_id,
              pet_id: item.vendor_pet_id || item.pet_id,
              // If boarding-like item, force boarding type:
              item_type:
                item.item_type === "boarding"
                  ? "boarding"
                  : item.item_type || "grooming",
              service_type_name:
                item.service_type_name ||
                item.service_name ||
                (item.item_type === "boarding" ? "Boarding" : item.item_type),
              // Pass category id hints for matching
              service_category_type_id:
                item.service_category_type_id || item.service_type_id,
              service_type_id:
                item.service_type_id || item.service_category_type_id,
            };

            // Close history before opening drawer to avoid overlay/back issues
            setShowHistoryDrawer(false);
            setTimeout(() => {
              setItemData({ ...editData, _fromHistoryReorder: true });
              setDrawerEditMode(true);
              setShowPetServiceDrawer(true);
            }, 0);
          }}
        />
      ) : showEnquiryDrawer ? (
        <>
          <EnquiryListDrawer
            setShowEnquiryDrawer={setShowEnquiryDrawer}
            clientData={clientData}
            enquiryData={displayedEnquiries}
            loadingEnquiries={loadingEnquiries}
            expandedEnquiry={expandedEnquiry}
            setExpandedEnquiry={setExpandedEnquiry}
            handleDeleteEnquiry={handleDeleteEnquiry}
            handleProductQuantityChanges={handleProductQuantityChanges}
            handleProductQuantityInputs={handleProductQuantityInputs}
            handleEditEnquiry={handleEditEnquiryDrawer}
          />
          {showEditEnquiryDrawer && (
            <EditEnquiry
              isOpen={showEditEnquiryDrawer}
              onClose={() => {
                setShowEditEnquiryDrawer(false);
                setEditEnquiryData([]);
              }}
              onSave={(data) => {
                handleClose();
              }}
              appointmentStatusRef={appointmentStatusRef}
              enquiryDetails={editEnquiryData}
              clientDetails={clientData}
            />
          )}
        </>
      ) : !showPetServiceDrawer && !showHistoryDrawer && !showEnquiryDrawer && !proceedPopupData.isOpen && !checkinDrawerOpen && !groomingStartedDrawerOpen && !vetStartedDrawerOpen && !boardingStartedDrawerOpen && !checkoutDrawerOpen ? (
        <div
          className={`fixed inset-0 z-50 transition-all duration-300 ease-in-out ${
            isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
          }`}
        >
          <div
            className="absolute inset-0 bg-black bg-opacity-40 backdrop-blur-[2px]"
            onClick={handleClose}
          />
          <div
            className={`absolute right-0 top-0 h-full w-full ${drawerWidth} bg-white shadow-xl transform transition-transform duration-300 ease-out ${
              isOpen ? "translate-x-0" : "translate-x-full"
            }`}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Modern Header */}
            <div className="flex justify-between items-center bg-gradient-to-r from-blue-50 to-indigo-50">
              <div className="flex justify-start items-center p-4 border-b bg-gradient-to-r from-blue-50 to-indigo-50 shadow-sm gap-3">
                {/*<button
                  onClick={
                    showAddClientDrawer
                      ? () => setShowAddClientDrawer(false)
                      : handleClose
                  }
                  className="flex items-center justify-center w-10 h-10 rounded-full hover:bg-white/70 transition-colors duration-200"
                >
                  <HiArrowSmLeft className="w-6 h-6 text-gray-700" />
                </button> */}
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 bg-gradient-to-r from-blue-500 to-indigo-600 rounded-full flex items-center justify-center">
                    {showAddClientDrawer ? (
                      <FiUserPlus className="w-4 h-4 text-white" />
                    ) : (
                      <FiCalendar className="w-4 h-4 text-white" />
                    )}
                  </div>
                  <h2 className="text-xl font-semibold text-gray-800">
                    {showAddClientDrawer
                      ? "Add New Client"
                      : editMode
                        ? "Edit Appointment"
                        : enquiryDetails
                          ? "Edit Enquiry"
                          : `Create New Sale`}
                  </h2>
                </div>
              </div>
            </div>

            {/* Content */}
            {isOpen && (
              <>
                {showAddClientDrawer ? (
                  <AddNewClientAppointment
                    onClose={() => setShowAddClientDrawer(false)}
                    phone={searchPhone}
                    onSave={handleclientSaved}
                    onSaveAndAddPet={handleSaveAndAddPet}
                    isOpen={isOpen}
                  />
                ) : (
                  <div className="flex h-[calc(100vh-73px)] flex-col">
                    <div className="p-6 overflow-y-auto bg-gradient-to-b from-gray-50 to-white flex-1 flex flex-col">
                      <div className="transition-opacity duration-200 flex-1 flex flex-col min-h-full">
                        {/* Client Search Section */}
                        <div className="flex-1 flex flex-col">
                          {!clientData && (
                            <>
                              <label className="block text-sm font-semibold text-gray-700 mb-3 flex items-center gap-2">
                                <FiSearch className="w-4 h-4 text-blue-600" />
                                Select a Client
                              </label>
                              <div className="relative">
                                <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                                  <FiPhone className="w-5 h-5 text-gray-400" />
                                </div>
                                <input
                                  type="number"
                                  placeholder="Enter phone number"
                                  value={searchPhone}
                                  onChange={(e) => {
                                    const numericValue = e.target.value
                                      .replace(/\D/g, "")
                                      .slice(0, 10);
                                    setSearchPhone(numericValue);
                                    searchClientsByPhone(numericValue);
                                    if (numericValue.length === 10) {
                                      fetchClientByPhone(numericValue);
                                    }
                                  }}
                                  onWheel={(e) => e.target.blur()}
                                  className="w-full pl-12 pr-32 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 bg-white shadow-sm"
                                />
                                {/* Add New Client Button */}
                                {!clientData && (
                                  <button
                                    onClick={() => setShowAddClientDrawer(true)}
                                    className="absolute right-2 top-1/2 transform -translate-y-1/2 flex items-center px-3 py-2 text-xs font-medium text-blue-600 bg-blue-50 border border-blue-200 rounded-lg hover:bg-blue-100 hover:text-blue-700 transition-all duration-200"
                                  >
                                    <FiUserPlus className="w-4 h-4 mr-1" />
                                    Add New Client
                                  </button>
                                )}
                              </div>
                            </>
                          )}

                          {/* Dropdown when 3 digits of any phone number entered*/}
                          {showDropdown && !clientData && (
                            <div className="relative z-50 mt-1">
                              <div className="absolute left-0 right-0 bg-white border border-gray-200 rounded-xl shadow-lg overflow-hidden max-h-80 overflow-y-auto">
                                {searchLoading ? (
                                  <div className="flex items-center gap-3 px-4 py-3 text-sm text-gray-500">
                                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-500"></div>
                                    Searching...
                                  </div>
                                ) : searchResults.length === 0 ? (
                                  <div className="px-4 py-3 text-sm text-gray-500">
                                    No clients found
                                  </div>
                                ) : (
                                  searchResults.map((client) => (
                                    <button
                                      key={client._id}
                                      onClick={() => handleSelectClient(client)}
                                      className="w-full flex items-center gap-3 px-4 py-3 hover:bg-blue-50 transition-colors text-left border-b border-gray-100 last:border-b-0"
                                    >
                                      <div className="w-8 h-8 bg-gradient-to-r from-blue-500 to-indigo-600 rounded-full flex items-center justify-center flex-shrink-0">
                                        <FiUser className="w-4 h-4 text-white" />
                                      </div>
                                      <div className="flex-1 min-w-0">
                                        <p className="text-sm font-semibold text-gray-800 truncate">
                                          {client.fullname ||
                                            `${client.firstname || ""} ${client.lastname || ""}`.trim() ||
                                            "User"}
                                        </p>
                                        <p className="text-xs text-gray-500 flex items-center gap-1">
                                          <FiPhone className="w-3 h-3" />
                                          {client.phone}
                                        </p>
                                        
                                      </div>
                                      {client.pets?.length > 0 && (
                                        <span className="text-xs text-gray-400 flex-shrink-0">
                                          {client.pets.length} pet
                                          {client.pets.length > 1 ? "s" : ""}
                                        </span>
                                      )}
                                    </button>
                                  ))
                                )}
                              </div>
                            </div>
                          )}

                          {/* Loading and Error States */}
                          {loading && (
                            <div className="mt-4 flex items-center gap-3 p-4 bg-blue-50 rounded-xl">
                              <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-blue-500"></div>
                              <p className="text-sm text-blue-700">
                                Searching for client...
                              </p>
                            </div>
                          )}
                          {error && (
                            <div className="mt-4 flex items-center gap-3 p-4 bg-red-50 rounded-xl">
                              <div className="w-5 h-5 bg-red-500 rounded-full flex items-center justify-center">
                                <span className="text-white text-xs">!</span>
                              </div>
                              <p className="text-sm text-red-700">{error}</p>
                            </div>
                          )}

                          {/* Client Data Display - Improved Spacing */}
                          {clientData && (
                            <>
                              <div className="space-y-6">
                                <div className="relative p-5 bg-white rounded-xl border border-gray-200 shadow-sm">
                                {/* Mobile-friendly button layout */}
                                <div className="flex flex-col sm:flex-row sm:justify-end sm:items-start gap-2 mb-4 pb-3 border-b border-gray-100"></div>
                                {/* Delete Icon and Top Right Buttons */}
                                <button
                                  onClick={() => {
                                    setSearchPhone("");
                                    setClientData(null);
                                    setError(null);
                                    setOrderItems([]);
                                    setOrderId(null);
                                  }}
                                  className="absolute top-3 right-3 w-6 h-6 flex items-center justify-center text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-full transition-all duration-200"
                                  aria-label="Clear client data"
                                >
                                  <RiCloseCircleFill className="w-4 h-4" />
                                </button>

                                <div className="absolute top-3 right-3 flex gap-2">
                                  <button
                                    onClick={() => setShowEnquiryDrawer(true)}
                                    className="inline-flex items-center gap-2 px-3 py-1.5 bg-purple-500 text-white text-xs font-medium rounded-lg hover:bg-purple-600 transition-all duration-200"
                                  >
                                    <FiSearch className="w-3 h-3" />
                                    <span>View Enquiry</span>
                                    {(clientData?.enquiryStats?.weeklyCount ||
                                      0) > 0 && (
                                      <span
                                        className={`px-2 py-1 rounded-full text-[10px] font-semibold whitespace-nowrap border ${
                                          (clientData?.enquiryStats
                                            ?.weeklyCount || 0) >= 6
                                            ? "bg-white text-purple-700 border-white"
                                            : (clientData?.enquiryStats
                                                  ?.weeklyCount || 0) >= 3
                                              ? "bg-purple-200 text-purple-800 border-purple-200"
                                              : "bg-white/20 text-white border-white/20"
                                        }`}
                                        title={`${
                                          clientData?.enquiryStats
                                            ?.weeklyCount || 0
                                        } ${
                                          (clientData?.enquiryStats
                                            ?.weeklyCount || 0) > 1
                                            ? "enquiries"
                                            : "enquiry"
                                        } made in the last 7 days`}
                                      >
                                        {(clientData?.enquiryStats
                                          ?.weeklyCount || 0) === 1
                                          ? "1 This Week"
                                          : `${clientData?.enquiryStats?.weeklyCount || 0} This Week`}
                                      </span>
                                    )}
                                  </button>
                                  <button
                                    onClick={() => setShowHistoryDrawer(true)}
                                    className="inline-flex items-center gap-1 px-3 py-1.5 bg-blue-500 text-white text-xs font-medium rounded-lg hover:bg-blue-600 transition-all duration-200"
                                  >
                                    <MdHistory className="w-3 h-3" />
                                    Recent Visits
                                  </button>
                                  <button
                                    onClick={() => {
                                      setSearchPhone("");
                                      setClientData(null);
                                      setError(null);
                                      setOrderItems([]);
                                      setOrderId(null);
                                      setAppointmentList([]);
                                    }}
                                    className="inline-flex items-center justify-center w-8 h-8 bg-gray-200 text-gray-600 text-xs font-medium rounded-full hover:bg-gray-300 transition-all duration-200"
                                    title="Remove client and go back to search"
                                  >
                                    <FiX className="w-3 h-3" />
                                  </button>
                                  
                                </div>

                                <div className="space-y-3">
                                  {/* Client Info */}
                                  <div className="flex items-center gap-4">
                                    <div className="w-12 h-12 bg-gradient-to-r from-blue-500 to-indigo-600 rounded-full flex items-center justify-center">
                                      <FiUser className="w-6 h-6 text-white" />
                                    </div>
                                    <div className="flex-1">
                                      <h3 className="text-lg font-semibold text-gray-800 mb-1">
                                        {clientData.firstname}{" "}
                                        {clientData.lastname}
                                      </h3>
                                      <div className="flex items-center gap-8 text-sm text-gray-500">
                                        <span className="flex items-center gap-1">
                                          <FiPhone className="w-3 h-3" />
                                          {clientData.phone}
                                        </span>
                                        <button
                                          onClick={() => setIsEditClientOpen(true)}
                                          className="inline-flex items-center gap-1 px-2 py-1 bg-green-600 text-white text-xs font-medium rounded-md hover:bg-green-700 transition-all duration-200"
                                          title="Edit client"
                                        >
                                          <FiEdit3 className="w-3 h-3" />
                                          Edit
                                        </button>
                                        {clientData.email && (
                                          <span className="flex items-center gap-1">
                                            <FiMail className="w-3 h-3" />
                                            {clientData.email}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                  </div>

                                  {/* Address */}
                                  {clientData.address?.address1 && (
                                    <div className="flex items-center gap-2 text-sm text-gray-600 pl-16">
                                      <FiMapPin className="w-3 h-3" />
                                      <span>
                                        {[
                                          clientData.address.address1,
                                          clientData.address.city,
                                          clientData.address.state,
                                          clientData.address.zip,
                                        ]
                                          .filter(Boolean)
                                          .join(", ")}
                                      </span>
                                      <button
                                        onClick={() => {
                                          const addressString = [
                                            clientData.address.address1,
                                            clientData.address.city,
                                            clientData.address.state,
                                            clientData.address.zip,
                                          ]
                                            .filter(Boolean)
                                            .join(", ");

                                          const destination =
                                            clientData.address?.latitude &&
                                            clientData.address?.longitude
                                              ? `${clientData.address.latitude},${clientData.address.longitude}`
                                              : encodeURIComponent(
                                                  addressString,
                                                );

                                          const googleMapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${destination}`;

                                          Swal.fire({
                                            title: "Get Directions",
                                            text: "Do you want to open Google Maps for directions?",
                                            icon: "question",
                                            showCancelButton: true,
                                            confirmButtonColor: "#3085d6",
                                            cancelButtonColor: "#d33",
                                            confirmButtonText: "Yes",
                                            cancelButtonText: "No",
                                          }).then((result) => {
                                            if (result.isConfirmed) {
                                              window.open(
                                                googleMapsUrl,
                                                "_blank",
                                              );
                                            }
                                          });
                                        }}
                                        className="inline-flex items-center gap-1 px-3 py-2 text-sm font-medium bg-orange-100 text-orange-600 rounded-lg hover:bg-orange-200 transition-all duration-200 shadow hover:shadow-md flex-shrink-0"
                                        title="Get Directions"
                                      >
                                        <FaDirections className="w-3 h-3" />
                                        Directions
                                      </button>
                                    </div>
                                  )}

                                  {/* Labels */}
                                  {clientData.labels &&
                                    clientData.labels.length > 0 &&
                                    clientData.labels.some(
                                      (label) => label && label.trim() !== "",
                                    ) && (
                                      <div className="flex items-center gap-2 pl-16">
                                        <div className="flex flex-wrap gap-2">
                                          {clientData.labels.map(
                                            (labelString, index) => {
                                              const individualLabels =
                                                labelString
                                                  .split(",")
                                                  .map((label) => label.trim());
                                              return individualLabels.map(
                                                (label, labelIndex) => {
                                                  if (!label) return null;
                                                  return (
                                                    <span
                                                      key={`${index}-${labelIndex}`}
                                                      className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-purple-100 text-purple-700"
                                                    >
                                                      {label}
                                                    </span>
                                                  );
                                                },
                                              );
                                            },
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  {clientData.pets &&
                                  clientData.pets.length > 0 ? (
                                    <div className="mt-2 text-sm text-gray-700">
                                      <div className="flex items-center gap-2">
                                        <div className="flex-1 min-w-0">
                                          <div className="inline-flex flex-wrap items-center gap-1 text-sm leading-none">
                                            {clientData.pets
                                              .filter(
                                                (pet) =>
                                                  pet.status?.toLowerCase() !==
                                                  "inactive",
                                              )
                                              .map((pet, idx) => {
                                                // ✅ SAFE: Get size initial
                                                const sizeLabel =
                                                  pet.size_details?.size_label;
                                                const size =
                                                  sizeLabel &&
                                                  typeof sizeLabel ===
                                                    "string" &&
                                                  sizeLabel.trim() !== ""
                                                    ? sizeLabel
                                                        .charAt(0)
                                                        .toUpperCase()
                                                    : null;

                                                const details = size
                                                  ? `${size}`
                                                  : null;

                                                // Title can also just show name and size
                                                const titleParts = [
                                                  pet.name,
                                                  size,
                                                ].filter(Boolean);
                                                const title =
                                                  titleParts.join(", ");

                                                // Determine icon based on pet type
                                                let PetIcon = FaPaw;
                                                if (
                                                  pet.pet_type_details?.name ===
                                                  "Dog"
                                                )
                                                  PetIcon = FaDog;
                                                else if (
                                                  pet.pet_type_details?.name ===
                                                  "Cat"
                                                )
                                                  PetIcon = FaCat;

                                                return (
                                                  <span
                                                    key={pet._id ?? idx}
                                                    className="inline-flex items-center gap-1 text-gray-700"
                                                    title={title}
                                                    aria-label={`Pet ${pet.name}`}
                                                  >
                                                    <PetIcon
                                                      className="w-3 h-3"
                                                      aria-hidden="true"
                                                    />
                                                    <strong className="text-gray-800 truncate max-w-[12rem]">
                                                      {pet.name}
                                                    </strong>
                                                    {details && (
                                                      <span className="text-gray-500">
                                                        ({details})
                                                      </span>
                                                    )}
                                                    {idx !==
                                                      clientData.pets.length -
                                                        1 && (
                                                      <span
                                                        className="mx-1 text-gray-300"
                                                        aria-hidden="true"
                                                      >
                                                        ,
                                                      </span>
                                                    )}
                                                  </span>
                                                );
                                              })}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ) : null}
                                  {clientData &&
                                    clientData.isActive === false && (
                                      <div className="mt-4 p-3 bg-red-50 border border-red-200 rounded-lg flex items-start gap-2">
                                        <FiAlertCircle className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" />
                                        <div>
                                          <p className="text-sm font-medium text-red-800">
                                            Client Disabled
                                          </p>
                                          <p className="text-xs text-red-600">
                                            This client has been disabled. You
                                            cannot add new pets/services or
                                            create bookings for this client
                                            until they are enabled.
                                          </p>
                                        </div>
                                      </div>
                                    )}
                                </div>
                              </div>

                              {/* Service List Display - Appointments, Boarding, and Vet Clinic */}
                              {/* ================== PER-SERVICE TABLE VIEW ================== */}
                              {(appointmentList?.length > 0 ||
                                boardingList?.length > 0 ||
                                vetClinicList?.length > 0 ||
                                productList?.length > 0) && (
                                <div className="mt-6 space-y-4">
                                  {/* ---------- PART 1: APPOINTMENTS ---------- */}
                                  {appointmentList?.map((appointment, index) => {
                                    if (!appointment) return null;
                                    const qty = 1;

                                    // MRP per unit (tax-inclusive, pre-discount)
                                    const mrpPerUnit = Number(
                                      appointment.price ||
                                        appointment.original_unit_price ||
                                        appointment.unit_price ||
                                        0,
                                    );

                                    // Discount per unit
                                    const activeDiscount = appointment?.discounts?.find(
                                      (d) => Number(d.is_active) === 1,
                                    );
                                    const discountPerUnit = activeDiscount
                                      ? Number(activeDiscount.discount_amount || 0) ||
                                        (activeDiscount.type === "percentage"
                                          ? (mrpPerUnit * Number(activeDiscount.value || 0)) / 100
                                          : Number(activeDiscount.value || 0))
                                      : Number(appointment.discount_amount || 0);

                                    // Tax per unit
                                    const taxPerUnit = Number(
                                      appointment.discounted_tax ||
                                        appointment.gst ||
                                        appointment.tax_amount ||
                                        0,
                                    );

                                    // Totals (× qty)
                                    const mrpTotal = mrpPerUnit * qty;
                                    const discountTotal = discountPerUnit * qty;
                                    const taxTotal = taxPerUnit * qty;
                                    const grandTotal = (mrpPerUnit - discountPerUnit) * qty;

                                    const typeLabel =
                                      appointment.item_type === "day_care" ||
                                      appointment.item_type === "daycare"
                                        ? "Day Care"
                                        : appointment.item_type === "dog_walking"
                                          ? "Dog Walking"
                                          : "Grooming";

                                    return (
                                      <div
                                        key={`apt-wrap-${index}`}
                                        className="overflow-hidden rounded-lg border border-gray-200 shadow-sm bg-white"
                                      >
                                        {/* ===== Header: only type badge + actions ===== */}
                                        <div className="flex flex-wrap items-center justify-between gap-3 px-3 py-2 bg-orange-50 border-b border-orange-100">
                                          <div className="flex items-center gap-2 min-w-0 flex-wrap">
                                            <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-orange-100 text-orange-700 shrink-0">
                                              <MdContentCut className="w-3 h-3" />
                                              {typeLabel}
                                            </span>
                                          </div>
                                          <div className="flex items-center gap-2 shrink-0">
                                            <button
                                              onClick={() =>
                                                handleOpenProductsDrawer(
                                                  appointment,
                                                  index,
                                                  "appointmentList",
                                                )
                                              }
                                              className="inline-flex items-center gap-1 px-2 py-1 rounded-md bg-teal-600 text-white text-xs font-medium hover:bg-teal-700 transition"
                                            >
                                              <FaPlus className="w-2.5 h-2.5" /> Product
                                            </button>
                                            <button
                                              onClick={() =>
                                                handleOpenAddonsDrawer(
                                                  appointment,
                                                  index,
                                                  "appointmentList",
                                                )
                                              }
                                              className="inline-flex items-center gap-1 px-2 py-1 rounded-md bg-green-600 text-white text-xs font-medium hover:bg-green-700 transition"
                                            >
                                              <FaPlus className="w-2.5 h-2.5" /> Add-on
                                            </button>
                                            <button
                                              onClick={() =>
                                                handleOpenOtherChargesDrawer(
                                                  appointment,
                                                  index,
                                                  "appointmentList",
                                                )
                                              }
                                              className="inline-flex items-center gap-1 px-2 py-1 rounded-md bg-purple-600 text-white text-xs font-medium hover:bg-purple-700 transition"
                                            >
                                              <FaPlus className="w-2.5 h-2.5" /> Other Charge
                                            </button>
                                            <span className="w-px h-5 bg-orange-200 mx-1" />
                                            <button
                                              onClick={() => {
                                                setIsServiceEditMode(true);
                                                handleEditAppointmentFromList(appointment, index);
                                              }}
                                              className="w-6 h-6 rounded-full bg-white hover:bg-gray-100 flex items-center justify-center"
                                              title="Edit"
                                            >
                                              <FiEdit3 className="w-3 h-3 text-gray-600" />
                                            </button>
                                            <button
                                              onClick={() => handleDeleteAppointmentFromList(index)}
                                              className="w-6 h-6 rounded-full bg-white hover:bg-red-100 flex items-center justify-center"
                                              title="Delete"
                                            >
                                              <FiTrash2 className="w-3 h-3 text-gray-600 hover:text-red-600" />
                                            </button>
                                          </div>
                                        </div>

                                        {/* ===== Financial table ===== */}
                                        <table className="min-w-full text-sm">
                                          <thead className="bg-gray-50 text-gray-600 uppercase text-xs tracking-wider">
                                            <tr>
                                              <th className="px-3 py-2 text-left min-w-[280px]">Line</th>
                                              <th className="px-2 py-2 text-center w-12">Qty</th>
                                              <th className="px-3 py-2 text-right">MRP (incl. tax)/Unit</th>
                                              <th className="px-3 py-2 text-right">Discount</th>
                                              <th className="px-3 py-2 text-right">Tax</th>
                                              <th className="px-3 py-2 text-right">Total</th>
                                              <th className="px-3 py-2 text-right w-10"></th>
                                            </tr>
                                          </thead>
                                          <tbody className="divide-y divide-gray-100">
                                            {/* Main service row — all details stacked in Line column */}
                                            <tr>
                                              <td className="px-3 py-2 align-top">
                                                <div className="flex flex-col gap-0.5">
                                                  {/* Row 1: Pet details + Staff inline */}
                                                  <div className="flex items-center gap-2 flex-wrap leading-tight">
                                                    <span className="text-gray-800 inline-flex items-center gap-1 font-semibold">
                                                      <FaDog className="w-3 h-3 text-orange-500" />
                                                      {appointment.pet_name || "-"}
                                                      {appointment.pet_breed ? ` (${appointment.pet_breed})` : ""}
                                                      {appointment.pet_size ? ` • ${appointment.pet_size}` : ""}
                                                    </span>
                                                    <span className="text-gray-300">•</span>
                                                    {appointment.employee_name ? (
                                                      <span className="text-gray-600 inline-flex items-center gap-1">
                                                        <FaUserTie className="w-3 h-3 text-purple-500" />
                                                        {appointment.employee_name}
                                                      </span>
                                                    ) : (
                                                      <span className="text-red-500 italic inline-flex items-center gap-1">
                                                        <FaUserTie className="w-3 h-3 text-red-400" />
                                                        Staff not assigned
                                                      </span>
                                                    )}
                                                  </div>
                                                  
                                                  {/* Row 2: Service name */}
                                                  <span className="font-semibold text-gray-800 leading-tight">
                                                    {appointment.service_name || "Service"}
                                                  </span>

                                                  {/* Row 3: Date + Time + Duration */}
                                                  {appointment.start_date ? (
                                                    <span className="text-gray-600 inline-flex items-center gap-1 leading-tight">
                                                      <FaCalendar className="w-3 h-3 text-blue-500" />
                                                      {safeFormatDate(appointment.start_date)?.toLocaleDateString(
                                                        "en-IN",
                                                        {
                                                          day: "2-digit",
                                                          month: "short",
                                                          year: "numeric",
                                                        },
                                                      )}
                                                      {appointment.start_time ? ` • ${appointment.start_time}` : ""}
                                                      {appointment.duration ? ` • ${appointment.duration}` : ""}
                                                    </span>
                                                  ) : (
                                                    <span className="text-red-500 italic inline-flex items-center gap-1 leading-tight">
                                                      <FaCalendar className="w-3 h-3 text-red-400" />
                                                      Date not selected
                                                    </span>
                                                  )}
                                                </div>
                                              </td>
                                              <td className="px-2 py-2 text-center align-top text-sm">{qty}</td>
                                              <td className="px-3 py-2 text-right whitespace-nowrap align-top">
                                                ₹{mrpTotal.toFixed(2)}
                                              </td>
                                              <td className="px-3 py-2 text-right whitespace-nowrap text-red-600 align-top">
                                                {discountTotal > 0 ? `− ₹${discountTotal.toFixed(2)}` : "—"}
                                              </td>
                                              <td className="px-3 py-2 text-right whitespace-nowrap text-gray-600 align-top">
                                                ₹{taxTotal.toFixed(2)}
                                              </td>
                                              <td className="px-3 py-2 text-right whitespace-nowrap text-green-700 font-semibold align-top">
                                                ₹{grandTotal.toFixed(2)}
                                              </td>
                                              <td className="px-3 py-2 align-top"></td>
                                            </tr>

                                            {/* Add-ons nested */}
                                            {appointment.addons?.map((addon, aIdx) => {
                                              const amt = Number(addon.addon_price || addon.price || 0);
                                              return (
                                                <tr
                                                  key={`apt-${index}-addon-${aIdx}`}
                                                  className="bg-green-50/40"
                                                >
                                                  <td className="px-3 py-1.5 pl-6">
                                                    <span className="inline-flex items-center gap-1">
                                                      <FiCheck className="w-3 h-3 text-green-600" />
                                                      <span className="text-green-700 text-[10px] font-semibold uppercase mr-1">
                                                        Add-on
                                                      </span>
                                                      {addon.addon_name || addon.name || `Add-on ${aIdx + 1}`}
                                                    </span>
                                                  </td><td className="px-2 py-1.5 text-center text-[12px]">1</td>
                                                  <td className="px-3 py-1.5 text-right">₹{amt.toFixed(2)}</td>
                                                  <td className="px-3 py-1.5 text-right text-red-600">—</td>
                                                  <td className="px-3 py-1.5 text-right text-gray-600">—</td>
                                                  <td className="px-3 py-1.5 text-right text-green-700 font-semibold">
                                                    ₹{amt.toFixed(2)}
                                                  </td>
                                                  <td className="px-3 py-1.5 text-right">
                                                    <button
                                                      onClick={() =>
                                                        handleDeleteAddon("appointmentList", index, aIdx)
                                                      }
                                                      className="text-red-500 hover:text-red-700"
                                                      title="Remove add-on"
                                                    >
                                                      <FiTrash2 className="w-3 h-3" />
                                                    </button>
                                                  </td>
                                                </tr>
                                              );
                                            })}

                                            {/* Products nested */}
                                            {appointment.products?.map((product, pIdx) => {
                                              const qtyP = Number(product.quantity || 1);
                                              const mrpP = Number(
                                                product.mrp_price || product.unit_price || 0,
                                              );
                                              const discP = Number(Number(product.amount_before_discount || 0) - Number(product.amount_after_discount || 0));
                                              const taxP = Number(product.gst || product.gstAmount || 0);
                                              const mrpT = mrpP * qtyP;
                                              const discT = discP * qtyP;
                                              const taxT = taxP * qtyP;
                                              const totalP = Number(product?.effective_sale_price || mrpP) * qtyP;
                                              return (
                                                <tr
                                                  key={`apt-${index}-prod-${pIdx}`}
                                                  className="bg-blue-50/40"
                                                >
                                                  <td className="px-3 py-1.5 pl-6">
                                                    <span className="inline-flex items-center gap-1">
                                                      <MdShoppingCart className="w-3 h-3 text-blue-600" />
                                                      <span className="text-blue-700 text-[10px] font-semibold uppercase mr-1">
                                                        Product
                                                      </span>
                                                      {product.product_name || product.name}
                                                      {product.gst_slab > 0 && (
                                                        <span className="italic text-[10px] text-gray-500">
                                                          (gst {product.gst_slab}%)
                                                        </span>
                                                      )}
                                                    </span>
                                                  </td>
                                                  <td className="px-3 py-1.5 text-center">
                                                    <div className="inline-flex items-center gap-1">
                                                      {qtyP > 1 ? (
                                                        <button
                                                          onClick={() =>
                                                            handleDecrementProduct(
                                                              "appointmentList",
                                                              index,
                                                              pIdx,
                                                            )
                                                          }
                                                          className="text-gray-600 hover:text-black"
                                                        >
                                                          <FiMinus className="w-3 h-3" />
                                                        </button>
                                                      ) : (
                                                        <button
                                                          onClick={() =>
                                                            handleDeleteProduct(
                                                              "appointmentList",
                                                              index,
                                                              pIdx,
                                                            )
                                                          }
                                                          className="text-gray-600 hover:text-red-600"
                                                        >
                                                          <FiTrash2 className="w-3 h-3" />
                                                        </button>
                                                      )}
                                                      <span className="w-5 text-center">{qtyP}</span>
                                                      <button
                                                        onClick={() =>
                                                          handleIncrementProduct(
                                                            "appointmentList",
                                                            index,
                                                            pIdx,
                                                          )
                                                        }
                                                        className="text-gray-600 hover:text-black"
                                                      >
                                                        <FiPlus className="w-3 h-3" />
                                                      </button>
                                                    </div>
                                                  </td>
                                                  <td className="px-3 py-1.5 text-right">₹{mrpP.toFixed(2)}</td>
                                                  <td className="px-3 py-1.5 text-right text-red-600">
                                                    {discT > 0 ? `− ₹${discT.toFixed(2)}` : "—"}
                                                  </td>
                                                  <td className="px-3 py-1.5 text-right text-gray-600">
                                                    ₹{taxT.toFixed(2)}
                                                  </td>
                                                  <td className="px-3 py-1.5 text-right text-green-700 font-semibold">
                                                    ₹{totalP.toFixed(2)}
                                                  </td>
                                                  <td className="px-3 py-1.5 text-right">
                                                    <button
                                                      onClick={() =>
                                                        handleDeleteProduct(
                                                          "appointmentList",
                                                          index,
                                                          pIdx,
                                                        )
                                                      }
                                                      className="text-gray-600 hover:text-red-600"
                                                      title="Remove product"
                                                    >
                                                      <FiTrash2 className="w-3 h-3" />
                                                    </button>
                                                  </td>
                                                </tr>
                                              );
                                            })}

                                            {/* Other charges nested */}
                                            {appointment.otherCharges?.map((charge, cIdx) => {
                                              const amt = Number(charge.amount || 0);
                                              return (
                                                <tr
                                                  key={`apt-${index}-charge-${cIdx}`}
                                                  className="bg-purple-50/40"
                                                >
                                                  <td className="px-3 py-1.5 pl-6">
                                                    <span className="inline-flex items-center gap-1">
                                                      <FiAlertCircle className="w-3 h-3 text-purple-600" />
                                                      <span className="text-purple-700 text-[10px] font-semibold uppercase mr-1">
                                                        Other Charge
                                                      </span>
                                                      {charge.description || charge.name}
                                                    </span>
                                                  </td>
                                                  <td className="px-2 py-1.5 text-center text-[12px]">1</td>
                                                  <td className="px-3 py-1.5 text-right">₹{amt.toFixed(2)}</td>
                                                  <td className="px-3 py-1.5 text-right text-red-600">—</td>
                                                  <td className="px-3 py-1.5 text-right text-gray-600">—</td>
                                                  <td className="px-3 py-1.5 text-right text-green-700 font-semibold">
                                                    ₹{amt.toFixed(2)}
                                                  </td>
                                                  <td className="px-3 py-1.5 text-right">
                                                    <button
                                                      onClick={() =>
                                                        handleDeleteOtherCharge(
                                                          "appointmentList",
                                                          index,
                                                          cIdx,
                                                        )
                                                      }
                                                      className="text-gray-600 hover:text-red-600"
                                                      title="Remove Other Charge"
                                                    >
                                                      <FiTrash2 className="w-3 h-3" />
                                                    </button>
                                                  </td>
                                                </tr>
                                              );
                                            })}
                                          </tbody>
                                        </table>
                                      </div>
                                    );
                                  })}

                                  {/* PART 2 will open here — do NOT close the outer wrapper yet */}
                                  {/* ---------- PART 2: BOARDING ---------- */}
                                  {boardingList?.map((boarding, index) => {
                                    if (!boarding) return null;
                                    const qty = Number(boarding.duration || 1);

                                    // MRP per day (tax-inclusive, pre-discount)
                                    const mrpPerDay = Number(
                                      boarding.price_per_day || boarding.unit_price || 0,
                                    );

                                    // For boarding, discount_amount & gst are stored as TOTALS across all days
                                    const discountTotal = Number(boarding.discount_amount || 0);
                                    const taxTotal = Number(
                                      boarding.discounted_tax || boarding.gst || 0,
                                    );

                                    const mrpTotal = mrpPerDay * qty;
                                    const grandTotal = mrpPerDay * qty - discountTotal;

                                    return (
                                      <div
                                        key={`board-wrap-${index}`}
                                        className="overflow-hidden rounded-lg border border-gray-200 shadow-sm bg-white"
                                      >
                                        {/* ===== Header ===== */}
                                        <div className="flex flex-wrap items-center justify-between gap-3 px-3 py-2 bg-purple-50 border-b border-purple-100">
                                          <div className="flex items-center gap-2 min-w-0 flex-wrap">
                                            <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-purple-100 text-purple-700 shrink-0">
                                              <MdLocalHotel className="w-3 h-3" /> Boarding
                                            </span>
                                          </div>
                                          <div className="flex items-center gap-2 shrink-0">
                                            <button
                                              onClick={() =>
                                                handleOpenProductsDrawer(boarding, index, "boardingList")
                                              }
                                              className="inline-flex items-center gap-1 px-2 py-1 rounded-md bg-teal-600 text-white text-xs font-medium hover:bg-teal-700 transition"
                                            >
                                              <FaPlus className="w-2.5 h-2.5" /> Product
                                            </button>
                                            <button
                                              onClick={() =>
                                                handleOpenAddonsDrawer(boarding, index, "boardingList")
                                              }
                                              className="inline-flex items-center gap-1 px-2 py-1 rounded-md bg-green-600 text-white text-xs font-medium hover:bg-green-700 transition"
                                            >
                                              <FaPlus className="w-2.5 h-2.5" /> Add-on
                                            </button>
                                            <button
                                              onClick={() =>
                                                handleOpenOtherChargesDrawer(boarding, index, "boardingList")
                                              }
                                              className="inline-flex items-center gap-1 px-2 py-1 rounded-md bg-purple-600 text-white text-xs font-medium hover:bg-purple-700 transition"
                                            >
                                              <FaPlus className="w-2.5 h-2.5" /> Other Charge
                                            </button>
                                            <span className="w-px h-5 bg-purple-200 mx-1" />
                                            <button
                                              onClick={() => handleEditBoardingFromList(boarding, index)}
                                              className="w-6 h-6 rounded-full bg-white hover:bg-gray-100 flex items-center justify-center"
                                              title="Edit"
                                            >
                                              <FiEdit3 className="w-3 h-3 text-gray-600" />
                                            </button>
                                            <button
                                              onClick={() => handleDeleteBoardingFromList(index)}
                                              className="w-6 h-6 rounded-full bg-white hover:bg-red-100 flex items-center justify-center"
                                              title="Delete"
                                            >
                                              <FiTrash2 className="w-3 h-3 text-gray-600" />
                                            </button>
                                          </div>
                                        </div>

                                        {/* ===== Table ===== */}
                                        <table className="min-w-full text-sm">
                                          <thead className="bg-gray-50 text-gray-600 uppercase text-xs tracking-wider">
                                            <tr>
                                              <th className="px-3 py-2 text-left min-w-[280px]">Line</th>
                                              <th className="px-3 py-2 text-center w-12">Qty</th>
                                              <th className="px-3 py-2 text-right">MRP (incl. tax)/Unit</th>
                                              <th className="px-3 py-2 text-right">Discount</th>
                                              <th className="px-3 py-2 text-right">Tax</th>
                                              <th className="px-3 py-2 text-right">Total</th>
                                              <th className="px-3 py-2 text-right w-10"></th>
                                            </tr>
                                          </thead>
                                          <tbody className="divide-y divide-gray-100">
                                            {/* Main boarding row */}
                                            <tr>
                                              <td className="px-3 py-2 align-top">
                                                <div className="flex flex-col gap-0.5">
                                                  {/* Row 1: Service name / room type display */}
                                                  <span className="font-semibold text-gray-800 leading-tight">
                                                    {getBoardingDisplayText(boarding)}
                                                  </span>

                                                  {/* Row 2: Pet details + Room details inline */}
                                                  <div className="flex items-center gap-2 flex-wrap leading-tight">
                                                    <span className="text-gray-500 inline-flex items-center gap-1 font-semibold">
                                                      <FaDog className="w-3 h-3 text-orange-500" />
                                                      {boarding.pet_name || "-"}
                                                      {boarding.pet_breed ? ` (${boarding.pet_breed})` : ""}
                                                    </span>
                                                    {boarding.room_type_name || boarding.room_name || boarding.room_number ? (
                                                      <>
                                                        <span className="text-gray-300">•</span>
                                                        <span className="text-gray-600 inline-flex items-center gap-1">
                                                          <FiHome className="w-3 h-3 text-indigo-500" />
                                                          {boarding.room_type_name || boarding.room_name || "Room"}
                                                          {boarding.room_number ? ` — ${boarding.room_number}` : ""}
                                                        </span>
                                                      </>
                                                    ) : (
                                                      <>
                                                        <span className="text-gray-300">•</span>
                                                        <span className="text-red-500 italic inline-flex items-center gap-1">
                                                          <FiHome className="w-3 h-3 text-red-400" />
                                                          Room not selected
                                                        </span>
                                                      </>
                                                    )}
                                                  </div>

                                                  {/* Row 3: In → Out + nights */}
                                                  {boarding.start_date && boarding.end_date ? (
                                                    <span className="text-gray-600 inline-flex items-center gap-1 leading-tight">
                                                      <FaCalendar className="w-3 h-3 text-blue-500" />
                                                      In:{" "}
                                                      {safeFormatDate(boarding.start_date)?.toLocaleDateString(
                                                        "en-IN",
                                                        { day: "2-digit", month: "short" },
                                                      )}
                                                      {" "}→ Out:{" "}
                                                      {safeFormatDate(boarding.end_date)?.toLocaleDateString(
                                                        "en-IN",
                                                        { day: "2-digit", month: "short" },
                                                      )}
                                                      {" "}• {qty} day{qty > 1 ? "s" : ""}
                                                    </span>
                                                  ) : (
                                                    <span className="text-red-500 italic inline-flex items-center gap-1 leading-tight">
                                                      <FaCalendar className="w-3 h-3 text-red-400" />
                                                      Dates not selected
                                                    </span>
                                                  )}
                                                </div>
                                              </td>
                                              <td className="px-2 py-2 text-center align-top text-sm">1</td>
                                              <td className="px-3 py-2 text-right whitespace-nowrap align-top">
                                                ₹{mrpTotal.toFixed(2)}
                                              </td>
                                              <td className="px-3 py-2 text-right whitespace-nowrap text-red-600 align-top">
                                                {discountTotal > 0 ? `− ₹${discountTotal.toFixed(2)}` : "—"}
                                              </td>
                                              <td className="px-3 py-2 text-right whitespace-nowrap text-gray-600 align-top">
                                                ₹{taxTotal.toFixed(2)}
                                              </td>
                                              <td className="px-3 py-2 text-right whitespace-nowrap text-green-700 font-semibold align-top">
                                                ₹{grandTotal.toFixed(2)}
                                              </td>
                                              <td className="px-3 py-2 align-top"></td>
                                            </tr>

                                            {/* Add-ons */}
                                            {boarding.addons?.map((addon, aIdx) => {
                                              const amt = Number(addon.addon_price || addon.price || 0);
                                              return (
                                                <tr
                                                  key={`board-${index}-addon-${aIdx}`}
                                                  className="bg-green-50/40"
                                                >
                                                  <td className="px-3 py-1.5 pl-6">
                                                    <span className="inline-flex items-center gap-1">
                                                      <FiCheck className="w-3 h-3 text-green-600" />
                                                      <span className="text-green-700 text-[10px] font-semibold uppercase mr-1">
                                                        Add-on
                                                      </span>
                                                      {addon.addon_name || addon.name || `Add-on ${aIdx + 1}`}
                                                    </span>
                                                  </td>
                                                  <td className="px-2 py-1.5 text-center text-[12px]">1</td>
                                                  <td className="px-3 py-1.5 text-right">₹{amt.toFixed(2)}</td>
                                                  <td className="px-3 py-1.5 text-right text-red-600">—</td>
                                                  <td className="px-3 py-1.5 text-right text-gray-600">—</td>
                                                  <td className="px-3 py-1.5 text-right text-green-700 font-semibold">
                                                    ₹{amt.toFixed(2)}
                                                  </td>
                                                  <td className="px-3 py-1.5 text-right">
                                                    <button
                                                      onClick={() =>
                                                        handleDeleteAddon("boardingList", index, aIdx)
                                                      }
                                                      className="text-gray-600 hover:text-red-600"
                                                      title="Remove add-on"
                                                    >
                                                      <FiTrash2 className="w-3 h-3" />
                                                    </button>
                                                  </td>
                                                </tr>
                                              );
                                            })}

                                            {/* Products */}
                                            {boarding.products?.map((product, pIdx) => {
                                              const qtyP = Number(product.quantity || 1);
                                              const mrpP = Number(
                                                product.mrp_price || product.unit_price || 0,
                                              );
                                              const discP = Number(Number(product.amount_before_discount || 0) - Number(product.amount_after_discount || 0));
                                              const taxP = Number(product.gst || product.gstAmount || 0);
                                              const mrpT = mrpP * qtyP;
                                              const discT = discP * qtyP;
                                              const taxT = taxP * qtyP;
                                              const totalP = Number(product?.effective_sale_price || mrpP) * qtyP;
                                              return (
                                                <tr
                                                  key={`board-${index}-prod-${pIdx}`}
                                                  className="bg-blue-50/40"
                                                >
                                                  <td className="px-3 py-1.5 pl-6">
                                                    <span className="inline-flex items-center gap-1">
                                                      <MdShoppingCart className="w-3 h-3 text-blue-600" />
                                                      <span className="text-blue-700 text-[10px] font-semibold uppercase mr-1">
                                                        Product
                                                      </span>
                                                      {product.product_name || product.name}
                                                      {product.gst_slab > 0 && (
                                                        <span className="italic text-[10px] text-gray-500">
                                                          (gst {product.gst_slab}%)
                                                        </span>
                                                      )}
                                                    </span>
                                                  </td>
                                                  <td className="px-3 py-1.5 text-center">
                                                    <div className="inline-flex items-center gap-1">
                                                      {qtyP > 1 ? (
                                                        <button
                                                          onClick={() =>
                                                            handleDecrementProduct(
                                                              "boardingList",
                                                              index,
                                                              pIdx,
                                                            )
                                                          }
                                                          className="text-gray-600 hover:text-black"
                                                        >
                                                          <FiMinus className="w-3 h-3" />
                                                        </button>
                                                      ) : (
                                                        <button
                                                          onClick={() =>
                                                            handleDeleteProduct(
                                                              "boardingList",
                                                              index,
                                                              pIdx,
                                                            )
                                                          }
                                                          className="text-gray-600 hover:text-red-600"
                                                        >
                                                          <FiTrash2 className="w-3 h-3" />
                                                        </button>
                                                      )}
                                                      <span className="w-5 text-center">{qtyP}</span>
                                                      <button
                                                        onClick={() =>
                                                          handleIncrementProduct(
                                                            "boardingList",
                                                            index,
                                                            pIdx,
                                                          )
                                                        }
                                                        className="text-gray-600 hover:text-black"
                                                      >
                                                        <FiPlus className="w-3 h-3" />
                                                      </button>
                                                    </div>
                                                  </td>
                                                  <td className="px-3 py-1.5 text-right">₹{mrpP.toFixed(2)}</td>
                                                  <td className="px-3 py-1.5 text-right text-red-600">
                                                    {discT > 0 ? `− ₹${discT.toFixed(2)}` : "—"}
                                                  </td>
                                                  <td className="px-3 py-1.5 text-right text-gray-600">
                                                    ₹{taxT.toFixed(2)}
                                                  </td>
                                                  <td className="px-3 py-1.5 text-right text-green-700 font-semibold">
                                                    ₹{totalP.toFixed(2)}
                                                  </td>
                                                  <td className="px-3 py-1.5 text-right">
                                                    <button
                                                      onClick={() =>
                                                        handleDeleteProduct(
                                                          "boardingList",
                                                          index,
                                                          pIdx,
                                                        )
                                                      }
                                                      className="text-gray-600 hover:text-red-600"
                                                      title="Remove product"
                                                    >
                                                      <FiTrash2 className="w-3 h-3" />
                                                    </button>
                                                  </td>
                                                </tr>
                                              );
                                            })}

                                            {/* Other charges */}
                                            {boarding.otherCharges?.map((charge, cIdx) => {
                                              const amt = Number(charge.amount || 0);
                                              return (
                                                <tr
                                                  key={`board-${index}-charge-${cIdx}`}
                                                  className="bg-purple-50/40"
                                                >
                                                  <td className="px-3 py-1.5 pl-6">
                                                    <span className="inline-flex items-center gap-1">
                                                      <FiAlertCircle className="w-3 h-3 text-purple-600" />
                                                      <span className="text-purple-700 text-[10px] font-semibold uppercase mr-1">
                                                        Other Charge
                                                      </span>
                                                      {charge.description || charge.name}
                                                    </span>
                                                  </td>
                                                  <td className="px-2 py-1.5 text-center text-[12px]">1</td>
                                                  <td className="px-3 py-1.5 text-right">₹{amt.toFixed(2)}</td>
                                                  <td className="px-3 py-1.5 text-right text-red-600">—</td>
                                                  <td className="px-3 py-1.5 text-right text-gray-600">—</td>
                                                  <td className="px-3 py-1.5 text-right text-green-700 font-semibold">
                                                    ₹{amt.toFixed(2)}
                                                  </td>
                                                  <td className="px-3 py-1.5 text-right">
                                                    <button
                                                      onClick={() =>
                                                        handleDeleteOtherCharge(
                                                          "boardingList",
                                                          index,
                                                          cIdx,
                                                        )
                                                      }
                                                      className="text-red-500 hover:text-red-700"
                                                      title="Remove Other Charge"
                                                    >
                                                      <FiTrash2 className="w-3 h-3" />
                                                    </button>
                                                  </td>
                                                </tr>
                                              );
                                            })}
                                          </tbody>
                                        </table>
                                      </div>
                                    );
                                  })}

                                  {/* PART 3 will open here — outer wrapper still open */}
                                  {/* ---------- PART 3: VET CLINIC ---------- */}
                                  {vetClinicList?.map((vetClinic, index) => {
                                    if (!vetClinic) return null;
                                    const qty = 1;

                                    // MRP per unit (tax-inclusive, pre-discount)
                                    const mrpPerUnit = Number(
                                      vetClinic.original_unit_price ||
                                        vetClinic.mrp_price ||
                                        vetClinic.unit_price ||
                                        0,
                                    );

                                    // Discount per unit
                                    const discountPerUnit = Number(vetClinic.discount_amount || 0);

                                    // Tax per unit
                                    const taxPerUnit = Number(
                                      vetClinic.gst || vetClinic.tax_amount || 0,
                                    );

                                    // Totals (× qty)
                                    const mrpTotal = mrpPerUnit * qty;
                                    const discountTotal = discountPerUnit * qty;
                                    const taxTotal = taxPerUnit * qty;
                                    const grandTotal = (mrpPerUnit - discountPerUnit) * qty;

                                    return (
                                      <div
                                        key={`vet-wrap-${index}`}
                                        className="overflow-hidden rounded-lg border border-gray-200 shadow-sm bg-white"
                                      >
                                        {/* ===== Header ===== */}
                                        <div className="flex flex-wrap items-center justify-between gap-3 px-3 py-2 bg-red-50 border-b border-red-100">
                                          <div className="flex items-center gap-2 min-w-0 flex-wrap">
                                            <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-700 shrink-0">
                                              <MdSpa className="w-3 h-3" /> Vet Clinic
                                            </span>
                                          </div>
                                          <div className="flex items-center gap-2 shrink-0">
                                            <button
                                              onClick={() =>
                                                handleOpenProductsDrawer(vetClinic, index, "vetClinicList")
                                              }
                                              className="inline-flex items-center gap-1 px-2 py-1 rounded-md bg-teal-600 text-white text-xs font-medium hover:bg-teal-700 transition"
                                            >
                                              <FaPlus className="w-2.5 h-2.5" /> Product
                                            </button>
                                            <button
                                              onClick={() =>
                                                handleOpenAddonsDrawer(vetClinic, index, "vetClinicList")
                                              }
                                              className="inline-flex items-center gap-1 px-2 py-1 rounded-md bg-green-600 text-white text-xs font-medium hover:bg-green-700 transition"
                                            >
                                              <FaPlus className="w-2.5 h-2.5" /> Add-on
                                            </button>
                                            <button
                                              onClick={() =>
                                                handleOpenOtherChargesDrawer(vetClinic, index, "vetClinicList")
                                              }
                                              className="inline-flex items-center gap-1 px-2 py-1 rounded-md bg-purple-600 text-white text-xs font-medium hover:bg-purple-700 transition"
                                            >
                                              <FaPlus className="w-2.5 h-2.5" /> Other Charge
                                            </button>
                                            <span className="w-px h-5 bg-red-200 mx-1" />
                                            <button
                                              onClick={() => handleEditVetClinicFromList(vetClinic, index)}
                                              className="w-6 h-6 rounded-full bg-white hover:bg-gray-100 flex items-center justify-center"
                                              title="Edit"
                                            >
                                              <FiEdit3 className="w-3 h-3 text-gray-600" />
                                            </button>
                                            <button
                                              onClick={() => handleDeleteVetClinicFromList(index)}
                                              className="w-6 h-6 rounded-full bg-white hover:bg-red-100 flex items-center justify-center"
                                              title="Delete"
                                            >
                                              <FiTrash2 className="w-3 h-3 text-gray-600" />
                                            </button>
                                          </div>
                                        </div>

                                        {/* ===== Table ===== */}
                                        <table className="min-w-full text-sm">
                                          <thead className="bg-gray-50 text-gray-600 uppercase text-xs tracking-wider">
                                            <tr>
                                              <th className="px-3 py-2 text-left min-w-[280px]">Line</th>
                                              <th className="px-3 py-2 text-center w-12">Qty</th>
                                              <th className="px-3 py-2 text-right">MRP (incl. tax)/Unit</th>
                                              <th className="px-3 py-2 text-right">Discount</th>
                                              <th className="px-3 py-2 text-right">Tax</th>
                                              <th className="px-3 py-2 text-right">Total</th>
                                              <th className="px-3 py-2 text-right w-10"></th>
                                            </tr>
                                          </thead>
                                          <tbody className="divide-y divide-gray-100">
                                            {/* Main vet row */}
                                            <tr>
                                              <td className="px-3 py-2 align-top">
                                                <div className="flex flex-col gap-0.5">
                                                  {/* Row 1: Service name */}
                                                  <span className="font-semibold text-gray-800 leading-tight">
                                                    {vetClinic.service_name || "Vet Service"}
                                                  </span>

                                                  {/* Row 2: Pet + Vet inline */}
                                                  <div className="flex items-center gap-2 flex-wrap leading-tight">
                                                    <span className="text-gray-500 inline-flex items-center gap-1">
                                                      <FaDog className="w-3 h-3 text-orange-500" />
                                                      {vetClinic.pet_name || "-"}
                                                      {vetClinic.pet_breed ? ` (${vetClinic.pet_breed})` : ""}
                                                    </span>
                                                    <span className="text-gray-300">•</span>
                                                    {vetClinic.veterinarian_name || vetClinic.employee_name ? (
                                                      <span className="text-gray-600 inline-flex items-center gap-1">
                                                        <FaUserTie className="w-3 h-3 text-purple-500" />
                                                        {vetClinic.veterinarian_name || vetClinic.employee_name}
                                                      </span>
                                                    ) : (
                                                      <span className="text-red-500 italic inline-flex items-center gap-1">
                                                        <FaUserTie className="w-3 h-3 text-red-400" />
                                                        Veterinarian not assigned
                                                      </span>
                                                    )}
                                                  </div>

                                                  {/* Row 3: Date + Time + Duration */}
                                                  {vetClinic.appointment_date || vetClinic.start_date ? (
                                                    <span className="text-gray-600 inline-flex items-center gap-1 leading-tight">
                                                      <FaCalendar className="w-3 h-3 text-blue-500" />
                                                      {safeFormatDate(
                                                        vetClinic.appointment_date || vetClinic.start_date,
                                                      )?.toLocaleDateString("en-IN", {
                                                        day: "2-digit",
                                                        month: "short",
                                                        year: "numeric",
                                                      })}
                                                      {vetClinic.appointment_time || vetClinic.start_time
                                                        ? ` • ${vetClinic.appointment_time || vetClinic.start_time}`
                                                        : ""}
                                                      {vetClinic.duration ? ` • ${vetClinic.duration} min` : ""}
                                                    </span>
                                                  ) : (
                                                    <span className="text-red-500 italic inline-flex items-center gap-1 leading-tight">
                                                      <FaCalendar className="w-3 h-3 text-red-400" />
                                                      Date not selected
                                                    </span>
                                                  )}
                                                </div>
                                              </td>
                                              <td className="px-2 py-2 text-center align-top text-sm">{qty}</td>
                                              <td className="px-3 py-2 text-right whitespace-nowrap align-top">
                                                ₹{mrpTotal.toFixed(2)}
                                              </td>
                                              <td className="px-3 py-2 text-right whitespace-nowrap text-red-600 align-top">
                                                {discountTotal > 0 ? `− ₹${discountTotal.toFixed(2)}` : "—"}
                                              </td>
                                              <td className="px-3 py-2 text-right whitespace-nowrap text-gray-600 align-top">
                                                ₹{taxTotal.toFixed(2)}
                                              </td>
                                              <td className="px-3 py-2 text-right whitespace-nowrap text-green-700 font-semibold align-top">
                                                ₹{grandTotal.toFixed(2)}
                                              </td>
                                              <td className="px-3 py-2 align-top"></td>
                                            </tr>

                                            {/* Add-ons */}
                                            {vetClinic.addons?.map((addon, aIdx) => {
                                              const amt = Number(addon.addon_price || addon.price || 0);
                                              return (
                                                <tr
                                                  key={`vet-${index}-addon-${aIdx}`}
                                                  className="bg-green-50/40"
                                                >
                                                  <td className="px-3 py-1.5 pl-6">
                                                    <span className="inline-flex items-center gap-1">
                                                      <FiCheck className="w-3 h-3 text-green-600" />
                                                      <span className="text-green-700 text-[10px] font-semibold uppercase mr-1">
                                                        Add-on
                                                      </span>
                                                      {addon.addon_name || addon.name || `Add-on ${aIdx + 1}`}
                                                    </span>
                                                  </td>
                                                  <td className="px-2 py-1.5 text-center text-[12px]">1</td>
                                                  <td className="px-3 py-1.5 text-right">₹{amt.toFixed(2)}</td>
                                                  <td className="px-3 py-1.5 text-right text-red-600">—</td>
                                                  <td className="px-3 py-1.5 text-right text-gray-600">—</td>
                                                  <td className="px-3 py-1.5 text-right text-green-700 font-semibold">
                                                    ₹{amt.toFixed(2)}
                                                  </td>
                                                  <td className="px-3 py-1.5 text-right">
                                                    <button
                                                      onClick={() =>
                                                        handleDeleteAddon("vetClinicList", index, aIdx)
                                                      }
                                                      className="text-red-500 hover:text-red-700"
                                                      title="Remove add-on"
                                                    >
                                                      <FiTrash2 className="w-3 h-3" />
                                                    </button>
                                                  </td>
                                                </tr>
                                              );
                                            })}

                                            {/* Products */}
                                            {vetClinic.products?.map((product, pIdx) => {
                                              const qtyP = Number(product.quantity || 1);
                                              const mrpP = Number(
                                                product.mrp_price || product.unit_price || 0,
                                              );
                                              const discP = Number(Number(product.amount_before_discount || 0) - Number(product.amount_after_discount || 0));
                                              const taxP = Number(product.gst || product.gstAmount || 0);
                                              const mrpT = mrpP * qtyP;
                                              const discT = discP * qtyP;
                                              const taxT = taxP * qtyP;
                                              const totalP = Number(product?.effective_sale_price || mrpP) * qtyP;
                                              return (
                                                <tr
                                                  key={`vet-${index}-prod-${pIdx}`}
                                                  className="bg-blue-50/40"
                                                >
                                                  <td className="px-3 py-1.5 pl-6">
                                                    <span className="inline-flex items-center gap-1">
                                                      <MdShoppingCart className="w-3 h-3 text-blue-600" />
                                                      <span className="text-blue-700 text-[10px] font-semibold uppercase mr-1">
                                                        Product
                                                      </span>
                                                      {product.product_name || product.name}
                                                      {product.gst_slab > 0 && (
                                                        <span className="italic text-[10px] text-gray-500">
                                                          (gst {product.gst_slab}%)
                                                        </span>
                                                      )}
                                                    </span>
                                                  </td>
                                                  <td className="px-3 py-1.5 text-center">
                                                    <div className="inline-flex items-center gap-1">
                                                      {qtyP > 1 ? (
                                                        <button
                                                          onClick={() =>
                                                            handleDecrementProduct(
                                                              "vetClinicList",
                                                              index,
                                                              pIdx,
                                                            )
                                                          }
                                                          className="text-gray-600 hover:text-black"
                                                        >
                                                          <FiMinus className="w-3 h-3" />
                                                        </button>
                                                      ) : (
                                                        <button
                                                          onClick={() =>
                                                            handleDeleteProduct(
                                                              "vetClinicList",
                                                              index,
                                                              pIdx,
                                                            )
                                                          }
                                                          className="text-gray-600 hover:text-red-600"
                                                        >
                                                          <FiTrash2 className="w-3 h-3" />
                                                        </button>
                                                      )}
                                                      <span className="w-5 text-center">{qtyP}</span>
                                                      <button
                                                        onClick={() =>
                                                          handleIncrementProduct(
                                                            "vetClinicList",
                                                            index,
                                                            pIdx,
                                                          )
                                                        }
                                                        className="text-gray-600 hover:text-black"
                                                      >
                                                        <FiPlus className="w-3 h-3" />
                                                      </button>
                                                    </div>
                                                  </td>
                                                  <td className="px-3 py-1.5 text-right">₹{mrpP.toFixed(2)}</td>
                                                  <td className="px-3 py-1.5 text-right text-red-600">
                                                    {discT > 0 ? `− ₹${discT.toFixed(2)}` : "—"}
                                                  </td>
                                                  <td className="px-3 py-1.5 text-right text-gray-600">
                                                    ₹{taxT.toFixed(2)}
                                                  </td>
                                                  <td className="px-3 py-1.5 text-right text-green-700 font-semibold">
                                                    ₹{totalP.toFixed(2)}
                                                  </td>
                                                  <td className="px-3 py-1.5 text-right">
                                                    <button
                                                      onClick={() =>
                                                        handleDeleteProduct(
                                                          "vetClinicList",
                                                          index,
                                                          pIdx,
                                                        )
                                                      }
                                                      className="text-gray-600 hover:text-red-600"
                                                      title="Remove product"
                                                    >
                                                      <FiTrash2 className="w-3 h-3" />
                                                    </button>
                                                  </td>
                                                </tr>
                                              );
                                            })}

                                            {/* Other charges */}
                                            {vetClinic.otherCharges?.map((charge, cIdx) => {
                                              const amt = Number(charge.amount || 0);
                                              return (
                                                <tr
                                                  key={`vet-${index}-charge-${cIdx}`}
                                                  className="bg-purple-50/40"
                                                >
                                                  <td className="px-3 py-1.5 pl-6">
                                                    <span className="inline-flex items-center gap-1">
                                                      <FiAlertCircle className="w-3 h-3 text-purple-600" />
                                                      <span className="text-purple-700 text-[10px] font-semibold uppercase mr-1">
                                                        Other Charge
                                                      </span>
                                                      {charge.description || charge.name}
                                                    </span>
                                                  </td>
                                                  <td className="px-2 py-1.5 text-center text-[12px]">1</td>
                                                  <td className="px-3 py-1.5 text-right">₹{amt.toFixed(2)}</td>
                                                  <td className="px-3 py-1.5 text-right text-red-600">—</td>
                                                  <td className="px-3 py-1.5 text-right text-gray-600">—</td>
                                                  <td className="px-3 py-1.5 text-right text-green-700 font-semibold">
                                                    ₹{amt.toFixed(2)}
                                                  </td>
                                                  <td className="px-3 py-1.5 text-right">
                                                    <button
                                                      onClick={() =>
                                                        handleDeleteOtherCharge(
                                                          "vetClinicList",
                                                          index,
                                                          cIdx,
                                                        )
                                                      }
                                                      className="text-red-500 hover:text-red-700"
                                                      title="Remove Other Charge"
                                                    >
                                                      <FiTrash2 className="w-3 h-3" />
                                                    </button>
                                                  </td>
                                                </tr>
                                              );
                                            })}
                                          </tbody>
                                        </table>
                                      </div>
                                    );
                                  })}

                                  {/* PART 4 will open here — outer wrapper still open */}
                                  {/* ---------- PART 4: STANDALONE PRODUCTS ---------- */}
                                  {productList?.length > 0 && (
                                    <div className="overflow-hidden rounded-lg border border-gray-200 shadow-sm bg-white">
                                      {/* ===== Header ===== */}
                                      <div className="flex flex-wrap items-center justify-between gap-3 px-3 py-2 bg-blue-50 border-b border-blue-100">
                                        <div className="flex items-center gap-2 min-w-0 flex-wrap">
                                          <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-700 shrink-0">
                                            <MdShoppingCart className="w-3 h-3" /> Products
                                          </span>
                                          <span className="font-semibold text-gray-800">
                                            Standalone Products
                                          </span>
                                          <span className="text-xs text-gray-500 shrink-0">
                                            • {productList.length} item
                                            {productList.length > 1 ? "s" : ""}
                                          </span>
                                        </div>
                                      </div>

                                      {/* ===== Table ===== */}
                                      <table className="min-w-full text-sm">
                                        <thead className="bg-gray-50 text-gray-600 uppercase text-xs tracking-wider">
                                          <tr>
                                            <th className="px-3 py-2 text-left min-w-[280px]">Line</th>
                                            <th className="px-3 py-2 text-center w-24">Qty</th>
                                            <th className="px-3 py-2 text-right">MRP (incl. tax)/Unit</th>
                                            <th className="px-3 py-2 text-right">Discount</th>
                                            <th className="px-3 py-2 text-right">Tax</th>
                                            <th className="px-3 py-2 text-right">Total</th>
                                            <th className="px-3 py-2 text-right w-10"></th>
                                          </tr>
                                        </thead>
                                        <tbody className="divide-y divide-gray-100">
                                          {productList.map((product, idx) => {
                                            if (!product) return null;
                                            const qty = Number(product.quantity || 1);

                                            // MRP per unit (tax-inclusive, pre-discount)
                                            const mrpPerUnit = Number(
                                              product.mrp_price || product.unit_price || 0,
                                            );

                                            // Discount per unit
                                            const discountPerUnit = Number(product.discount_amount || 0);

                                            // Tax per unit
                                            const taxPerUnit = Number(
                                              product.gstAmount || product.gst || 0,
                                            );

                                            // Totals (× qty)
                                            const mrpTotal = mrpPerUnit * qty;
                                            const discountTotal = discountPerUnit * qty;
                                            const taxTotal = taxPerUnit * qty;
                                            const grandTotal = (mrpPerUnit - discountPerUnit) * qty;

                                            return (
                                              <tr key={product.service_id || `prod-${idx}`}>
                                                <td className="px-3 py-2">
                                                  <div className="font-medium text-gray-800">
                                                    {product.name || product.product_name || "Unnamed"}
                                                  </div>
                                                  <div className="text-xs text-gray-500">
                                                    SKU: {product.sku_number || "—"}
                                                    {product.gst_slab > 0 && (
                                                      <span className="italic ml-2">
                                                        (gst {product.gst_slab}%)
                                                      </span>
                                                    )}
                                                  </div>
                                                </td>
                                                <td className="px-3 py-2 text-center">
                                                  <div className="inline-flex items-center gap-1">
                                                    <button
                                                      onClick={() => handleProductQuantityChange(idx, -1)}
                                                      className="w-6 h-6 flex items-center justify-center rounded border hover:bg-red-100"
                                                      title="Decrease"
                                                    >
                                                      <FiMinus className="w-3 h-3" />
                                                    </button>
                                                    <input
                                                      type="number"
                                                      min="1"
                                                      value={product.quantity || 1}
                                                      onChange={(e) =>
                                                        handleProductQuantityInput(
                                                          idx,
                                                          e.target.value,
                                                          product,
                                                        )
                                                      }
                                                      className="w-12 text-center border rounded p-0.5"
                                                    />
                                                    <button
                                                      onClick={() => handleProductQuantityChange(idx, +1)}
                                                      className="w-6 h-6 flex items-center justify-center rounded border hover:bg-green-100"
                                                      title="Increase"
                                                    >
                                                      <FiPlus className="w-3 h-3" />
                                                    </button>
                                                  </div>
                                                </td>
                                                <td className="px-3 py-2 text-right whitespace-nowrap">
                                                  ₹{mrpTotal.toFixed(2)}
                                                </td>
                                                <td className="px-3 py-2 text-right whitespace-nowrap text-red-600">
                                                  {discountTotal > 0
                                                    ? `− ₹${discountTotal.toFixed(2)}`
                                                    : "—"}
                                                </td>
                                                <td className="px-3 py-2 text-right whitespace-nowrap text-gray-600">
                                                  ₹{taxTotal.toFixed(2)}
                                                </td>
                                                <td className="px-3 py-2 text-right whitespace-nowrap text-green-700 font-semibold">
                                                  ₹{grandTotal.toFixed(2)}
                                                </td>
                                                <td className="px-3 py-2 text-right">
                                                  <button
                                                    onClick={() =>
                                                      setProductList((prev) =>
                                                        prev.filter((_, i) => i !== idx),
                                                      )
                                                    }
                                                    className="text-gray-600 hover:text-red-600"
                                                    title="Remove product"
                                                  >
                                                    <FiTrash2 className="w-3 h-3" />
                                                  </button>
                                                </td>
                                              </tr>
                                            );
                                          })}
                                        </tbody>
                                      </table>
                                    </div>
                                  )}
                                </div>
                              )}
                              {/* ================== END PER-SERVICE TABLE VIEW ================== */}

                              {/* Add/Edit Pets & Services Button */}
                              <div className="my-6">
                                <button
                                  onClick={handleAddPetsAndServices}
                                  disabled={clientData?.isActive === false}
                                  className={`w-full flex items-center justify-between p-4 border-2 border-dashed rounded-xl transition-all duration-200 group ${
                                    clientData?.isActive === false
                                      ? "border-gray-300 bg-gray-50 cursor-not-allowed opacity-60"
                                      : "border-blue-300 hover:border-blue-500 hover:bg-blue-50"
                                  }`}
                                >
                                  <div className="flex items-center gap-3">
                                    <div className="w-10 h-10 bg-gradient-to-r from-blue-100 to-indigo-100 rounded-full flex items-center justify-center group-hover:from-blue-200 group-hover:to-indigo-200 transition-all duration-200">
                                      <FiPlusCircle className="w-5 h-5 text-blue-600" />
                                    </div>
                                    <span className="font-medium text-gray-700 group-hover:text-blue-700 transition-colors duration-200">
                                      {editMode
                                        ? "Edit Pets & Services"
                                        : "Add Pets & Services"}
                                    </span>
                                  </div>
                                  <FiArrowRightCircle className="w-5 h-5 text-gray-400 group-hover:text-blue-600 transition-colors duration-200" />
                                </button>
                              </div>

                              {/* <Grid item xs={12}>
                                <Typography
                                  variant="subtitle2"
                                  fontWeight="bold"
                                  mb={0.5}
                                  className="flex items-center gap-2"
                                >
                                  <NotesIcon
                                    sx={{ fontSize: 16, color: "#6b7280" }}
                                  />
                                  Order Notes
                                </Typography>
                                <TextField
                                  fullWidth
                                  multiline
                                  rows={3}
                                  size="small"
                                  value={notes}
                                  onChange={(e) => setNotes(e.target.value)}
                                  placeholder="Describe concerns, or reason for the visit..."
                                  sx={{
                                    mb: 1,
                                    "& .MuiOutlinedInput-root": {
                                      borderRadius: "12px",
                                      backgroundColor: "white",
                                      border: "1px solid #e5e7eb",
                                      "&:hover": {
                                        borderColor: "#6b7280",
                                        boxShadow:
                                          "0 4px 12px rgba(107, 114, 128, 0.15)",
                                      },
                                      "&.Mui-focused": {
                                        borderColor: "#6b7280",
                                        boxShadow:
                                          "0 0 0 3px rgba(107, 114, 128, 0.1)",
                                      },
                                    },
                                  }}
                                />
                              </Grid> */}
                              {/* Client Orders Section (Edit Mode) */}
                              {editMode && clientOrders.length > 0 && (
                                <div className="mt-8">
                                  <h4 className="text-base font-semibold text-gray-700 mb-4 flex items-center gap-2">
                                    <MdHistory className="w-5 h-5 text-orange-600" />
                                    Recent Orders
                                  </h4>
                                  <div className="space-y-4">
                                    {clientOrders.map((order) => (
                                      <div
                                        key={order._id}
                                        className="bg-gradient-to-r from-white to-orange-50 rounded-xl border border-orange-100 overflow-hidden shadow-sm"
                                      >
                                        <div className="p-5">
                                          <div className="flex justify-between items-start">
                                            <div className="flex-1">
                                              <div className="flex items-center gap-2 text-sm text-gray-600 mb-3">
                                                <FiTag className="w-4 h-4" />
                                                <span className="font-medium">
                                                  {order.order_number}
                                                </span>
                                                <FiCalendar className="w-4 h-4 ml-2" />
                                                <span>
                                                  {new Date(
                                                    order.createdAt,
                                                  ).toLocaleDateString(
                                                    "en-IN",
                                                    {
                                                      day: "2-digit",
                                                      month: "short",
                                                      year: "numeric",
                                                    },
                                                  )}{" "}
                                                  {new Date(order.createdAt)
                                                    .toLocaleTimeString(
                                                      "en-IN",
                                                      {
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                        hour12: true,
                                                      },
                                                    )
                                                    .toUpperCase()}
                                                </span>
                                              </div>
                                              <div className="grid grid-cols-3 gap-4 text-sm text-gray-600">
                                                <div className="flex items-center gap-2">
                                                  <MdContentCut className="w-4 h-4 text-blue-600" />
                                                  <span>
                                                    Appointments:{" "}
                                                    {order.appointmentCount}
                                                  </span>
                                                </div>
                                                <div className="flex items-center gap-2">
                                                  <MdLocalHotel className="w-4 h-4 text-purple-600" />
                                                  <span>
                                                    Boarding:{" "}
                                                    {order.boardingCount}
                                                  </span>
                                                </div>
                                                <div className="flex items-center gap-2">
                                                  <MdShoppingCart className="w-4 h-4 text-green-600" />
                                                  <span>
                                                    Products:{" "}
                                                    {order.productCount}
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="text-right ml-6">
                                              <div className="flex items-center gap-2 text-sm text-gray-600 mb-2">
                                                <span className="font-semibold">
                                                  ₹{" "}
                                                  {order.total_amount.toFixed(
                                                    2,
                                                  )}
                                                </span>
                                              </div>
                                              <div
                                                className={`inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-medium mb-2 ${
                                                  order.status === "completed"
                                                    ? "bg-green-100 text-green-700"
                                                    : order.status ===
                                                          "draft" ||
                                                        order.status ===
                                                          "in_progress"
                                                      ? "bg-blue-100 text-blue-700"
                                                      : "bg-gray-100 text-gray-700"
                                                }`}
                                              >
                                                <div
                                                  className={`w-2 h-2 rounded-full ${
                                                    order.status === "completed"
                                                      ? "bg-green-500"
                                                      : order.status ===
                                                            "draft" ||
                                                          order.status ===
                                                            "in_progress"
                                                        ? "bg-blue-500"
                                                        : "bg-gray-500"
                                                  }`}
                                                ></div>
                                                {order.status === "completed"
                                                  ? "Completed"
                                                  : order.status === "draft" ||
                                                      order.status ===
                                                        "in_progress"
                                                    ? "In-Progress"
                                                    : order.status}
                                              </div>
                                              <div
                                                className={`text-xs flex items-center gap-1 ${
                                                  order.payment_status ===
                                                  "paid"
                                                    ? "text-green-600"
                                                    : order.payment_status ===
                                                        "unpaid"
                                                      ? "text-orange-600"
                                                      : "text-gray-600"
                                                }`}
                                              >
                                                ₹
                                                {order.payment_status === "paid"
                                                  ? "Full Paid"
                                                  : order.payment_status ===
                                                      "unpaid"
                                                    ? "Pending"
                                                    : order.payment_status}
                                              </div>
                                            </div>
                                          </div>

                                          {/* View Details Link */}
                                          <div className="flex justify-end mt-4 pt-3 border-t border-orange-200">
                                            <button
                                              className="inline-flex items-center gap-2 text-sm text-orange-600 hover:text-orange-800 font-medium transition-colors duration-200"
                                              onClick={() =>
                                                setShowHistoryDrawer(true)
                                              }
                                            >
                                              <MdHistory className="w-4 h-4" />
                                              View Details
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              )}
                              </div>

                              {/* Bottom Area: Compact Enquiries Section */}
                              {displayedEnquiries?.length > 0 && (
                                <div className="mt-auto pt-6">
                                  <div className="rounded-xl border border-purple-100 bg-purple-50/30 p-3 shadow-xs">
                                    <div className="flex items-center justify-between mb-2 pb-1.5 border-b border-purple-100/60">
                                      <div className="flex items-center gap-1.5">
                                        <FiFileText className="w-3.5 h-3.5 text-purple-600" />
                                        <span className="text-xs font-semibold text-gray-700">
                                          Recent Enquiries
                                        </span>
                                        <span className="px-1.5 py-0.5 bg-purple-100 text-purple-700 text-[10px] font-bold rounded-full">
                                          {displayedEnquiries.length}
                                        </span>
                                      </div>
                                      {displayedEnquiries.length > 2 && (
                                        <span className="text-[10px] text-gray-400">
                                          Scroll to see all
                                        </span>
                                      )}
                                    </div>

                                    <div className="space-y-2 max-h-52 overflow-y-auto pr-1">
                                      {displayedEnquiries.map((enquiry, index) => {
                                        const recentItems = enquiry?.items || [];
                                        const firstItem = recentItems[0];
                                        const getCategoryName = (item) => {
                                          const rawCat =
                                            item?.service_type_name ||
                                            item?.service_category_name ||
                                            (item?.type === "product"
                                              ? "Product"
                                              : item?.item_type);

                                          if (!rawCat || typeof rawCat !== "string") return "";
                                          const cleaned = rawCat.trim();
                                          if (
                                            ["service", "services", "service type", "n/a", "none", "-"].includes(
                                              cleaned.toLowerCase(),
                                            )
                                          ) {
                                            return "";
                                          }
                                          return formatName(cleaned.toLowerCase());
                                        };

                                        const previewTitle =
                                          firstItem?.service_name ||
                                          (firstItem?.room_type_name
                                            ? `${firstItem.room_type_name}${firstItem.room_number ? ` - Room ${firstItem.room_number}` : " Room"}`
                                            : null) ||
                                          firstItem?.product_details?.name ||
                                          firstItem?.name ||
                                          firstItem?.service_type_name ||
                                          "Service";
                                        const firstCategory = getCategoryName(firstItem);
                                        const hasCategoryInTitle =
                                          firstCategory &&
                                          (previewTitle.toLowerCase() === firstCategory.toLowerCase() ||
                                            previewTitle
                                              .toLowerCase()
                                              .endsWith(`(${firstCategory.toLowerCase()})`));

                                        const petNames = Array.from(
                                          new Set(
                                            recentItems
                                              .map(
                                                (item) =>
                                                  item?.pet_name ||
                                                  item?.pet?.name ||
                                                  item?.vendor_pet?.name ||
                                                  item?.pet_details?.name,
                                              )
                                              .concat([
                                                enquiry?.pet_name,
                                                enquiry?.vendor_pet?.name,
                                                enquiry?.pet?.name,
                                              ])
                                              .filter(Boolean),
                                          ),
                                        );
                                        const petNameDisplay =
                                          petNames.length > 0
                                            ? petNames.join(", ")
                                            : null;

                                        return (
                                          <div
                                            key={enquiry._id || enquiry.order_number || index}
                                            className="p-2.5 bg-white rounded-lg border border-gray-200 hover:border-purple-300 shadow-xs transition-all"
                                          >
                                            <div className="flex items-center justify-between gap-2 mb-1.5">
                                              <div className="flex items-center gap-1.5 flex-wrap">
                                                <span className="text-xs font-semibold text-indigo-700">
                                                  #{enquiry?.order_number || "ORD"}
                                                </span>
                                                <span className="text-gray-300 text-[10px]">•</span>
                                                <span className="text-[11px] text-gray-500 font-medium">
                                                  {enquiry?.createdAt
                                                    ? new Date(enquiry.createdAt).toLocaleDateString("en-IN", {
                                                        day: "2-digit",
                                                        month: "short",
                                                        year: "numeric",
                                                      })
                                                    : "Recent enquiry"}
                                                </span>
                                                {enquiry?.createdAt && (
                                                  <>
                                                    <span className="text-gray-300 text-[10px]">•</span>
                                                    <span className="text-[11px] text-gray-400">
                                                      {new Date(enquiry.createdAt).toLocaleTimeString("en-IN", {
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                      })}
                                                    </span>
                                                  </>
                                                )}
                                              </div>

                                              <div className="flex items-center gap-1.5 shrink-0">
                                                <button
                                                  onClick={() => handleEditEnquiryDrawer(enquiry)}
                                                  className="px-2.5 py-0.5 text-[10px] font-medium text-white bg-blue-500 rounded-md hover:bg-blue-600 transition"
                                                  title="Edit enquiry"
                                                >
                                                  Edit
                                                </button>
                                              </div>
                                            </div>

                                            <div className="flex items-center gap-2">
                                              <div className="w-6 h-6 rounded-full bg-orange-100 flex items-center justify-center text-orange-600 shrink-0">
                                                <MdPets className="w-3.5 h-3.5" />
                                              </div>

                                              <div className="min-w-0 flex-1">
                                                <div className="flex items-center gap-1.5">
                                                  <h5 className="text-xs font-semibold text-gray-800 truncate">
                                                    {previewTitle}
                                                    {firstCategory && !hasCategoryInTitle && (
                                                      <span className="text-gray-500 font-normal ml-1">
                                                        ({firstCategory})
                                                      </span>
                                                    )}
                                                  </h5>
                                                </div>

                                                <div className="flex items-center gap-1.5 text-[10px] text-gray-500 truncate mt-0.5">
                                                  {petNameDisplay && (
                                                    <>
                                                      <span className="inline-flex items-center gap-1 font-medium text-orange-700">
                                                        <FaPaw className="w-2.5 h-2.5 text-orange-500" />
                                                        {petNameDisplay}
                                                      </span>
                                                      <span className="text-gray-300">•</span>
                                                    </>
                                                  )}
                                                  <span className="shrink-0 text-gray-500">
                                                    {recentItems.length} item{recentItems.length > 1 ? "s" : ""}
                                                  </span>
                                                  {recentItems.length > 1 && (
                                                    <>
                                                      <span className="text-gray-300">•</span>
                                                      <span className="truncate text-gray-400">
                                                        {recentItems
                                                          .slice(1)
                                                          .map((item) => {
                                                            const itemTitle =
                                                              item?.service_name ||
                                                              (item?.room_type_name
                                                                ? `${item.room_type_name}${item.room_number ? ` - Room ${item.room_number}` : " Room"}`
                                                                : null) ||
                                                              item?.product_details?.name ||
                                                              item?.name ||
                                                              item?.service_type_name;
                                                            const itemCat = getCategoryName(item);
                                                            const hasCat =
                                                              itemCat &&
                                                              itemTitle &&
                                                              (itemTitle.toLowerCase() === itemCat.toLowerCase() ||
                                                                itemTitle
                                                                  .toLowerCase()
                                                                  .endsWith(`(${itemCat.toLowerCase()})`));
                                                            return itemCat && !hasCat && itemTitle
                                                              ? `${itemTitle} (${itemCat})`
                                                              : itemTitle;
                                                          })
                                                          .filter(Boolean)
                                                          .join(", ")}
                                                      </span>
                                                    </>
                                                  )}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        );
                                      })}
                                    </div>
                                  </div>
                                </div>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Totals Section */}
                    {(appointmentList?.length > 0 ||
                      boardingList?.length > 0 ||
                      vetClinicList?.length > 0 ||
                      productList?.length > 0) && (
                      <div className="px-3 py-2 bg-white border-t border-gray-200">
                        {/* Define isProductOnlyOrder here */}
                        {(() => {
                          // const isProductOnlyOrder =
                          //   appointmentList?.length === 0 &&
                          //   boardingList?.length === 0 &&
                          //   vetClinicList?.length === 0 &&
                          //   productList?.length > 0;

                          return (
                            <TotalsSummary
                              totals={{
                                // subtotal: isProductOnlyOrder
                                //   ? postDiscountSubtotal
                                //   : parseFloat(totalSummary.subtotal || 0),
                                subtotal: parseFloat(totalSummary.subtotal),
                                netAmount: parseFloat(totalSummary.total) - parseFloat(totalSummary.discountedGST),
                                // gst: isProductOnlyOrder
                                //   ? postDiscountGst
                                //   : parseFloat(totalSummary.gst || 0),
                                // gst: parseFloat(totalSummary.gst || 0),
                                discount: parseFloat(
                                  totalSummary.discount || 0,
                                ),
                                total_discount: parseFloat(totalSummary.discount || 0),
                                // total: isProductOnlyOrder
                                //   ? preDiscountGross -
                                //     parseFloat(totalSummary.discount || 0)
                                //   : parseFloat(totalSummary.total || 0),
                                total: parseFloat(totalSummary.total || 0),
                                // discountedGST: isProductOnlyOrder
                                //   ? postDiscountGst
                                //   : parseFloat(
                                //       totalSummary.discountedGST ||
                                //         totalSummary.gst ||
                                //         0,
                                //     ),
                                discountedGST: parseFloat(
                                      totalSummary.discountedGST ||
                                        totalSummary.gst ||
                                        0,
                                    ),
                                totalItemDiscount: parseFloat(totalSummary?.totalItemDiscount)
                              }}
                              // discount={discount}
                              // setDiscount={setDiscount}
                              orderData={{
                                total_paid_amount: 0,
                                is_pos_order: false,//isProductOnlyOrder,
                                amount_before_discount: preDiscountGross,
                              }}
                              isOrderCancelled={false}
                              isAnyAppointmentCancelled={false}
                              orderId={orderId}
                              onDiscountUpdated={() => {
                                // if (isProductOnlyOrder) {
                                //   fetchLiveCalculation(
                                //     productList,
                                //     discount.type,
                                //     discount.value,
                                //   );
                                // } else {
                                  calculateTotals();
                                // }
                              }}
                              isProductOnlyOrder={false}//isProductOnlyOrder}
                            />
                          );
                        })()}
                      </div>
                    )}

                    {/* Footer with 4 buttons matching the image */}
                    <div className="p-4 border-t border-gray-200 bg-white">
                      {/* ✅ Adjustment Amount + Final Amount */}
                      {(appointmentList?.length > 0 ||
                        boardingList?.length > 0 ||
                        vetClinicList?.length > 0 ||
                        productList?.length > 0) && (
                        <AdjustmentAmountCard
                          adjustmentAmount={adjustmentAmount}
                          adjustmentReason={adjustmentReason}
                          onAdjustmentReasonChange={setAdjustmentReason}
                          onAdjustmentChange={setAdjustmentAmount}
                          orderTotal={parseFloat(totalSummary.total || 0)}
                          maxAmount={parseFloat(totalSummary.total || 0)}
                          className="mb-2"
                        />
                      )}
                      {appointmentList?.length > 0 ||
                      boardingList?.length > 0 ||
                      vetClinicList?.length > 0 ||
                      productList?.length > 0 ? (
                        <div className="flex gap-3">
                          <button
                            onClick={handleClose}
                            className="flex-1 inline-flex items-center justify-center px-4 py-3.5 bg-gray-800 text-white font-medium rounded-lg hover:bg-gray-900 transition-all duration-200 text-sm"
                          >
                            Cancel
                          </button>
                          <button
                            onClick={handleSaveBooking}
                            disabled={saveDisabled}
                            className={`flex-1 inline-flex items-center justify-center px-4 py-3.5 font-medium rounded-lg transition-all duration-200 text-sm gap-2
                            ${
                              saveDisabled
                                ? "bg-blue-300 text-white cursor-not-allowed" // lighter color + no hover
                                : "bg-blue-600 hover:bg-blue-700 text-white"
                            }`}
                          >
                            Save Booking
                          </button>
                          <button
                            onClick={handleSaveAndAddPayment}
                            disabled={saveDisabled}
                            className={`flex-1 inline-flex items-center justify-center px-4 py-3.5 font-medium rounded-lg transition-all duration-200 text-sm gap-2
                            ${
                              saveDisabled
                                ? "bg-purple-300 text-white cursor-not-allowed" // lighter color + no hover
                                : "bg-purple-600 hover:bg-purple-700 text-white"
                            }`}
                          >
                            <MdPayment className="w-4 h-4" />
                            Pay Now
                          </button>
                        </div>
                      ) : (
                        <div className="flex justify-end">
                          <button
                            onClick={handleClose}
                            className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-gray-500 to-gray-600 text-white font-medium rounded-xl hover:from-gray-600 hover:to-gray-700 transition-all duration-200 shadow-md hover:shadow-lg transform hover:scale-105"
                          >
                            <RiCloseCircleFill className="w-4 h-4" />
                            Cancel
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      ) : (
        <PetServiceCategoryDrawer
          isOpen={showPetServiceDrawer}
          onClose={() => {
            if (editMode) {
              handleClose();
            } else {
              handleBackFromServiceDrawer();
            }
            setIsServiceEditMode(false);
          }}
          onUpdate={handleSavedServicesData}
          clientId={clientData?._id}
          clientName={`${clientData.firstname} ${clientData.lastname}`}
          clientNumber={`${clientData.phone}`}
          itemData={{
            ...itemData,
            roomtype_id: itemData?.roomtype_id || itemData?.room_type_id,
            room_type_id: itemData?.roomtype_id || itemData?.room_type_id,
            room_id: itemData?.room_id || itemData?.bedId,
            bedId: itemData?.bedId,
            fromDrag: itemData?.fromDrag || false,
            // ✅ Force service type for boarding
            service_type_name:
              itemData?.service_type_name ||
              (itemData?.roomtype_id
                ? "Boarding"
                : itemData?.service_type_name),
            item_type:
              itemData?.item_type ||
              (itemData?.roomtype_id ? "boarding" : "grooming"),
            // Ensure the pet ID is passed for pre-selection
            vendor_pet_id: preSelectedPetId || itemData?.vendor_pet_id,
            pet_id: preSelectedPetId || itemData?.pet_id,
          }}
          orderId={editMode ? editingAppointment?.order_id || orderId : orderId}
          fromCalendar={true}
          selectedSlotInfo={selectedSlotInfo}
          editMode={drawerEditMode}
          onRefreshData={handleRefreshAppointmentData}
          appointmentStatusRef={appointmentStatusRef}
          autoOpenPetForm={shouldOpenPetForm}
          saleType={saleTypeValue}
          isServiceEditMode={isServiceEditMode}
          isPetDetails={isPetDetails}
          preSelectedPetId={preSelectedPetId}
          existingAppointments={[...appointmentList, ...vetClinicList]}
          checkEmployeeDoubleBooking={checkEmployeeDoubleBooking}
          setSaveEnquiryClicked={setSaveEnquiryClicked}
          drawerWidth={drawerWidth}
        />
      )}
      <OrderPaymentDrawer
        isOpen={paymentOrderId !== null}
        onClose={() => {
          const closingOrderId = paymentOrderId;
          triggerConfirmedNotifications(closingOrderId);
          openBookingDetailsDrawer(closingOrderId);
          setPaymentOrderId(null);
        }}
        orderId={paymentOrderId}
        onPaymentSuccess={handlePaymentSuccess}
      />
      
      {isEditClientOpen &&
        clientData?._id &&
        createPortal(
          <div
            className="fixed inset-0 z-[100] bg-black/50 backdrop-blur-sm flex justify-end"
            onClick={(e) => {
              e.stopPropagation();
              setIsEditClientOpen(false);
            }}
          >
            <div
              className="h-full w-full md:w-[60vw] lg:w-[60vw] xl:w-2/5 bg-white shadow-2xl overflow-y-auto"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="flex items-center gap-3 p-4 border-b bg-gradient-to-r from-blue-50 to-indigo-50 sticky top-0 z-10">
                <button
                  onClick={() => setIsEditClientOpen(false)}
                  className="w-10 h-10 rounded-full hover:bg-white/70 flex items-center justify-center transition"
                >
                  <HiArrowSmLeft className="w-6 h-6 text-gray-700" />
                </button>
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 bg-gradient-to-r from-blue-500 to-indigo-600 rounded-full flex items-center justify-center">
                    <FiUserPlus className="w-4 h-4 text-white" />
                  </div>
                  <h2 className="text-xl font-semibold">Edit Client</h2>
                </div>
              </div>

              <AddNewClientAppointment
                onClose={() => setIsEditClientOpen(false)}
                phone={clientData.phone}
                clientId={clientData._id}
                isOpen={isEditClientOpen}
                onSave={(saved) => {
                  setIsEditClientOpen(false);
                  const phone = saved?.phone || clientData.phone;
                  setSearchPhone(phone);
                  fetchClientByPhone(phone); // reloads client with pets, labels, enquiry stats
                }}
              />
            </div>
          </div>,
          document.body
        )}

      {showEnquiryPaymentSection && (
        <div className="fixed inset-0 z-50 transition-all duration-300 ease-in-out">
          <div className="absolute inset-0 bg-black bg-opacity-40 backdrop-blur-[2px]" />
          <div className="absolute right-0 top-0 h-full w-full lg:w-1/2 bg-white shadow-xl transform transition-transform duration-300 ease-out">
            {/* Payment Header */}
            <div className="flex justify-start items-center p-4 border-b bg-gradient-to-r from-green-50 to-emerald-50 shadow-sm gap-3">
              <button
                onClick={handleBackFromEnquiryPayment}
                className="flex items-center justify-center w-10 h-10 rounded-full hover:bg-white/70 transition-colors duration-200"
              >
                <FiArrowLeft className="w-6 h-6 text-gray-700" />
              </button>
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 bg-gradient-to-r from-green-500 to-emerald-600 rounded-full flex items-center justify-center">
                  <MdPayment className="w-4 h-4 text-white" />
                </div>
                <h2 className="text-xl font-semibold text-gray-800">
                  Payment Details
                </h2>
              </div>
            </div>

            {/* Payment Content */}
            <div className="flex h-[calc(100vh-73px)] flex-col">
              <div className="p-6 space-y-6 overflow-auto bg-gradient-to-b from-gray-50 to-white flex-1">
                {/* Total Amount Display */}
                <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                  <div className="space-y-2">
                    {(() => {
                      const enquiry = selectedEnquiryForPayment;
                      if (!enquiry) return null;

                      // Calculate GST percentage and amount from enquiry items
                      let gstAmount = Number(enquiry.total_gst);

                      // Calculate remaining amount
                      const remainingAmount = calculateRemainingAmount();

                      return (
                        <>
                          <div className="flex justify-between text-sm">
                            <span>Subtotal</span>
                            <span>
                              ₹{" "}
                              {parseFloat(
                                enquiry.amount_before_discount || 0,
                              ).toFixed(2)}
                            </span>
                          </div>
                          <div className="flex justify-between text-sm">
                            <span>Discount</span>
                            <span>
                              ₹{" "}
                              {parseFloat(enquiry.total_discount || 0).toFixed(
                                2,
                              )}
                            </span>
                          </div>
                          <div className="flex justify-between text-sm">
                            <span>GST</span>
                            <span>₹ {gstAmount?.toFixed(2)}</span>
                          </div>
                          {existingPaidAmount > 0 && (
                            <div className="flex justify-between text-sm text-blue-600">
                              <span>Already Paid</span>
                              <span>- ₹ {existingPaidAmount.toFixed(2)}</span>
                            </div>
                          )}
                          <div className="flex justify-between text-lg font-bold border-t border-gray-300 pt-2">
                            <span>Remaining Amount</span>
                            <span>₹ {remainingAmount.toFixed(2)}</span>
                          </div>
                        </>
                      );
                    })()}
                  </div>
                </div>

                {/* Payment Methods Section */}
                <div className="space-y-4">
                  <div className="flex items-center justify-between">
                    <h4 className="text-lg font-semibold text-gray-800">
                      Payment Methods
                    </h4>
                  </div>

                  {/* Single Payment Method */}
                  <div className="space-y-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Payment Type
                      </label>
                      <div className="grid grid-cols-2 gap-2">
                        <button
                          onClick={() =>
                            setPaymentDetails((prev) => ({
                              ...prev,
                              paymentType: "full",
                              amount: calculateRemainingAmount(),
                            }))
                          }
                          className={`p-3 border rounded-lg text-sm font-medium transition-colors ${
                            paymentDetails.paymentType === "full"
                              ? "border-blue-500 bg-blue-50 text-blue-700"
                              : "border-gray-300 hover:border-gray-400"
                          }`}
                        >
                          Full Payment
                        </button>
                        <button
                          onClick={() =>
                            setPaymentDetails((prev) => ({
                              ...prev,
                              paymentType: "partial",
                              amount: "",
                            }))
                          }
                          className={`p-3 border rounded-lg text-sm font-medium transition-colors ${
                            paymentDetails.paymentType === "partial"
                              ? "border-blue-500 bg-blue-50 text-blue-700"
                              : "border-gray-300 hover:border-gray-400"
                          }`}
                        >
                          Partial Payment
                        </button>
                      </div>
                    </div>

                    {paymentDetails.paymentType === "partial" && (
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Amount
                        </label>
                        <input
                          type="number"
                          value={paymentDetails.amount}
                          onChange={(e) => {
                            const inputValue = e.target.value;
                            const remainingAmount = parseFloat(
                              calculateRemainingAmount(),
                            );

                            if (parseFloat(inputValue) > remainingAmount) {
                              toast.error(
                                "Partial payment cannot exceed remaining amount",
                                {
                                  position: "top-center",
                                },
                              );
                              return;
                            }

                            setPaymentDetails((prev) => ({
                              ...prev,
                              amount: inputValue,
                            }));
                          }}
                          placeholder="Enter amount"
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                          max={calculateRemainingAmount()}
                        />
                      </div>
                    )}

                    {paymentDetails.paymentType && (
                      <>
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-2">
                            Payment Method
                          </label>
                          <div className="grid grid-cols-3 gap-2">
                            {["cash", "upi", "credit", "cheque", "bank"].map(
                              (method) => (
                                <button
                                  key={method}
                                  onClick={() =>
                                    setPaymentDetails((prev) => ({
                                      ...prev,
                                      method,
                                    }))
                                  }
                                  className={`p-2 border rounded-lg text-sm font-medium capitalize transition-colors ${
                                    paymentDetails.method === method
                                      ? "border-blue-500 bg-blue-50 text-blue-700"
                                      : "border-gray-300 hover:border-gray-400"
                                  }`}
                                >
                                  {method === "upi" ? "UPI" : method}
                                </button>
                              ),
                            )}
                          </div>
                        </div>

                        {paymentDetails.method &&
                          paymentDetails.method !== "cash" && (
                            <div>
                              <label className="block text-sm font-medium text-gray-700 mb-2">
                                Reference Number
                                {paymentDetails.method === "upi" &&
                                  " (Transaction ID)"}
                                {paymentDetails.method === "credit" &&
                                  " (Transaction ID)"}
                                {paymentDetails.method === "cheque" &&
                                  " (Cheque Number)"}
                                {paymentDetails.method === "bank" &&
                                  " (Transaction ID)"}
                              </label>
                              <input
                                type="text"
                                value={paymentDetails.reference}
                                onChange={(e) =>
                                  setPaymentDetails((prev) => ({
                                    ...prev,
                                    reference: e.target.value,
                                  }))
                                }
                                placeholder={`Enter ${paymentDetails.method} reference`}
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                              />
                            </div>
                          )}

                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-2">
                            Notes (Optional)
                          </label>
                          <textarea
                            value={paymentDetails.notes}
                            onChange={(e) =>
                              setPaymentDetails((prev) => ({
                                ...prev,
                                notes: e.target.value,
                              }))
                            }
                            placeholder="Add payment notes..."
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            rows={2}
                          />
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>

              {/* Payment Footer */}
              <div className="p-4 border-t border-gray-200 bg-white">
                <div className="flex gap-3">
                  <button
                    onClick={handleBackFromEnquiryPayment}
                    className="flex-1 py-3 px-4 bg-gray-600 text-white font-semibold rounded-xl hover:bg-gray-700 transition-colors duration-200 flex items-center justify-center gap-2"
                  >
                    <FiArrowLeft className="w-4 h-4" />
                    Back
                  </button>
                  <button
                    onClick={() => {
                      handleEnquiryPaymentComplete(paymentDetails);
                    }}
                    disabled={!paymentDetails.method || isPaymentLoading}
                    className="flex-1 py-3 px-4 bg-gradient-to-r from-green-600 to-emerald-600 text-white font-semibold rounded-xl hover:from-green-700 hover:to-emerald-700 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                  >
                    {isPaymentLoading ? (
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                    ) : (
                      <FiCheck className="w-4 h-4" />
                    )}
                    Complete Payment
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* <ScheduleDrawer
        isOpen={showBookingDetails}
        onClose={handleCloseScheduleDetails}
        orderId={selectedOrderId}
        mode={`update`}
      /> */}
      {isProductsDrawerOpen && (
        <ProductCatalog
          isOpen={isProductsDrawerOpen}
          onClose={handleCloseProductsDrawer}
          onCartUpdate={handleSaveProducts}
          apiEndpoint="/vendorproduct/getAvailableInventoryProducts"
        />
      )}

      {isOtherChargesDrawerOpen && (
        <OtherChargesDrawer
          isOpen={isOtherChargesDrawerOpen}
          onClose={handleCloseOtherChargesDrawer}
          onSave={handleSaveOtherCharges}
          initialCharges={otherCharges}
          drawerWidth={drawerWidth}
        />
      )}

      {proceedPopupData.isOpen && (
        <BookingOrderPopup
          isOpen={proceedPopupData.isOpen}
          orderId={proceedPopupData.orderId}
          highlightRefId={proceedPopupData.highlightRefId}
          mode={proceedPopupData.isQueue === 1 ? "queue" : "scheduled"}
          onClose={handleProceedPopupClose}
          onSchedule={() => {
            handleProceedPopupClose();
          }}
          onModify={(item) => {
            handleProceedPopupClose();
            if (openBookingDetailsDrawer) {
              openBookingDetailsDrawer(item?.order_id || proceedPopupData.orderId);
            }
          }}
          onCheckIn={(checkInPayload) => {
            handleProceedCheckIn(checkInPayload);
          }}
          refreshData={() => {
            if (window.refreshOrderData) window.refreshOrderData();
            if (window.refreshOrdersList) window.refreshOrdersList();
            if (window.refreshAppointmentData) window.refreshAppointmentData();
            if (window.refreshBookingData) window.refreshBookingData();
            if (window.refreshBoardingData) window.refreshBoardingData();
          }}
        />
      )}

      {checkinDrawerOpen &&
        createPortal(
          <div style={{ position: "relative", zIndex: 99999 }}>
            <OrderCheckinDrawer
              isOpen={checkinDrawerOpen}
              onClose={handleCheckinDrawerClose}
              orderId={
                selectedCheckinPayload?.order_id ||
                savedBookingOrderRef.current?._id
              }
              onCheckin={handlePostCheckin}
            />
          </div>,
          document.body
        )}

      {groomingStartedDrawerOpen &&
        createPortal(
          <div style={{ position: "relative", zIndex: 99999 }}>
            <GroomingStartedDrawer
              open={groomingStartedDrawerOpen}
              booking={selectedStartedBooking}
              appointmentRow={selectedStartedRow}
              onClose={handleCloseStartedDrawer}
              onSave={() => {
                if (window.refreshAppointmentData) window.refreshAppointmentData();
              }}
              onComplete={(orderId) => {
                handleOpenCheckoutDrawer(orderId);
              }}
            />
          </div>,
          document.body
        )}

      {vetStartedDrawerOpen &&
        createPortal(
          <div style={{ position: "relative", zIndex: 99999 }}>
            <VetClinicStartedDrawer
              open={vetStartedDrawerOpen}
              booking={selectedStartedBooking}
              appointmentRow={selectedStartedRow}
              onClose={handleCloseStartedDrawer}
              onSave={() => {
                if (window.refreshAppointmentData) window.refreshAppointmentData();
              }}
              onComplete={(orderId) => {
                handleOpenCheckoutDrawer(orderId);
              }}
            />
          </div>,
          document.body
        )}

      {boardingStartedDrawerOpen &&
        createPortal(
          <div style={{ position: "relative", zIndex: 99999 }}>
            <BoardingStartedDrawer
              open={boardingStartedDrawerOpen}
              booking={selectedStartedBooking}
              appointmentRow={selectedStartedRow}
              onClose={handleCloseStartedDrawer}
              onSave={() => {
                if (window.refreshBoardingData) window.refreshBoardingData();
              }}
              onComplete={(orderId) => {
                handleOpenCheckoutDrawer(orderId);
              }}
            />
          </div>,
          document.body
        )}

      {checkoutDrawerOpen &&
        createPortal(
          <div style={{ position: "relative", zIndex: 99999 }}>
            <OrderCheckoutDrawer
              isOpen={checkoutDrawerOpen}
              orderId={
                checkoutOrderId ||
                savedBookingOrderRef.current?._id
              }
              onClose={handleCheckoutDrawerClose}
            />
          </div>,
          document.body
        )}
    </>
  );
};

export default AddAppointment;
